/* ============================================================
   ManMade Precision Trimmer — PDP JavaScript
   No external dependencies. Vanilla JS only.
   ============================================================ */

'use strict';

/* ----------------------------------------------------------
   1. COUNTDOWN
   ---------------------------------------------------------- */
function initCountdown() {
  document.querySelectorAll('[data-mm-countdown]').forEach(function(el) {
    var total = parseInt(el.dataset.minutes, 10) * 60;
    var remaining = total;
    var seen = true;
    if ('IntersectionObserver' in window) {
      new IntersectionObserver(function(es) { seen = es[es.length - 1].isIntersecting; }).observe(el);
    }

    function pad(n) { return String(n).padStart(2, '0'); }

    function tick() {
      if (!document.hidden && seen) {
        var h = Math.floor(remaining / 3600);
        var m = Math.floor((remaining % 3600) / 60);
        var s = remaining % 60;
        var next = '00 : ' + pad(h) + ' : ' + pad(m) + ' : ' + pad(s);
        if (el.textContent !== next) el.textContent = next;
      }
      remaining = remaining <= 0 ? total : remaining - 1;
    }

    tick();
    setInterval(tick, 1000);
  });
}

/* ----------------------------------------------------------
   3. MINI REVIEWS CAROUSEL
   ---------------------------------------------------------- */
function initMiniReviews() {
  document.querySelectorAll('[data-mm-mini-reviews]').forEach(function(container) {
    var reviews = Array.from(container.querySelectorAll('[data-review]'));
    if (reviews.length < 2) return;

    var idx = 0;

    function show(next) {
      reviews[idx].hidden = true;
      idx = (next + reviews.length) % reviews.length;
      reviews[idx].hidden = false;
    }

    var prevBtn = container.querySelector('[data-mm-mini-review-prev]');
    var nextBtn = container.querySelector('[data-mm-mini-review-next]');
    if (prevBtn) prevBtn.addEventListener('click', function() { show(idx - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { show(idx + 1); });
  });
}

/* ----------------------------------------------------------
   4. FAQ — exclusive one-open-at-a-time
   ---------------------------------------------------------- */
function initFaq() {
  if (window.MMSpring) return; // mm-spring.js animates these and closes siblings itself
  document.querySelectorAll('[data-mm-faq-exclusive]').forEach(function(list) {
    if (list.__mmFaq) return;
    list.__mmFaq = true;
    var allDetails = Array.from(list.querySelectorAll('details'));
    allDetails.forEach(function(detail) {
      detail.addEventListener('toggle', function() {
        if (detail.open) {
          allDetails.forEach(function(other) {
            if (other !== detail && other.open) other.removeAttribute('open');
          });
        }
      });
    });
  });
}
// FAQ sections can arrive after boot (theme editor, deferred sections in theme.liquid).
document.addEventListener('shopify:section:load', initFaq);

/* ----------------------------------------------------------
   5. STICKY ATC
   ---------------------------------------------------------- */
/* Spring show/hide for the sticky bar (mm-spring.js); null → CSS state only */
function stickyAtcMotion(bar) {
  if (!bar || !window.MMSpring) return null;
  return bar.__mmReveal || (bar.__mmReveal = MMSpring.reveal(bar, {
    shown: bar.hasAttribute('data-visible'),
    offset: function() {
      return bar.classList.contains('mm-sticky-atc--pos-top') ? -bar.offsetHeight : bar.offsetHeight;
    }
  }));
}

function setStickyAtcVisible(bar, visible) {
  var motion = stickyAtcMotion(bar);
  if (visible) {
    bar.setAttribute('data-visible', '');
    if (motion) motion.show();
  } else {
    bar.removeAttribute('data-visible');
    if (motion) motion.hide();
  }
}

function initStickyAtc() {
  var stickyBar = document.getElementById('mm-sticky-atc');
  if (!stickyBar) return;

  // Always-on mode (theme setting sticky_trigger = 'always'): the bar is
  // rendered with data-visible from Liquid — no scroll observer needed.
  if (stickyBar.getAttribute('data-mm-trigger') === 'always') {
    stickyBar.setAttribute('data-visible', '');
    stickyBar.setAttribute('aria-hidden', 'false');
    mmSyncWidgetLift();
    return;
  }

  var hero = document.getElementById('mm-hero');
  if (!hero) return;
  // Anchor to the buybox ATC button so the bar appears as soon as the real
  // button is scrolled past; fall back to the whole hero if a template has
  // no atc block.
  var anchor = hero.querySelector('.mm-buybox__atc') || hero;
  // 'offscreen': shown whenever the button is out of view, below the fold on load included. The bottom
  // margin is the bar's own height, so the bar hands over once the real button clears it, not behind it.
  var offscreen = stickyBar.getAttribute('data-mm-trigger') === 'offscreen';
  var under = offscreen && stickyBar.className.indexOf('mm-sticky-atc--pos-top') === -1 ? stickyBar.offsetHeight : 0;

  var observer = new IntersectionObserver(function(entries) {
    entries.forEach(function(entry) {
      // after_atc: only "scrolled past" (anchor above the viewport) shows the bar, so an anchor still
      // below the fold on load keeps it hidden. offscreen: either side of the viewport shows it.
      if (!entry.isIntersecting && (offscreen || entry.boundingClientRect.top < 0)) {
        setStickyAtcVisible(stickyBar, true);
        stickyBar.setAttribute('aria-hidden', 'false');
      } else {
        setStickyAtcVisible(stickyBar, false);
        stickyBar.setAttribute('aria-hidden', 'true');
      }
      mmSyncWidgetLift();
    });
  }, { threshold: 0.05, rootMargin: under ? '0px 0px -' + under + 'px 0px' : '0px' });

  observer.observe(anchor);
}

/* ----------------------------------------------------------
   5a. FLOATING WIDGET LIFT
   The Klaviyo form teaser and the Gorgias chat button are fixed to the
   bottom of the viewport and overlap the sticky ATC bar. While the bar
   is visible AND actually displayed at this viewport (offsetHeight > 0
   — it is display:none on desktop) and bottom-positioned, lift them by
   the bar's height via !important margin-bottom (for fixed elements,
   `bottom` measures to the margin edge, so extra bottom margin raises
   them WITHOUT touching their own transforms — Klaviyo centers its
   teaser with translateX(-50%), so transform must stay theirs).
   Restore the original margin when the bar hides. Both widgets inject
   their DOM late, so a debounced MutationObserver re-applies the lift.
   ---------------------------------------------------------- */
var WIDGET_LIFT_SELECTOR = [
  '#gorgias-chat-container iframe#chat-button',
  '#gorgias-chat-container iframe#chat-campaigns',
  '[id^="kl-teaser"]',
  'div[class*="kl-teaser"]',
  'button[class*="kl-teaser"]',
  '.klaviyo-teaser'
].join(', ');

function mmSyncWidgetLift() {
  try {
    var bar = document.getElementById('mm-sticky-atc');
    var barH = 0;
    if (bar && bar.hasAttribute('data-visible') && bar.offsetHeight > 0 &&
        bar.className.indexOf('mm-sticky-atc--pos-top') === -1) {
      barH = bar.offsetHeight;
    }
    var changed = false;
    var els = document.querySelectorAll(WIDGET_LIFT_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        // Skip nested matches (e.g. a kl-teaser button inside a kl-teaser
        // wrapper) — lifting both would double the offset.
        if (el.parentElement && el.parentElement.closest &&
            el.parentElement.closest(WIDGET_LIFT_SELECTOR)) continue;
        var isGorgias = el.id === 'chat-button' || el.id === 'chat-campaigns';
        if (barH > 0) {
          var wasLifted = el.hasAttribute('data-mm-lifted');
          if (!wasLifted) {
            el.setAttribute('data-mm-lifted', el.style.marginBottom || '');
            if (!isGorgias) {
              // Measured while unlifted: the teaser's natural gap to the
              // viewport bottom. Lifting by (barH - gap) lands its bottom
              // edge flush on the bar's top edge — no see-through strip.
              var gap = Math.max(0, window.innerHeight - el.getBoundingClientRect().bottom);
              el.setAttribute('data-mm-gapbase', Math.round(gap));
            }
          }
          var m;
          if (isGorgias) {
            m = barH + 8; // floating bubble keeps a little air
          } else {
            m = Math.max(0, barH - (parseFloat(el.getAttribute('data-mm-gapbase')) || 0));
            // Closed-loop correction: the initial measurement can catch the
            // teaser mid-animation (its slide-in, or our restore still in
            // flight) and land it overlapping the bar. Once our transition
            // has settled, compare where its bottom edge REALLY is to the
            // bar's top edge and nudge by the difference.
            var ts = parseFloat(el.getAttribute('data-mm-liftts')) || 0;
            if (wasLifted && Date.now() - ts > 350) {
              var cur = parseFloat(el.style.marginBottom) || 0;
              var delta = Math.round(el.getBoundingClientRect().bottom - (window.innerHeight - barH));
              m = Math.abs(delta) > 1 ? Math.max(0, cur + delta) : cur;
            }
          }
          var mStr = m + 'px';
          if (el.style.marginBottom !== mStr) {
            el.style.setProperty('transition', 'margin-bottom .25s ease', 'important');
            el.style.setProperty('margin-bottom', mStr, 'important');
            el.setAttribute('data-mm-liftts', Date.now());
            changed = true;
          }
        } else if (el.hasAttribute('data-mm-lifted')) {
          var prev = el.getAttribute('data-mm-lifted');
          el.removeAttribute('data-mm-lifted');
          el.removeAttribute('data-mm-gapbase');
          el.removeAttribute('data-mm-liftts');
          if (prev) { el.style.setProperty('margin-bottom', prev); }
          else { el.style.removeProperty('margin-bottom'); }
        }
      } catch (e) { /* one bad element must not stop the rest */ }
    }
    // A margin just changed → schedule one settle-pass after the transition
    // so the closed-loop correction always gets its post-animation look.
    if (changed) {
      clearTimeout(mmSyncWidgetLift.__t);
      mmSyncWidgetLift.__t = setTimeout(mmSyncWidgetLift, 400);
    }
  } catch (e) { /* widget lift must never break the page */ }
}

/* ----------------------------------------------------------
   5b. FLOATING WIDGET LAYERING
   Klaviyo and Gorgias pin their UI at the maximum z-index
   (2147483647), so the nav/cart drawers can never out-stack them —
   at equal z the later DOM node (the widgets, appended to body-end)
   wins. Inverse approach: while a drawer is open, demote the widgets
   below the drawer scrim with !important inline z-index and restore
   their original z-index on close. Covers the teaser AND full Klaviyo
   popups (kl-private-reset-css wrappers) plus the Gorgias iframes.
   ---------------------------------------------------------- */
var WIDGET_LAYER_SELECTOR = [
  '#gorgias-chat-container iframe#chat-button',
  '#gorgias-chat-container iframe#chat-campaigns',
  '#gorgias-chat-container iframe#chat-window',
  '[id^="kl-teaser"]',
  'div[class*="kl-teaser"]',
  'button[class*="kl-teaser"]',
  '.klaviyo-teaser',
  'div[class*="kl-private-reset-css"]'
].join(', ');

function mmSyncWidgetLayer() {
  try {
    var navDrawer = document.getElementById('mm-drawer');
    var cartDrawer = document.getElementById('mm-cart');
    var covered = (navDrawer && navDrawer.hasAttribute('data-open')) ||
                  (cartDrawer && cartDrawer.hasAttribute('data-open'));
    var els = document.querySelectorAll(WIDGET_LAYER_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      try {
        if (covered) {
          if (!el.hasAttribute('data-mm-layered')) {
            el.setAttribute('data-mm-layered', el.style.zIndex || '');
          }
          // Below the drawer scrim (60) and drawers (70+), above page chrome.
          el.style.setProperty('z-index', '49', 'important');
        } else if (el.hasAttribute('data-mm-layered')) {
          var prev = el.getAttribute('data-mm-layered');
          el.removeAttribute('data-mm-layered');
          if (prev) { el.style.setProperty('z-index', prev); }
          else { el.style.removeProperty('z-index'); }
        }
      } catch (e) { /* one bad element must not stop the rest */ }
    }
  } catch (e) { /* layering must never break the page */ }
}

/* ----------------------------------------------------------
   5c. ATC CLEAR ZONE
   Nothing floats over the hero ATC. While a floating widget's box would
   overlap the button (+8px air), fade it out; it returns once the page
   scrolls far enough that there is room below the button, or the button
   leaves view. visibility keeps layout, so rects stay measurable.
   ---------------------------------------------------------- */
function mmSyncAtcClear() {
  try {
    var atc = document.querySelector('#mm-hero .mm-buybox__atc');
    var a = atc && atc.offsetHeight ? atc.getBoundingClientRect() : null;
    var els = document.querySelectorAll(WIDGET_LIFT_SELECTOR);
    for (var i = 0; i < els.length; i++) {
      var el = els[i];
      if (el.parentElement && el.parentElement.closest(WIDGET_LIFT_SELECTOR)) continue;
      var r = el.getBoundingClientRect();
      var hit = a && r.height && r.top < a.bottom + 8 && r.bottom > a.top - 8 &&
                r.left < a.right && r.right > a.left;
      if (hit === el.hasAttribute('data-mm-atcclear')) continue;
      if (hit) {
        el.setAttribute('data-mm-atcclear', '');
        el.style.setProperty('opacity', '0', 'important');
        el.style.setProperty('visibility', 'hidden', 'important');
      } else {
        el.removeAttribute('data-mm-atcclear');
        el.style.removeProperty('opacity');
        el.style.removeProperty('visibility');
      }
    }
  } catch (e) { /* clear zone must never break the page */ }
}

function initWidgetLift() {
  var t;
  var syncAll = function() { mmSyncWidgetLift(); mmSyncWidgetLayer(); mmApplyDiscountLabels(); mmSyncDiscNotes(); mmSyncAtcClear(); };
  var raf = 0;
  window.addEventListener('scroll', function() {
    if (!raf) raf = requestAnimationFrame(function() { raf = 0; mmSyncAtcClear(); });
  }, { passive: true });
  var debounced = function() { clearTimeout(t); t = setTimeout(syncAll, 200); };
  try {
    // App widgets land directly under <body>. Product pages also need the buy box (Kaching renders the
    // deal bars these passes read there), the cart UI, and the inside of each widget (Klaviyo fills its
    // teaser after appending it, Gorgias puts its iframes inside its container), so each gets its own
    // watch instead of the whole tree re-running on every change any app makes. Sections streamed in by
    // mm-defer-sections land in <main>, which nothing watches here, hence mm:deferred-hydrated.
    var isProduct = location.pathname.indexOf('/products/') > -1;
    var hero = document.getElementById('mm-hero');
    var deep = { childList: true, subtree: true };
    var isWidget = function(n) {
      return n.nodeType === 1 && !n.classList.contains('shopify-section') &&
        !/^(MAIN|SECTION|SCRIPT|STYLE|LINK|TEMPLATE|NOSCRIPT)$/.test(n.nodeName);
    };
    var mo = new MutationObserver(function(records) {
      if (isProduct && hero) records.forEach(function(r) {
        if (r.target === document.body) Array.prototype.filter.call(r.addedNodes, isWidget).forEach(function(n) { mo.observe(n, deep); });
      });
      debounced();
    });
    if (isProduct && hero) {
      mo.observe(document.body, { childList: true });
      [hero, document.getElementById('mm-cart'), document.getElementById('mm-drawer')].forEach(function(n) { if (n) mo.observe(n, deep); });
      Array.prototype.filter.call(document.body.children, isWidget).forEach(function(n) { mo.observe(n, deep); });
      document.addEventListener('mm:deferred-hydrated', debounced);
    } else {
      mo.observe(document.body, { childList: true, subtree: isProduct });
    }
    // The home page's live copy of the PDP hero (sections/home-rvt-hero) holds the same buy box.
    document.addEventListener('mm:rvt-hero-loaded', function(e) {
      if (e.detail && e.detail.root) mo.observe(e.detail.root, { childList: true, subtree: true });
    });
  } catch (e) { /* no observer → IO callback + resize still cover it */ }
  var lastW = window.innerWidth;
  window.addEventListener('resize', function(e) {
    if (e.isTrusted && window.innerWidth === lastW) return; // phone address bar: height only
    lastW = window.innerWidth;
    debounced();
  });
  // Drawer open/close must re-layer instantly, not on the debounce.
  ['mm-drawer', 'mm-cart'].forEach(function(id) {
    var d = document.getElementById(id);
    if (!d) return;
    try {
      new MutationObserver(mmSyncWidgetLayer).observe(d, { attributes: true, attributeFilter: ['data-open'] });
    } catch (e) { /* debounced observers still cover it */ }
  });
  syncAll();
}

/* ----------------------------------------------------------
   5b. STICKY ATC LABEL — Kaching discount pass
   The Liquid snippet substitutes {discountp|discountpr|discount$|discount$r}
   from variant compare-at prices / hero overrides. Kaching Bundles deals
   (specific-price or percentage tiers) apply at cart via a discount
   function and are invisible to Liquid — but the app server-renders its
   deal config as JSON into the page. When the preselected deal bar
   carries a real discount, recompute the label from it here; otherwise
   the server-rendered label (compare-at based, or the fallback) stays.
   ---------------------------------------------------------- */
// Parity with Liquid money_without_trailing_zeros: "$80" / "$80.01"
function mmDiscountMoney(cents) {
  var v = cents / 100;
  return '$' + (cents % 100 === 0 ? v : v.toFixed(2));
}

/* Resolve the SELECTED Kaching Bundles deal bar into cents.
   Returns { save, orig } or null when there is no real Kaching discount.
   Reads the bar's RENDERED price nodes (same contract as snippets/pdp-price),
   not the server-rendered deal-block config JSON: under a Kaching A/B test
   that JSON carries the control deal while the visitor sees and is charged
   the variant's price, so config math drifted from the shown price
   ($120 OFF vs $80 OFF on the 2.0 PDP). The rendered bar is what checkout
   charges. Null until the widget mounts; the body observer re-runs us. */
function mmKachingDeal() {
  try {
    var bar = document.querySelector('.kaching-bundles__bar--selected');
    if (!bar) return null;
    var now = mmCentsFromText(bar.querySelector('.kaching-bundles__bar-price'));
    var was = mmCentsFromText(bar.querySelector('.kaching-bundles__bar-full-price'));
    if (now == null || was == null || now <= 0 || was <= now) return null;
    return { save: was - now, orig: was };
  } catch (e) { return null; }
}

function mmCentsFromText(el) {
  if (!el) return null;
  var f = parseFloat((el.textContent || '').replace(/[^0-9.,]/g, '').replace(/,/g, ''));
  return isNaN(f) ? null : Math.round(f * 100);
}

function mmSubstDiscount(tpl, save, orig) {
  var pct = save * 100 / orig;
  var pct1 = Math.round(pct * 10) / 10;
  var pctInt = Math.round(pct);
  return tpl
    .split('{discount$r}').join(mmDiscountMoney(Math.round(save / 100) * 100))
    .split('{discount$}').join(mmDiscountMoney(save))
    .split('{discountpr}').join(pctInt + '%')
    .split('{discountp}').join((pct1 === pctInt ? pctInt : pct1) + '%');
}

/* Apply the Kaching discount to every label that carries a raw template:
   the sticky ATC bar (data-mm-label-template) and any text rendered
   through snippets/mm-discount-label.liquid (data-mm-discount-text —
   all pdp-button labels flow through it when they contain a token).
   Server-side Liquid already substituted compare-at based values; this
   pass only overwrites when a real Kaching deal exists. Writes are
   equality-guarded so the body MutationObserver never self-triggers. */
function mmApplyDiscountLabels() {
  try {
    var deal = mmKachingDeal();
    if (!deal) return;

    var bar = document.getElementById('mm-sticky-atc');
    if (bar) {
      var tpl = bar.getAttribute('data-mm-label-template');
      var labelEl = bar.querySelector('.mm-btn__label');
      if (tpl && tpl.indexOf('{discount') > -1 && labelEl) {
        var out = mmSubstDiscount(tpl, deal.save, deal.orig);
        if (bar.hasAttribute('data-mm-label-append-price')) out += ' — ' + mmDiscountMoney(deal.orig - deal.save);
        if (labelEl.textContent !== out) labelEl.textContent = out;
      }
    }

    document.querySelectorAll('[data-mm-discount-text]').forEach(function (el) {
      try {
        var raw = el.getAttribute('data-mm-discount-text');
        if (!raw || raw.indexOf('{discount') === -1) return;
        var txt = mmSubstDiscount(raw, deal.save, deal.orig);
        if (el.textContent !== txt) el.textContent = txt;
      } catch (e) { /* one bad label must not stop the rest */ }
    });
  } catch (e) { /* label enhancement must never break the page */ }
}

function initStickyLabelDiscount() {
  mmApplyDiscountLabels();
}

/* "Discount applied" note on product pages (snippets/pdp-discount-applied,
   context product — under the delivery estimate). Shown only while the
   buybox is actually showing a discount:
     · the selected Kaching deal bar has a struck price (mmKachingDeal), or
     · the product form will submit a selling plan — subscribe selected on
       the Kaching subscriptions widget / .mm-sub stack (the plan carries
       the discount) and the widget's one-time card is not selected, or
     · the selected variant has a compare-at markdown (data-mm-dn-variants).
   The cart copy is driven by renderCartSavings instead. Writes are
   equality-guarded so the observers that call this never self-trigger. */
function mmPdpDiscountShown(note) {
  if (mmKachingDeal()) return true;
  var scope = note.closest('.shopify-section') || document;
  var form = scope.querySelector('form[action*="/cart/add"]') || document.querySelector('form[action*="/cart/add"]');
  if (!form) return false;
  var plan = form.querySelector('[name="selling_plan"]');
  var oneTime = document.querySelector('.kaching-subscriptions__card-wrapper.one-time-purchase.selected');
  if (plan && plan.value && !plan.disabled && !oneTime) return true;
  var idEl = form.querySelector('[name="id"]');
  var marked = (note.getAttribute('data-mm-dn-variants') || '').split(',');
  return !!(idEl && idEl.value && marked.indexOf(String(idEl.value)) > -1);
}

function mmSyncDiscNotes() {
  try {
    document.querySelectorAll('[data-mm-disc-note="product"]').forEach(function (n) {
      var hide = !mmPdpDiscountShown(n);
      if (n.hidden !== hide) n.hidden = hide;
    });
  } catch (e) { /* the note must never break the page */ }
}

function initDiscNotes() {
  if (!document.querySelector('[data-mm-disc-note="product"]')) return;
  // Deal-bar / plan / variant switches are class and value changes the
  // body childList observer (initWidgetLift) can miss — re-check after any
  // buybox interaction, once fast and once after the widget re-renders.
  var t1, t2;
  var later = function () {
    clearTimeout(t1); clearTimeout(t2);
    t1 = setTimeout(mmSyncDiscNotes, 60);
    t2 = setTimeout(mmSyncDiscNotes, 450);
  };
  document.addEventListener('click', later, true);
  document.addEventListener('change', later, true);
  mmSyncDiscNotes();
}

/* ----------------------------------------------------------
   6. CART STATE
   ---------------------------------------------------------- */
// /cart.js does not reliably populate `compare_at_price` on line items
// (Markets currency, B2B, and bundle apps like Kaching often strip it).
// We hydrate it ourselves from /products/{handle}.js, keyed by variant id.
var variantComparePriceCache = {};
// One-time variant price, keyed by variant id. Subscription line items compare
// against this (the price you'd pay without the plan) so the cart's savings
// mirror the on-PDP "Subscribe & Protect" offer, not the retail compare-at.
var variantPriceCache = {};
var productFetchInFlight = {};

function hydrateVariantComparePrices(items) {
  var handles = {};
  items.forEach(function(it) {
    if (!it.handle) return;
    if (variantComparePriceCache[it.variant_id] !== undefined) return;
    handles[it.handle] = true;
  });
  var pending = Object.keys(handles).map(function(handle) {
    if (productFetchInFlight[handle]) return productFetchInFlight[handle];
    productFetchInFlight[handle] = fetch('/products/' + handle + '.js')
      .then(function(r) { return r.ok ? r.json() : null; })
      .then(function(p) {
        if (!p) return;
        if (!Array.isArray(p.variants)) return;
        p.variants.forEach(function(v) {
          var cap = (typeof v.compare_at_price === 'number') ? v.compare_at_price : null;
          variantComparePriceCache[v.id] = (cap && cap > v.price) ? cap : null;
          if (typeof v.price === 'number') variantPriceCache[v.id] = v.price;
        });
      })
      .catch(function() {});
    return productFetchInFlight[handle];
  });
  return Promise.all(pending);
}

/* Add-on cards (data-product, see pdp-cart-addon-card) hide while their
   product is already in the cart, any variant. Subscription cards
   (data-selling-plan) ignore Kaching bundle components (the blade that
   ships with a trimmer): the refill offer still applies on top of it.
   Runs from syncAddonsShelf so the frame check below sees the result. */
function syncInCartAddons() {
  var cards = document.querySelectorAll('.mm-cart__addon[data-product]');
  if (!cards.length) return;
  var inCart = {}, inCartOutright = {};
  (CartState.items || []).forEach(function(it) {
    inCart[it.product_id] = true;
    if (!parseKachingBundle(it)) inCartOutright[it.product_id] = true;
  });
  // The rail also skips what the cart already covers through a bundle line,
  // and whatever is on offer inline right now (the pairing, the upgrade's
  // contents), so nothing is pitched twice.
  var skip = mmOfferedOrCovered();
  cards.forEach(function(card) {
    var pid = parseInt(card.dataset.product, 10);
    var hide = !!(card.dataset.sellingPlan ? inCartOutright[pid] : inCart[pid]) || !!skip[pid];
    // A card added from inside the open drawer folds away instead of
    // vanishing in one jump (mmFoldCard).
    if (hide && card.hasAttribute('data-mm-added') && !card.hidden) { mmFoldCard(card); return; }
    // Back on the shelf after its line was removed: slide it open.
    if (!hide && card.hidden && cartDrawerOpen) { mmUnfold(card); return; }
    card.hidden = hide;
  });
}

/* The add-ons shelf never leaves the drawer. The theme card frame shows
   whenever any card inside it is visible — empty cart included (the shelf
   sits under the empty-state CTA and gives the shopper something to add) —
   and only hides when literally nothing is left to show. Also flags the items list
   while the empty message shares it with a live shelf so the message stops
   filling the full height and the shelf lands in view instead of below the
   fold. renderItems calls this; nothing else writes the frame's hidden
   attribute. */
function syncAddonsShelf() {
  mmOfferPlan = mmPlanOffers();
  syncInCartAddons();
  var wrap = document.querySelector('[data-mm-addons]');
  if (wrap) {
    wrap.hidden = !wrap.querySelector('.mm-cart__addon:not([hidden])');
  }
  var container = document.getElementById('mm-cart-items');
  if (!container) return;
  var empty = document.getElementById('mm-cart-empty');
  var isEmpty = !!(empty && !empty.hidden);
  var ownUp = !!(wrap && !wrap.hidden);
  container.classList.toggle('mm-cart__items--empty-shelf', isEmpty && ownUp);
  mmSyncRail();
}

/* Drawer on screen: opened, or pinned open in the theme editor. Work that only
   matters inside the drawer waits for this (openCart calls back in). */
function mmCartVisible() {
  var d = document.getElementById('mm-cart');
  return !!(d && d.hasAttribute('data-open'));
}

/* Rail arrows (mouse users can't swipe): shown only while the row overflows
   (never on the stacked empty-cart list), each end's arrow disabled there.
   Measuring the row lays out the page, so a closed drawer skips it (the
   arrows start hidden). */
function mmSyncRail() {
  if (!mmCartVisible()) return;
  var wrap = document.querySelector('[data-mm-addons]');
  var list = wrap && wrap.querySelector('.mm-cart__addons-list');
  var nav = wrap && wrap.querySelector('[data-mm-rail-nav]');
  if (!list || !nav) return;
  if (!list.__mmRail) {
    list.__mmRail = true;
    list.addEventListener('scroll', function() { requestAnimationFrame(mmSyncRail); }, { passive: true });
    nav.addEventListener('click', function(e) {
      var b = e.target.closest('[data-mm-rail-step]');
      if (!b) return;
      var card = list.querySelector('.mm-cart__addon:not([hidden])');
      var step = card ? card.getBoundingClientRect().width + 10 : list.clientWidth * 0.8;
      list.scrollBy({ left: step * parseInt(b.dataset.mmRailStep, 10), behavior: 'smooth' });
    });
  }
  nav.hidden = !(list.scrollWidth > list.clientWidth + 2);
  var prev = nav.querySelector('[data-mm-rail-step="-1"]');
  var next = nav.querySelector('[data-mm-rail-step="1"]');
  if (prev) prev.disabled = list.scrollLeft <= 2;
  if (next) next.disabled = list.scrollLeft + list.clientWidth >= list.scrollWidth - 2;
}

/* ---- Inline offers ---------------------------------------------------------
   At most ONE bundle upgrade and ONE pairing in the drawer, each drawn inside
   the cart line it relates to (data: [data-mm-offers] in pdp-cart-drawer).
   mmPlanOffers decides from CartState alone (syncAddonsShelf runs it before
   the rows are rebuilt, so the rail can skip what is offered inline);
   mmPaintOffers draws the plan into the rows once renderItems has built them.
   The two never share a line, and a line whose pairing the shopper already
   took gets no new one this session, so adding never sets off another pitch. */
var mmOfferPlan = { up: null, pair: null };
var MM_PAIR_TAKEN = 'mm_pair_taken_v1';

function mmPairTaken() {
  try { return JSON.parse(sessionStorage.getItem(MM_PAIR_TAKEN)) || []; } catch (e) { return []; }
}
function mmNotePairTaken(pid) {
  pid = parseInt(pid, 10);
  if (!pid) return;
  var t = mmPairTaken();
  if (t.indexOf(pid) > -1) return;
  t.push(pid);
  try { sessionStorage.setItem(MM_PAIR_TAKEN, JSON.stringify(t)); } catch (e) { /* storage blocked */ }
}

// Product ids the rail should skip on top of plain in-cart lines: the parts
// of a bundle that is in the cart, and everything offered inline right now.
function mmOfferedOrCovered() {
  var skip = {};
  var store = document.querySelector('[data-mm-offers]');
  if (!store) return skip;
  var inCart = {};
  CartState.items.forEach(function(it) { inCart[it.handle] = true; });
  store.querySelectorAll('[data-mm-bundle]').forEach(function(card) {
    if (!inCart[card.dataset.handle]) return;
    card.querySelectorAll('[data-mm-part]').forEach(function(p) { skip[p.dataset.pid] = true; });
  });
  var up = mmOfferPlan.up;
  if (up) {
    skip[up.card.dataset.pid] = true;
    up.adds.forEach(function(p) { skip[p.dataset.pid] = true; });
  }
  if (mmOfferPlan.pair) skip[mmOfferPlan.pair.el.dataset.pid] = true;
  return skip;
}

function mmPlanOffers() {
  var plan = { up: null, pair: null };
  var store = document.querySelector('[data-mm-offers]');
  if (!store || !CartState.items.length) return plan;
  // Nothing inline until the Kaching deal prices are known, so an upgrade
  // never flashes at full price, and a pairing never shows under the trimmer
  // only to be swapped for the upgrade a moment later.
  if (store.querySelector('[data-mm-bundle]') && !store.dataset.dealsReady) {
    // The deal lookup waits for the drawer to open (openCart starts it).
    if (mmCartVisible()) mmLoadBundleDeals(store);
    return plan;
  }
  plan.up = mmPickUpgrade(store);
  plan.pair = mmPickPair(store, plan.up);
  return plan;
}

function mmLoadBundleDeals(store) {
  if (store.dataset.dealsLoading) return;
  store.dataset.dealsLoading = '1';
  mmKachingDeals().then(function(deals) {
    store.querySelectorAll('[data-mm-bundle]').forEach(function(card) {
      card._mmDeal = mmBundleDeal(deals, card.dataset.pid, parseInt(card.dataset.price, 10) || 0);
    });
    store.dataset.dealsReady = '1';
    syncAddonsShelf();
    mmPaintOffers();
  });
}

function mmPickUpgrade(store) {
  var inCart = {};
  CartState.items.forEach(function(it) { inCart[it.handle] = true; });
  var best = null;
  store.querySelectorAll('[data-mm-bundle]').forEach(function(card) {
    if (inCart[card.dataset.handle]) return;
    var lines = mmBundleLines(card);
    if (!lines.length) return;
    var replaced = lines.reduce(function(sum, it) { return sum + Math.round(mmLineTotal(it) / it.quantity); }, 0);
    var price = card._mmDeal ? card._mmDeal.price : (parseInt(card.dataset.price, 10) || 0);
    var diff = price - replaced;
    // Relevant only when the cart already holds at least as much of the kit
    // as the upgrade costs: trimmer → +$20 yes, a lone $30 bag → +$70 no.
    if (diff > replaced) return;
    if (best && (lines.length < best.lines.length || (lines.length === best.lines.length && diff >= best.diff))) return;
    best = { card: card, lines: lines, diff: diff };
  });
  if (!best) return null;
  // Drawn under the priciest line it replaces: the item being upgraded.
  var anchor = best.lines.reduce(function(a, it) {
    return mmLineTotal(it) / it.quantity > mmLineTotal(a) / a.quantity ? it : a;
  });
  best.anchor = anchor.key;
  var matched = {};
  best.lines.forEach(function(it) { matched[it.handle] = true; });
  // What the shopper gains, most valuable first ("Adds Toiletry Bag & 2 more").
  best.adds = Array.prototype.filter.call(best.card.querySelectorAll('[data-mm-part]'), function(p) {
    return !matched[p.dataset.handle];
  }).sort(function(a, b) {
    return (parseInt(b.dataset.price, 10) || 0) - (parseInt(a.dataset.price, 10) || 0);
  });
  return best;
}

function mmPickPair(store, up) {
  var pairs = store.querySelectorAll('[data-mm-pair]');
  if (!pairs.length) return null;
  var taken = mmPairTaken();
  var have = {};
  CartState.items.forEach(function(it) { have[it.product_id] = true; });
  var bundleParts = {};
  store.querySelectorAll('[data-mm-bundle]').forEach(function(card) {
    var inCart = CartState.items.some(function(it) { return it.handle === card.dataset.handle; });
    if (inCart) card.querySelectorAll('[data-mm-part]').forEach(function(p) { bundleParts[p.dataset.pid] = true; });
  });
  var skipLine = {};
  if (up) {
    up.lines.forEach(function(it) { skipLine[it.key] = true; });
    skipLine[up.anchor] = true;
    up.adds.forEach(function(p) { bundleParts[p.dataset.pid] = true; });
    bundleParts[up.card.dataset.pid] = true;
  }
  // buildCartRows order = the order the shopper sees (newest first).
  var rows = buildCartRows(CartState.items);
  for (var r = 0; r < rows.length; r++) {
    var it = rows[r].item;
    if (skipLine[it.key] || mmLineTotal(it) <= 0) continue;
    if (it.properties && it.properties._protection) continue;
    if (taken.indexOf(it.product_id) > -1) continue;
    for (var i = 0; i < pairs.length; i++) {
      var p = pairs[i];
      if (parseInt(p.dataset.trigger, 10) !== it.product_id) continue;
      var pid = parseInt(p.dataset.pid, 10);
      if (have[pid] || bundleParts[pid]) continue;
      return { el: p, key: it.key, trigger: it.product_id };
    }
  }
  return null;
}

function mmMoneyAttr(cents) { return escapeHtml(formatMoney(cents)); }

function mmUpgradeHtml(store, up) {
  var names = up.adds.map(function(p) { return p.dataset.title; });
  var added = !names.length ? ''
    : names.length === 1 ? names[0]
    : names.length === 2 ? names[0] + ' & ' + names[1]
    : names[0] + ' & ' + (names.length - 1) + ' more';
  var items = up.lines.map(function(it) { return it.product_title; });
  items = items.length > 1 ? items.slice(0, -1).join(', ') + ' & ' + items[items.length - 1] : items[0];
  var note = (store.dataset.upNote || '').replace('[[added]]', added).replace('[[items]]', items);
  var tpl = up.diff < 0 ? store.dataset.upCtaSave : store.dataset.upCta;
  var cta = up.diff === 0 ? 'Upgrade' : tpl.replace('[[amount]]', formatMoney(Math.abs(up.diff)));
  var label = store.dataset.upLabel || '';
  var thumbs = up.adds.slice(0, 3).map(function(p) {
    return p.dataset.image
      ? '<img class="mm-cart__offer-img" src="' + escapeHtml(p.dataset.image) + '" alt="" width="34" height="34" loading="lazy">'
      : '';
  }).join('');
  return '<div class="mm-cart__offer mm-cart__offer--up" data-mm-offer>' +
      (thumbs ? '<span class="mm-cart__offer-imgs" aria-hidden="true">' + thumbs + '</span>' : '') +
      '<span class="mm-cart__offer-meta">' +
        '<span class="mm-cart__offer-label">' + escapeHtml(label) + '</span>' +
        (note ? '<span class="mm-cart__offer-name">' + escapeHtml(note) + '</span>' : '') +
      '</span>' +
      '<button type="button" class="mm-cart__offer-btn" data-mm-action="bundle-upgrade"' +
        ' data-handle="' + escapeHtml(up.card.dataset.handle) + '"' +
        ' aria-label="' + escapeHtml(label + (note ? ': ' + note : '') + ', ' + (up.diff < 0 ? cta : (up.diff ? formatMoney(up.diff) + ' more' : 'same price'))) + '">' +
        escapeHtml(cta) +
      '</button>' +
    '</div>';
}

function mmPairHtml(store, pair) {
  var d = pair.el.dataset;
  var price = parseInt(d.price, 10) || 0;
  var data = ' data-url="' + escapeHtml(d.url || '') + '"' +
    ' data-product="' + d.pid + '"' +
    ' data-variant="' + d.variant + '"' +
    ' data-title="' + escapeHtml(d.title || '') + '"' +
    ' data-price="' + price + '"' +
    ' data-mm-pair-for="' + pair.trigger + '"' +
    (d.compare ? ' data-compare="' + d.compare + '"' : '') +
    (d.image ? ' data-image="' + escapeHtml(d.image) + '"' : '') +
    (d.thumb ? ' data-thumb="' + escapeHtml(d.thumb) + '"' : '');
  return '<div class="mm-cart__offer mm-cart__offer--pair" data-mm-offer data-mm-action="addon-peek"' + data + '>' +
      (d.thumb ? '<img class="mm-cart__offer-img" src="' + escapeHtml(d.thumb) + '" alt="" width="40" height="40" loading="lazy">' : '') +
      '<span class="mm-cart__offer-meta">' +
        '<span class="mm-cart__offer-label">' + escapeHtml(store.dataset.pairLabel || '') + '</span>' +
        '<span class="mm-cart__offer-name">' + escapeHtml(d.title || '') + '</span>' +
      '</span>' +
      '<button type="button" class="mm-cart__offer-btn" data-mm-action="quick-add"' +
        ' data-variant="' + d.variant + '"' +
        ' data-title="' + escapeHtml(d.title || '') + '"' +
        ' data-price="' + price + '"' +
        ' data-mm-pair-for="' + pair.trigger + '"' +
        (d.thumb ? ' data-image="' + escapeHtml(d.thumb) + '"' : '') +
        ' aria-label="' + escapeHtml('Add ' + (d.title || '') + ', ' + formatMoney(price)) + '">' +
        '+' + mmMoneyAttr(price) +
      '</button>' +
    '</div>';
}

function mmPaintOffers() {
  var container = document.getElementById('mm-cart-items');
  if (!container) return;
  container.querySelectorAll('[data-mm-offer]').forEach(function(el) { el.remove(); });
  var store = document.querySelector('[data-mm-offers]');
  if (!store) return;
  var rows = container.querySelectorAll('.mm-cart__item[data-key]');
  function into(key, html) {
    for (var i = 0; i < rows.length; i++) {
      if (rows[i].dataset.key === key) { rows[i].insertAdjacentHTML('beforeend', html); return; }
    }
  }
  if (mmOfferPlan.up) into(mmOfferPlan.up.anchor, mmUpgradeHtml(store, mmOfferPlan.up));
  if (mmOfferPlan.pair) into(mmOfferPlan.pair.key, mmPairHtml(store, mmOfferPlan.pair));
}

/* Bundle upgrade (Cart Drawer → Bundle upgrade). Each bundle card carries its
   product tags in data-parts; a tag naming a product handle (bare, or as a
   /products/<handle> URL) marks that product as inside the bundle. The bundle
   whose parts overlap the cart most is offered; tapping it adds the bundle and
   takes ONE of each matched item out, leaving the rest of the cart alone.
   Subscription lines and $0 lines (bundle freebies, gifts) never match. */
function mmBundlePartHandle(tag) {
  var t = String(tag).trim().toLowerCase();
  var at = t.indexOf('/products/');
  if (at >= 0) t = t.slice(at + 10);
  return t.split(/[?#\/]/)[0];
}

function mmBundleLines(card) {
  var seen = {}, lines = [];
  (card.dataset.parts || '').split('|').map(mmBundlePartHandle).forEach(function(h) {
    if (!h || seen[h]) return;
    seen[h] = true;
    for (var i = 0; i < CartState.items.length; i++) {
      var it = CartState.items[i];
      if (it.handle !== h || it.selling_plan_allocation || mmLineTotal(it) === 0) continue;
      lines.push(it);
      return;
    }
  });
  return lines;
}

/* Kaching discounts a bundle (e.g. $140 → $99.99) only when its cart line
   carries the deal's __kaching_bundles tag — the same JSON its PDP widget
   writes. Deals come from Kaching's deal_blocks metafield, shared with
   manmade-bundle-price.js through the same sessionStorage cache. */
var MM_KB_CACHE = 'mm_kb_deals_v1';
var mmKbDeals = null;

function mmKachingDeals() {
  if (mmKbDeals) return mmKbDeals;
  try {
    var c = JSON.parse(sessionStorage.getItem(MM_KB_CACHE));
    if (c && Date.now() - c.ts < 30 * 60 * 1000 && Array.isArray(c.deals)) return (mmKbDeals = Promise.resolve(c.deals));
  } catch (e) { /* no cache */ }
  var cfg;
  try { cfg = JSON.parse(document.getElementById('kaching-bundles-config').textContent); } catch (e) { cfg = null; }
  if (!cfg || !cfg.shopifyDomain || !cfg.storefrontAccessToken) return Promise.resolve([]);
  mmKbDeals = fetch('https://' + cfg.shopifyDomain + '/api/2026-01/graphql.json', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'X-Shopify-Storefront-Access-Token': cfg.storefrontAccessToken },
    body: JSON.stringify({ query: '{shop{metafield(namespace:"$app:kaching_bundles",key:"deal_blocks"){value}}}' })
  })
    .then(function(r) { return r.ok ? r.json() : null; })
    .then(function(d) {
      var v = d && d.data && d.data.shop && d.data.shop.metafield && d.data.shop.metafield.value;
      var deals = v ? JSON.parse(v) : [];
      if (!Array.isArray(deals)) deals = [];
      try { sessionStorage.setItem(MM_KB_CACHE, JSON.stringify({ ts: Date.now(), deals: deals })); } catch (e) {}
      return deals;
    })
    .catch(function() { mmKbDeals = null; return []; });
  return mmKbDeals;
}

// The single-unit bar of the deal on this bundle product: its price and the
// line property that makes Kaching's discount apply at cart/checkout.
function mmBundleDeal(deals, pid, base) {
  for (var i = 0; i < deals.length; i++) {
    var d = deals[i];
    if (!d || !(d.selectedProductIds || []).some(function(id) { return String(id).split('/').pop() === pid; })) continue;
    var bar = (d.dealBars || []).filter(function(b) {
      return b && b.dealBarType === 'quantity-break' && Number(b.quantity) === 1;
    })[0];
    if (!bar) continue;
    var dv = Number(bar.discountValue) || 0;
    var price = bar.discountType === 'percentage' ? Math.round(base * (1 - dv / 100))
      : bar.discountType === 'amount' ? Math.max(0, base - Math.round(dv * 100))
      : bar.discountType === 'specific' ? Math.round(dv * 100)
      : base;
    return {
      price: price,
      prop: JSON.stringify({ deal: d.nanoId, pp: Number(pid), main: true, v: d.versionId, bid: bar.id, abid: d.abTestVariantId, ab: d.abTestVariantLetter })
    };
  }
  return null;
}

async function bundleUpgrade(btn) {
  var store = document.querySelector('[data-mm-offers]');
  var card = null;
  if (store) store.querySelectorAll('[data-mm-bundle]').forEach(function(c) {
    if (c.dataset.handle === btn.dataset.handle) card = c;
  });
  if (!card || btn.dataset.mmBusy === '1') return;
  var lines = mmBundleLines(card);
  if (!lines.length) return;
  var orig = btn.textContent;
  btn.dataset.mmBusy = '1';
  btn.disabled = true;
  btn.textContent = 'Upgrading…';
  clearCartError();
  var added = null;
  try {
    // Add first: if the bundle can't be added, nothing has left the cart.
    var add = { id: parseInt(card.dataset.variant, 10), quantity: 1 };
    if (card._mmDeal) add.properties = { __kaching_bundles: card._mmDeal.prop };
    var res = await mmTrackAdd(fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(add)
    }));
    if (!res.ok) throw new Error('add failed');
    added = await res.json().catch(function() { return null; });
    var updates = {};
    lines.forEach(function(it) {
      updates[it.key] = it.quantity - 1;
      // A paid Kaching line leaving the cart takes its $0 deal components
      // with it, as removing it by hand would.
      var kb = parseKachingBundle(it);
      if (!kb || !kb.id || it.quantity > 1) return;
      CartState.items.forEach(function(o) {
        var okb = parseKachingBundle(o);
        if (o !== it && okb && okb.id === kb.id && mmLineTotal(o) === 0) updates[o.key] = 0;
      });
    });
    res = await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ updates: updates })
    });
    if (!res.ok) throw new Error('swap failed');
    // update.js answers with the whole cart — paint it, no extra /cart.js trip.
    var cart = await res.json();
    btn.dataset.mmBusy = '';
    btn.disabled = false;
    btn.textContent = orig;
    CartState.apply(cart);
    return;
  } catch (e) {
    // The bundle went in but the items it replaces could not come out: take
    // the bundle back out, so the cart never holds both.
    if (added && added.key) {
      try {
        await fetch('/cart/change.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ id: added.key, quantity: Math.max(0, (added.quantity || 1) - 1) })
        });
      } catch (e2) { /* the refetch below shows whatever the cart holds */ }
    }
    showCartError('Couldn’t upgrade to the bundle — please try again.');
  }
  btn.dataset.mmBusy = '';
  btn.disabled = false;
  btn.textContent = orig;
  CartState.fetch();
}

function getItemComparePrice(item) {
  if (typeof item.compare_at_price === 'number' && item.compare_at_price > item.price) {
    return item.compare_at_price;
  }
  var cached = variantComparePriceCache[item.variant_id];
  return (typeof cached === 'number' && cached > item.price) ? cached : null;
}

/* ---- Stale single-item cart reset -----------------------------------------
   Shopify keeps a cart for ~2 weeks. A shopper who adds ONE trimmer, leaves,
   and comes back a day later adds it again — and checks out with 2×/3× of
   it. So a "simple" cart — at most one paid SKU, plus whatever rides with it
   ($0 Kaching gifts, shipping protection) — is treated as a fresh session
   after 24h without changes: cleared once, at page load, before the drawer
   paints. A cart the shopper has built up (two or more distinct paid SKUs)
   is their work and is kept for Shopify's full lifetime.

   The clock restarts whenever the cart's composition (line keys + qtys)
   changes and is kept in localStorage against the cart token — the same
   device/browser scope as the cart cookie itself; an empty cart drops it.
   The reset only ever runs from the boot path (never from a fetch an add
   triggered), and stands down the moment any add starts on this page, so a
   click can't have its own line wiped out from under it. */
var MM_CART_AGE_KEY = 'mm-cart-started-v1';
var MM_CART_STALE_MS = 24 * 60 * 60 * 1000;

function mmReadCartAge() {
  try { return JSON.parse(localStorage.getItem(MM_CART_AGE_KEY)) || null; } catch (e) { return null; }
}
function mmWriteCartAge(rec) {
  try {
    if (rec) localStorage.setItem(MM_CART_AGE_KEY, JSON.stringify(rec));
    else localStorage.removeItem(MM_CART_AGE_KEY);
  } catch (e) { /* storage blocked — degrades to "never clear" */ }
}
function mmCartSig(items) {
  return (items || []).map(function (it) { return it.key + ':' + it.quantity; }).sort().join('|');
}

/* Distinct paid SKUs in the cart. $0 bundle components and shipping
   protection ride along with a product; they don't make a cart "built up". */
function mmMainSkuCount(items) {
  var seen = Object.create(null);
  var n = 0;
  (items || []).forEach(function (it) {
    if (mmLineTotal(it) <= 0) return;
    if (it.properties && it.properties._protection) return;
    if (seen[it.variant_id]) return;
    seen[it.variant_id] = true;
    n++;
  });
  return n;
}

/* Runs on every /cart.js payload: (re)start the clock when the cart's
   contents differ from what we last saw; drop it when the cart empties. */
function mmNoteCartAge(data) {
  var items = (data && data.items) || [];
  if (!items.length) { mmWriteCartAge(null); return; }
  var token = (data && data.token) || '';
  var sig = mmCartSig(items);
  var rec = mmReadCartAge();
  if (rec && rec.token === token && rec.sig === sig && typeof rec.at === 'number') return;
  mmWriteCartAge({ token: token, sig: sig, at: Date.now() });
}

/* Boot-only: clear a simple cart that hasn't changed in 24h. A pure
   localStorage check unless the cart really is stale; resolves either way
   so the normal first paint follows, and never throws. */
function mmResetStaleCart(seed) {
  if (window.Shopify && Shopify.designMode) return Promise.resolve();
  if (mmAddEverStarted || mmAddInFlight || CartState.items.length) return Promise.resolve();
  var rec = mmReadCartAge();
  if (!rec || typeof rec.at !== 'number' || Date.now() - rec.at < MM_CART_STALE_MS) return Promise.resolve();
  // The page's own cart (seed) answers this without a round trip.
  var source = seed
    ? Promise.resolve(seed)
    : fetch('/cart.js').then(function (res) { return res.ok ? res.json() : null; });
  return source
    .then(function (data) {
      if (!data || !data.items || !data.items.length) { mmWriteCartAge(null); return; }
      // Changed since we last saw it (another tab, server-side) — clock restarts.
      if (data.token !== rec.token || mmCartSig(data.items) !== rec.sig) { mmNoteCartAge(data); return; }
      if (mmMainSkuCount(data.items) > 1) return; // built-up cart — keep it
      if (mmAddEverStarted) return; // a click landed while we were checking
      return fetch('/cart/clear.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' }
      }).then(function (res) {
        if (!res.ok) return;
        mmWriteCartAge(null);
        // The full cart page is server-rendered; make it reflect the reset.
        if (document.querySelector('[data-mm-cart-list]')) window.location.reload();
      });
    })
    .catch(function () { /* offline — leave the cart alone */ });
}

var CartState = {
  items: [],
  subtotal: 0,
  at: 0, // when the drawer's copy of the cart was last synced

  async fetch() {
    try {
      var res = await fetch('/cart.js');
      if (!res.ok) return;
      this.apply(await res.json());
    } catch (e) {
      /* silent */
    }
  },

  // Paint a cart payload — from /cart.js, or the server-rendered seed
  // (#mm-cart-seed, same shape: Liquid `cart | json`) so the badge and
  // drawer are right on first paint without a boot round trip.
  apply(data) {
    try {
      this.at = Date.now();
      this.items = data.items || [];
      this.subtotal = data.total_price || 0;
      mmNoteCartAge(data);
      this.updateBadge();
      var flip = mmShelfFlipStart();
      this.renderItems();
      this.updateShippingBar();
      this.updateGiftBar();
      mmShelfFlipEnd(flip);
      // Notify any listeners (sticky ATC, external apps, analytics).
      document.dispatchEvent(new CustomEvent('mm:cart:updated', { detail: data }));
      // Hydrate compare-at prices in the background, then re-render so
      // the savings strikethrough / "Save $X" badge appears once the
      // variant data arrives. First render is unblocked.
      var self = this;
      hydrateVariantComparePrices(this.items).then(function() {
        var flip2 = mmShelfFlipStart();
        self.renderItems();
        mmShelfFlipEnd(flip2);
      });
    } catch (e) {
      /* silent */
    }
  },

  // An empty cart shows no progress rows — "You're $25 away" with nothing in
  // the cart reads as noise. Editor-pinned drawers keep them up so the rows
  // stay styleable against the editor's usually-empty preview cart.
  emptyAndNotPinned() {
    if (this.items.length > 0) return false;
    var drawerEl = document.getElementById('mm-cart');
    return !(drawerEl && drawerEl.hasAttribute('data-editor-pinned'));
  },

  updateShippingBar() {
    var bar = document.getElementById('mm-cart-ship');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (!threshold || this.emptyAndNotPinned()) { bar.hidden = true; return; }
    var remaining = Math.max(0, threshold - this.subtotal);
    var pct = Math.min(100, (this.subtotal / threshold) * 100);
    var fill = bar.querySelector('[data-mm-ship-fill]');
    var msg  = bar.querySelector('[data-mm-ship-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      // Templates are merchant-defined in PDP Header settings.
      // {amount} is replaced with the formatted remaining $.
      var tplProgress = bar.dataset.textProgress || 'You’re {amount} away from free shipping';
      var tplUnlocked = bar.dataset.textUnlocked || '🎉 You unlocked <strong>free shipping</strong>!';
      var amount = '<strong>' + formatMoney(remaining) + '</strong>';
      msg.innerHTML = remaining === 0
        ? tplUnlocked
        : tplProgress.replace(/\{amount\}/g, amount);
    }
    if (remaining === 0) bar.setAttribute('data-unlocked', '');
    else bar.removeAttribute('data-unlocked');
    bar.hidden = false;
  },

  updateGiftBar() {
    var bar = document.getElementById('mm-cart-gift');
    if (!bar) return;
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    var label = bar.dataset.label || 'free gift';
    if (!threshold || this.emptyAndNotPinned()) { bar.hidden = true; return; }
    var remaining = Math.max(0, threshold - this.subtotal);
    var pct = Math.min(100, (this.subtotal / threshold) * 100);
    var fill = bar.querySelector('[data-mm-gift-fill]');
    var msg  = bar.querySelector('[data-mm-gift-msg]');
    if (fill) fill.style.width = pct + '%';
    if (msg) {
      msg.innerHTML = remaining === 0
        ? '🎁 You unlocked your <strong>' + label + '</strong>!'
        : 'Add <strong>' + formatMoney(remaining) + '</strong> for a <strong>' + label + '</strong>';
    }
    bar.hidden = false;
  },

  // Lines the shopper actually pays for — feeds the badge / item count only.
  // Kaching bundle components discounted to $0 DO display in the drawer
  // (nested under their anchor line via buildCartRows), but they're owned by
  // the bundle, so they don't inflate the count the shopper sees.
  // Fail-open: if somehow every line is $0 (e.g. an orphaned gift), count
  // everything rather than showing an empty badge on a cart that checks out.
  paidItems() {
    var paid = this.items.filter(function (it) {
      var line = (typeof it.final_line_price === 'number') ? it.final_line_price
        : (typeof it.line_price === 'number') ? it.line_price
        : it.price * it.quantity;
      return line > 0;
    });
    return paid.length ? paid : this.items;
  },

  updateBadge() {
    var count = this.paidItems().reduce(function(sum, item) { return sum + item.quantity; }, 0);
    document.querySelectorAll('[data-mm-cart-count]').forEach(function(el) {
      el.textContent = count;
      el.hidden = count === 0;
    });
    // Keep the cart-page "Your Cart (N items)" heading in sync when the
    // drawer's own qty controls are the source of truth — e.g. user is
    // sitting on /cart and adjusts qty inside the drawer. Subtotal/total
    // on the cart page are intentionally left to its own handler so
    // discount semantics stay correct.
    document.querySelectorAll('[data-mm-cart-item-count]').forEach(function(el) { el.textContent = count; });
    document.querySelectorAll('[data-mm-cart-item-word]').forEach(function(el) {
      el.textContent = count === 1 ? 'item' : 'items';
    });
    // Toggle the cart-icon animation when items are present.
    document.querySelectorAll('.mm-nav__icon--cart[data-mm-cart-anim]').forEach(function(btn) {
      if (count > 0) btn.classList.add('mm-cart-anim--active');
      else btn.classList.remove('mm-cart-anim--active');
    });
  },

  renderItems() {
    var container = document.getElementById('mm-cart-items');
    var footer = document.getElementById('mm-cart-footer');
    var empty = document.getElementById('mm-cart-empty');
    var reserve = document.querySelector('[data-mm-reserve]');
    var subtotalEl = document.getElementById('mm-cart-subtotal');
    var drawerEl = document.getElementById('mm-cart');
    if (!container) return;

    // "Pin drawer open" in the theme editor: every Apply re-renders the section
    // and refetches /cart.js, and the editor's preview cart is usually empty —
    // which would hide the footer and countdown, i.e. exactly the chrome being
    // styled. While pinned, keep them up. data-editor-pinned only renders when
    // request.design_mode is true, so this can never affect a real shopper.
    var editorPinned = !!(drawerEl && drawerEl.hasAttribute('data-editor-pinned'));

    if (this.items.length === 0) {
      // Drop any leftover line rows before showing the empty state — the
      // container holds #mm-cart-empty alongside the dynamic .mm-cart__item
      // rows, and removing the last item otherwise leaves the (dimmed,
      // optimistically-patched) row sitting behind the empty message.
      container.querySelectorAll('.mm-cart__item').forEach(function(el) { el.remove(); });
      // An in-flight ATC keeps its stand-in up even over an empty server
      // cart — insertPendingLine re-hides the empty state and re-shows the
      // footer itself.
      if (mmReassertPendingSetup(container)) return;
      if (empty) empty.hidden = false;
      // Keep the footer up while an error is showing — the error line lives
      // inside it, and a failed FIRST add reconciles back to an empty cart
      // (this render) right after showCartError() unhides the footer.
      var errorShowing = document.getElementById('mm-cart-error');
      errorShowing = !!(errorShowing && !errorShowing.hidden);
      if (footer) footer.hidden = !editorPinned && !errorShowing;
      if (reserve) reserve.hidden = !editorPinned;
      // The add-ons shelf stays up on an empty cart — it's the one thing
      // left to act on besides the empty-state CTA, and it must never
      // disappear from the drawer.
      syncAddonsShelf();
      if (editorPinned) {
        if (subtotalEl) subtotalEl.textContent = formatMoney(this.subtotal);
        CartReserve.start();
      } else {
        CartReserve.stop();
      }
      return;
    }

    if (empty) empty.hidden = true;
    if (footer) footer.hidden = false;
    if (reserve) reserve.hidden = false;
    syncAddonsShelf();

    var savingsMode = (drawerEl && drawerEl.dataset.savingsMode) || 'strikethrough';

    // Every line renders — free or not. Bundle components ($0 or discounted)
    // nest under their anchor row via buildCartRows(); anything ungrouped
    // keeps its own top-level row. Their value still feeds the "You save"
    // pill below via renderCartSavings(this.items).
    var html = buildCartRows(this.items).map(function(row) {
      var item = row.item;
      var isProtection = (item.properties && item.properties._protection) ? true : false;
      var imgSrc = item.featured_image && item.featured_image.url
        ? item.featured_image.url.replace(/\.([^.]+)$/, '_120x120.$1')
        : '';
      var media = isProtection
        ? '<div class="mm-cart__item-img mm-cart__item-shield" aria-hidden="true">' +
            '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.6" stroke-linecap="round" stroke-linejoin="round">' +
              '<path d="M12 2.5l8 3.2v6.1c0 4.4-3.4 8.4-8 9.7-4.6-1.3-8-5.3-8-9.7V5.7l8-3.2z"/>' +
              '<path d="M9 12l2 2 4-4"/>' +
            '</svg>' +
          '</div>'
        : (imgSrc
            ? '<img class="mm-cart__item-img" src="' + imgSrc + '" alt="' + escapeHtml(item.title) + '" width="72" height="72" loading="lazy">'
            : '<div class="mm-cart__item-img mm-ph" data-label="ITEM"></div>');
      var subline;
      if (isProtection) {
        subline = '<div class="mm-cart__item-pill">Add-on · Shipping Protection</div>';
      } else {
        var sublineParts = '';
        if (item.variant_title && item.variant_title !== 'Default Title') {
          sublineParts += '<div class="mm-cart__item-variant">' + escapeHtml(item.variant_title) + '</div>';
        }
        var spa = item.selling_plan_allocation;
        if (spa && spa.selling_plan && spa.selling_plan.name) {
          // Frame this as a recurring delivery SCHEDULE, not the product
          // shipping again each cycle. The plan name carries the cadence;
          // the plan description (authored in Kaching) says what actually
          // arrives each delivery — surface it so the cart isn't read as
          // "a new trimmer every cycle".
          var planDesc = (spa.selling_plan.description && String(spa.selling_plan.description).trim())
            ? String(spa.selling_plan.description).trim()
            : '';
          sublineParts +=
            '<div class="mm-cart__item-sub">' +
              '<span class="mm-cart__item-sub-tag">' +
                '<svg class="mm-cart__item-sub-ic" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
                  '<path d="M2.7 8a5.3 5.3 0 0 1 9-3.8l1.6 1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '<path d="M13.3 8a5.3 5.3 0 0 1-9 3.8l-1.6-1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
                  '<path d="M13.6 2.3v3.4h-3.4M2.4 13.7v-3.4h3.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
                '</svg>' +
                mmT('subscription','Subscription') +
              '</span>' +
              '<span class="mm-cart__item-sub-plan">' + escapeHtml(spa.selling_plan.name) + '</span>' +
              (planDesc ? '<span class="mm-cart__item-sub-desc">' + escapeHtml(planDesc) + '</span>' : '') +
              subPolicyLinkHtml() +
            '</div>';
        }
        if (item.properties) {
          var propsHtml = '';
          for (var pk in item.properties) {
            if (!Object.prototype.hasOwnProperty.call(item.properties, pk)) continue;
            if (pk.charAt(0) === '_') continue;
            var pv = item.properties[pk];
            if (pv === null || pv === undefined || pv === '') continue;
            propsHtml += '<li><strong>' + escapeHtml(pk) + ':</strong> ' + escapeHtml(String(pv)) + '</li>';
          }
          if (propsHtml) {
            sublineParts += '<ul class="mm-cart__item-props" role="list">' + propsHtml + '</ul>';
          }
        }
        subline = sublineParts;
      }
      var qty = isProtection
        ? '<button class="mm-cart__item-remove" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="-' + item.quantity + '" aria-label="' + mmT('remove_protection','Remove shipping protection') + '">' + mmT('remove','Remove') + '</button>'
        : '<div class="mm-cart__item-qty" role="group" aria-label="' + mmT('quantity','Quantity') + '">' +
            '<button class="mm-cart__qty-btn mm-cart__qty-btn--dec" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="-1" aria-label="' + mmT('remove_one','Remove one') + '">−</button>' +
            '<span class="mm-cart__qty-val">' + item.quantity + '</span>' +
            '<button class="mm-cart__qty-btn mm-cart__qty-btn--inc" data-mm-action="cart-qty" data-key="' + item.key + '" data-delta="1" aria-label="' + mmT('add_one','Add one') + '">+</button>' +
          '</div>';
      return '<div class="mm-cart__item' + (isProtection ? ' mm-cart__item--protection' : '') + '" data-key="' + item.key + '">' +
        media +
        '<div class="mm-cart__item-meta">' +
          renderItemSaveBadge(item) +
          '<div class="mm-cart__item-name">' + escapeHtml(item.title) + '</div>' +
          subline +
          qty +
        '</div>' +
        renderItemPrice(item, savingsMode) +
        renderBundleGifts(row.gifts) +
      '</div>';
    }).join('');

    var existingItems = container.querySelectorAll('.mm-cart__item');
    existingItems.forEach(function(el) { el.remove(); });
    if (empty) {
      container.insertAdjacentHTML('afterbegin', html);
    } else {
      container.innerHTML = html;
    }

    if (subtotalEl) subtotalEl.textContent = formatMoney(this.subtotal);
    renderCartSavings(this.items);
    mmReassertPendingSetup(container);
    mmPaintOffers();
  }
};

function formatMoney(cents) {
  // Theme setting "Price display" (cents / rounded / floored) — see layout/theme.liquid
  if (window.mmMoney) return window.mmMoney(cents);
  return '$' + (cents / 100).toFixed(2);
}

// Savings displays show round numbers: nearest $5 step ($84.99 → $85);
// under $5 the exact amount stays so a badge can't read $0.
function mmSaveRound(cents) {
  return cents >= 500 ? Math.round(cents / 500) * 500 : cents;
}

// Per-unit "was" price for a line item.
//   • Subscription lines compare against the ONE-TIME price (what you'd pay
//     without the plan) so the drawer matches the on-PDP subscribe offer
//     (e.g. $129.99 → $116.99). We pull that from the hydrated variant price
//     or the selling-plan allocation's compare-at — never the retail
//     compare-at, which would resurrect the $160-vs-offer mismatch.
//   • One-time lines keep the existing retail compare-at behavior.
function getItemWasUnit(item) {
  var unitNow = (item.quantity > 0 && typeof item.final_line_price === 'number')
    ? item.final_line_price / item.quantity
    : item.price;
  if (item.selling_plan_allocation) {
    var spa = item.selling_plan_allocation;
    if (typeof variantPriceCache[item.variant_id] === 'number' && variantPriceCache[item.variant_id] > unitNow) {
      return variantPriceCache[item.variant_id];
    }
    if (typeof spa.compare_at_price === 'number' && spa.compare_at_price > unitNow) {
      return spa.compare_at_price;
    }
    return 0;
  }
  return getItemComparePrice(item) || 0;
}

function computeItemSavings(item) {
  var now = item.final_line_price;
  var was = item.original_line_price && item.original_line_price > now
    ? item.original_line_price
    : null;
  if (!was) {
    var wasUnit = getItemWasUnit(item);
    if (wasUnit) was = wasUnit * item.quantity;
  }
  return { now: now, was: was };
}

function renderItemSaveBadge(item) {
  var s = computeItemSavings(item);
  if (!s.was) return '';
  var saved = s.was - s.now;
  if (saved <= 0) return '';
  return '<span class="mm-cart__item-save">Save ' + mmDiscountMoney(mmSaveRound(saved)) + '</span>';
}

/* ---- Kaching bundle grouping ---------------------------------------------
   Kaching tags every line it adds with a hidden `__kaching_bundles` property
   holding JSON; lines from the same add share an instance key ("id" on
   current builds, "bid" on some older ones). NOTE the counter-intuitive
   shape verified live (2026-08): for the Welcome Kit the widget marks the $0
   SUBSCRIPTION component (Foil Shaver Attachment, carries the selling plan)
   as {"main":true}, while the paid trimmer line carries {"bundleProduct"}.
   So "main" does NOT mean "the line to feature" — classification here is by
   PRICE: within an instance group the first PAID line is the anchor and
   every $0 line nests under it. Grouping on the shared id (rather than
   price alone) keeps this safe: two bundles can coexist, and a $0 line from
   a different app (no kaching property) is never swept under a trimmer. */
function parseKachingBundle(item) {
  var raw = item && item.properties && item.properties.__kaching_bundles;
  if (!raw || typeof raw !== 'string') return null;
  var data;
  try { data = JSON.parse(raw); } catch (e) { return null; }
  if (!data || typeof data !== 'object') return null;
  return {
    // Some deals ship no instance key at all — nothing to join on, so those
    // lines stay ungrouped rather than collapsing into one bogus group.
    id: typeof data.id === 'string' ? data.id
      : typeof data.bid === 'string' ? data.bid
      : ''
  };
}

function mmLineTotal(it) {
  return (typeof it.final_line_price === 'number') ? it.final_line_price
    : (typeof it.line_price === 'number') ? it.line_price
    : it.price * it.quantity;
}

// Ordered render list: [{ item, gifts: [...] }]. A bundle only nests when its
// group holds BOTH a paid anchor and at least one $0 component; an orphaned
// component keeps its own row (and therefore its own remove control) instead
// of becoming unreachable, and an anchor with no components renders exactly
// as it does today. (Orphans are rare now: removing an anchor sweeps its $0
// components with it — see mmDependentGiftLines.)
function buildCartRows(items) {
  var anchorFor = Object.create(null);
  var giftsFor = Object.create(null);

  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (kb && kb.id && mmLineTotal(it) > 0 && !anchorFor[kb.id]) anchorFor[kb.id] = it;
  });
  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (!kb || !kb.id || !anchorFor[kb.id]) return;
    if (mmLineTotal(it) === 0) (giftsFor[kb.id] = giftsFor[kb.id] || []).push(it);
  });

  var rows = [];
  items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (!kb || !kb.id) { rows.push({ item: it, gifts: [] }); return; }
    if (mmLineTotal(it) === 0 && anchorFor[kb.id]) return; // nested under its anchor
    if (anchorFor[kb.id] === it) {
      rows.push({ item: it, gifts: giftsFor[kb.id] || [] });
      return;
    }
    rows.push({ item: it, gifts: [] });
  });
  return rows;
}

/* The $0 Kaching components that would be left behind if `item` (a paid
   bundle anchor) left the cart: same instance group, no OTHER paid line
   still in it. They ride along with the anchor's removal, so a shopper who
   drops the trimmer never inherits a cart of stray free length guards /
   cables / brushes. Anything the shopper added on purpose is untouched by
   construction — an explicit add carries no __kaching_bundles property (or
   a different instance id if it came from its own Kaching offer), so it
   never matches the group. Non-Kaching lines return []. */
function mmDependentGiftLines(item, items) {
  var kb = parseKachingBundle(item);
  if (!kb || !kb.id || mmLineTotal(item) <= 0) return [];
  var otherPaid = items.some(function (it) {
    if (it.key === item.key) return false;
    var k = parseKachingBundle(it);
    return !!(k && k.id === kb.id && mmLineTotal(it) > 0);
  });
  if (otherPaid) return [];
  return items.filter(function (it) {
    if (it.key === item.key) return false;
    var k = parseKachingBundle(it);
    return !!(k && k.id === kb.id && mmLineTotal(it) === 0);
  });
}

/* ---- ATC optimism / paid-line watchdog ------------------------------------
   One click on a Kaching-owned buybox can become TWO requests (see
   handleAtcSubmit): our form post — which the widget rewrites, often to the
   $0 gift components — and the widget's own partial post carrying the PAID
   line. If our reconcile lands between the two, the drawer shows a
   gifts-only cart; if the second post dies, the order really is missing the
   product. Everything here exists so the customer never sees — or checks
   out — that half-landed state:

     mmAddInFlight        the /cart/add.js request currently running, so
                          checkout waits for it instead of racing it
     mmPendingSetup       the optimistic stand-in (product + gifts) painted
                          on click; held on screen until the paid line is
                          confirmed server-side
     mmOrphanedGiftLines  $0 Kaching components with no paid anchor in their
                          group — the signature of a half-landed add */
var mmAddInFlight = null;
var mmAddEverStarted = false; // any add this page load — mmResetStaleCart stands down
var mmPendingSetup = null; // { info, until, recovered }

function mmTrackAdd(promise) {
  mmAddInFlight = promise;
  mmAddEverStarted = true;
  var clear = function () { if (mmAddInFlight === promise) mmAddInFlight = null; };
  promise.then(clear, clear);
  return promise;
}

function mmOrphanedGiftLines() {
  var anchors = Object.create(null);
  CartState.items.forEach(function (it) {
    var kb = parseKachingBundle(it);
    if (kb && kb.id && mmLineTotal(it) > 0) anchors[kb.id] = true;
  });
  return CartState.items.filter(function (it) {
    var kb = parseKachingBundle(it);
    return kb && kb.id && mmLineTotal(it) === 0 && !anchors[kb.id];
  });
}

/* Called from renderItems after every server paint. While the click is still
   settling — the add request itself in flight, or the paid anchor missing —
   re-paint the stand-in setup over the incomplete server state, hiding the
   orphaned gift rows it already covers. Returns true when the stand-in owns
   the list; clears itself the moment the cart is whole (or on timeout). */
function mmReassertPendingSetup(container) {
  if (!mmPendingSetup) return false;
  if (mmPendingSetup.recovered || Date.now() > mmPendingSetup.until) {
    mmPendingSetup = null;
    return false;
  }
  var orphans = mmOrphanedGiftLines();
  if (!mmAddInFlight && !orphans.length) {
    mmPendingSetup = null;
    return false;
  }
  orphans.forEach(function (it) {
    var row = container.querySelector('.mm-cart__item[data-key="' + it.key + '"]');
    if (row) row.remove();
  });
  insertPendingLine(mmPendingSetup.info);
  return true;
}

/* ---- Kaching subscription swap ("what actually recurs") -------------------
   Kaching Subscriptions prints its selling-plan definitions on every page
   (app embed → <script id="kaching-subscriptions-config">). For swap-style
   bundle plans the interesting bit is automaticLineActionsPolicy: after
   cycle 1 the app REMOVES the bundled gift product and ADDS the recurring
   product (e.g. a fresh blade at $15.99). The cart line itself only names a
   cadence, so the drawer reads the policy to say what is actually delivered
   on that schedule. The swap variant's title/image aren't in the config —
   they're resolved once via the public Storefront token Kaching prints in
   #kaching-bundles-config (same source manmade-bundle-price.js uses) and
   cached in sessionStorage; until that lands the row shows the schedule
   line alone, which is still accurate. */
var mmSubsCfg; // parsed #kaching-subscriptions-config (null = absent/bad)
function mmKachingSubsConfig() {
  if (mmSubsCfg !== undefined) return mmSubsCfg;
  mmSubsCfg = null;
  try {
    var el = document.getElementById('kaching-subscriptions-config');
    if (el && el.textContent) mmSubsCfg = JSON.parse(el.textContent);
  } catch (e) { /* fall back to the raw plan-name display */ }
  return mmSubsCfg;
}

function mmPlanEveryText(delivery) {
  if (!delivery || !delivery.interval) return '';
  var unit = { DAY: 'day', WEEK: 'week', MONTH: 'month', YEAR: 'year' }[String(delivery.interval).toUpperCase()];
  if (!unit) return '';
  var n = Number(delivery.frequency) || 1;
  return 'every ' + (n > 1 ? n + ' ' + unit + 's' : unit);
}

/* { every, variantId, priceCents } for a cart line's numeric selling-plan id,
   or null when the plan isn't in the Kaching config on this page. variantId
   is 0 for plain (no-swap) plans. */
function mmKachingPlanMeta(planId) {
  var cfg = mmKachingSubsConfig();
  var pc = cfg && cfg.sellingPlanConfigs &&
    cfg.sellingPlanConfigs['gid://shopify/SellingPlan/' + planId];
  if (!pc) return null;
  var meta = { every: mmPlanEveryText(pc.delivery), variantId: 0, priceCents: 0 };
  var pol = pc.automaticLineActionsPolicy || {};
  var cycles = Object.keys(pol).sort(function (a, b) { return a - b; });
  for (var i = 0; i < cycles.length && !meta.variantId; i++) {
    var acts = pol[cycles[i]] || [];
    for (var j = 0; j < acts.length; j++) {
      var act = acts[j];
      if (act && act.type === 'add' && act.variantId) {
        meta.variantId = act.variantId;
        if (act.discountPolicy && act.discountPolicy.type === 'PRICE') {
          meta.priceCents = Math.round(Number(act.discountPolicy.adjustmentValue) * 100);
        }
        break;
      }
    }
  }
  // Some plans price the recurring item on the plan itself instead of the
  // add action ("$0 today, $15.99/cycle after cycle 1").
  if (!meta.priceCents && pc.recurringDiscountAdjustment && pc.recurringDiscountAdjustment.type === 'PRICE') {
    meta.priceCents = Math.round(Number(pc.recurringDiscountAdjustment.adjustmentValue) * 100);
  }
  return meta;
}

var SWAP_CACHE_KEY = 'mm-kaching-swap-v1'; // sessionStorage: variantId -> {title, img}
var mmSwapInflight = {};
function mmSwapCacheGet(vid) {
  try { return (JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY)) || {})[vid] || null; }
  catch (e) { return null; }
}
function mmSwapCachePut(vid, entry) {
  try {
    var all = JSON.parse(sessionStorage.getItem(SWAP_CACHE_KEY)) || {};
    all[vid] = entry;
    sessionStorage.setItem(SWAP_CACHE_KEY, JSON.stringify(all));
  } catch (e) { /* private mode etc. — refetched next render */ }
}

/* Resolve a swap variant's product title/image once, then patch every
   rendered swap row in place (render() may have painted before this lands;
   the cache makes all later renders synchronous). */
function mmResolveSwapVariant(vid) {
  if (mmSwapCacheGet(vid) || mmSwapInflight[vid]) return;
  var domain, token;
  try {
    var cfg = JSON.parse(document.getElementById('kaching-bundles-config').textContent);
    domain = cfg.shopifyDomain;
    token = cfg.storefrontAccessToken;
  } catch (e) { return; }
  if (!domain || !token) return;
  mmSwapInflight[vid] = true;
  var query = '{node(id:"gid://shopify/ProductVariant/' + vid + '"){... on ProductVariant{product{title}image{url}}}}';
  fetch('https://' + domain + '/api/2026-01/graphql.json', {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
      'X-Shopify-Storefront-Access-Token': token
    },
    body: JSON.stringify({ query: query })
  })
    .then(function (r) { return r.ok ? r.json() : null; })
    .then(function (data) {
      var node = data && data.data && data.data.node;
      if (!node || !node.product || !node.product.title) return;
      var entry = { title: node.product.title, img: (node.image && node.image.url) || '' };
      mmSwapCachePut(vid, entry);
      mmPatchSwapRows(vid, entry);
    })
    .catch(function () { /* schedule-only row remains — still accurate */ })
    .then(function () { delete mmSwapInflight[vid]; });
}

function mmPatchSwapRows(vid, entry) {
  document.querySelectorAll('[data-mm-swap="' + vid + '"]').forEach(function (row) {
    var nameEl = row.querySelector('[data-mm-swap-name]');
    if (nameEl) nameEl.textContent = entry.title;
    var ph = row.querySelector('[data-mm-swap-img]');
    if (ph && entry.img && ph.tagName !== 'IMG') {
      var img = document.createElement('img');
      img.className = 'mm-cart__gift-img';
      img.src = entry.img.replace(/\.([^.]+)$/, '_80x80.$1');
      img.alt = '';
      img.width = 32;
      img.height = 32;
      img.loading = 'lazy';
      img.setAttribute('data-mm-swap-img', '');
      ph.replaceWith(img);
    }
  });
}

// The recurring (post-swap) product as its own row under the gift it will
// replace: what arrives on the schedule, how often, at what recurring price.
function renderGiftSwapRow(meta) {
  var vid = String(meta.variantId);
  var cached = mmSwapCacheGet(vid);
  if (!cached) mmResolveSwapVariant(vid);
  var media = cached && cached.img
    ? '<img class="mm-cart__gift-img" data-mm-swap-img src="' + cached.img.replace(/\.([^.]+)$/, '_80x80.$1') + '" alt="" width="32" height="32" loading="lazy">'
    : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" data-mm-swap-img aria-hidden="true"></span>';
  var schedule = mmT('delivered','Delivered') + ' ' + meta.every +
    (meta.priceCents ? ' · ' + formatMoney(meta.priceCents) : '');
  return '<li class="mm-cart__gift mm-cart__gift--swap" data-mm-swap="' + vid + '">' +
      media +
      '<span class="mm-cart__gift-meta">' +
        '<span class="mm-cart__gift-name" data-mm-swap-name>' + escapeHtml(cached && cached.title ? cached.title : '') + '</span>' +
        '<span class="mm-cart__gift-plan">' +
          '<svg class="mm-cart__gift-swap-ic" viewBox="0 0 16 16" fill="none" aria-hidden="true">' +
            '<path d="M2.7 8a5.3 5.3 0 0 1 9-3.8l1.6 1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M13.3 8a5.3 5.3 0 0 1-9 3.8l-1.6-1.5" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
            '<path d="M13.6 2.3v3.4h-3.4M2.4 13.7v-3.4h3.4" stroke="currentColor" stroke-width="1.4" stroke-linecap="round" stroke-linejoin="round"/>' +
          '</svg>' +
          escapeHtml(schedule) +
        '</span>' +
        subPolicyLinkHtml() +
      '</span>' +
    '</li>';
}

// Sub-rows for the free add-ons that came with a bundle. No quantity stepper —
// the bundle owns the quantity. FREE rows get no remove control either: an ×
// on a $0 line reads as "am I paying for this? do I need to decide?" — and an
// orphaned gift is never stuck, because a component without a paid anchor
// renders as its own top-level row with a normal remove (see buildCartRows).
// Merely-discounted components still cost money, so they keep the ×.
function renderBundleGifts(gifts) {
  if (!gifts || !gifts.length) return '';
  // "Your 2 free gifts" beats "Included with this bundle" — but only when the
  // whole group really is free; a mix of free + discounted keeps the generic
  // label rather than miscounting.
  var freeQty = 0;
  var allFree = true;
  gifts.forEach(function (g) {
    if (g.final_line_price === 0) freeQty += Math.max(1, g.quantity || 1);
    else allFree = false;
  });
  var label = allFree && freeQty > 0
    ? (freeQty === 1 ? mmT('gift_one','Your free gift') : mmT('gift_many','Your {n} free gifts').replace('{n}', freeQty))
    : mmT('included_bundle','Included with this bundle');
  var rows = gifts.map(function (g) {
    var media = g.featured_image && g.featured_image.url
      ? '<img class="mm-cart__gift-img" src="' + g.featured_image.url.replace(/\.([^.]+)$/, '_80x80.$1') + '" alt="" width="32" height="32" loading="lazy">'
      : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" aria-hidden="true"></span>';
    var qty = g.quantity > 1 ? ' <span class="mm-cart__gift-qty">×' + g.quantity + '</span>' : '';
    // Free is the common case, but a bundle component can be merely
    // discounted — show whatever the line actually costs.
    var price = g.final_line_price === 0
      ? (g.original_line_price > 0 ? '<span class="mm-cart__gift-was">' + formatMoney(g.original_line_price) + '</span>' : '') +
        '<span class="mm-cart__gift-free">Free</span>'
      : '<span class="mm-cart__gift-now">' + formatMoney(g.final_line_price) + '</span>';
    // The subscription rides on the COMPONENT line (verified live: the free
    // Foil Shaver carries the "every 2 months" plan, the trimmer doesn't).
    // But the plan's cadence describes the post-swap RECURRING product, not
    // this gift — the gift ships once and Kaching's line action swaps it out
    // after cycle 1. So: tag the free line "Free gift", and give the actual
    // recurring product its own row (renderGiftSwapRow). A plan with no swap
    // policy keeps a cadence line here; a plan missing from the Kaching
    // config falls back to the raw plan name as before.
    var spa = g.selling_plan_allocation;
    var plan = '';
    var swapRow = '';
    if (spa && spa.selling_plan) {
      var meta = mmKachingPlanMeta(spa.selling_plan.id);
      if (meta && meta.variantId && meta.every) {
        swapRow = renderGiftSwapRow(meta);
      } else if (meta && meta.every) {
        plan = '<span class="mm-cart__gift-plan">' + mmT('delivered','Delivered') + ' ' + escapeHtml(meta.every) + '</span>';
      } else if (spa.selling_plan.name) {
        plan = '<span class="mm-cart__gift-plan">' + escapeHtml(spa.selling_plan.name) + '</span>';
      }
    }
    // No "Free gift" chip next to the name — the group label ("Your N free
    // gifts") and the price column's struck-price + FREE already say it;
    // a third mention just crowds the title.
    var removeBtn = g.final_line_price === 0
      ? ''
      : '<button type="button" class="mm-cart__gift-remove" data-mm-action="cart-qty"' +
          ' data-key="' + g.key + '" data-delta="-' + g.quantity + '"' +
          ' aria-label="Remove ' + escapeHtml(g.title) + ' from cart">' +
          '<svg viewBox="0 0 16 16" width="10" height="10" fill="none" aria-hidden="true">' +
            '<path d="M3.5 3.5l9 9M12.5 3.5l-9 9" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
          '</svg>' +
        '</button>';
    return '<li class="mm-cart__gift" data-key="' + g.key + '">' +
        media +
        '<span class="mm-cart__gift-meta">' +
          '<span class="mm-cart__gift-name">' + escapeHtml(g.title) + qty + '</span>' +
          plan +
        '</span>' +
        '<span class="mm-cart__gift-price">' + price + '</span>' +
        removeBtn +
      '</li>' +
      swapRow;
  }).join('');
  return '<ul class="mm-cart__gifts" role="list">' +
      '<li class="mm-cart__gifts-label" aria-hidden="true">' + label + '</li>' +
      rows +
    '</ul>';
}

// Per-unit savings for a line. Kept per-unit (rather than per-line) so the
// footer badge can be recomputed against an optimistic quantity mid-click,
// exactly like updateLineDom() scales the row's own "was"/"Save" figures.
function getItemUnitSavings(item) {
  if (!item.quantity) return 0;
  var s = computeItemSavings(item);
  if (!s.was) return 0;
  var saved = s.was - s.now;
  return saved > 0 ? saved / item.quantity : 0;
}

// Cart-level "You save $X" pill next to the subtotal. qtyFor lets the
// optimistic path substitute the pending quantity for a line.
function renderCartSavings(items, qtyFor) {
  var el = document.getElementById('mm-cart-savings');
  if (!el) return;
  var saved = items.reduce(function (sum, it) {
    var qty = qtyFor ? qtyFor(it) : it.quantity;
    return sum + getItemUnitSavings(it) * Math.max(0, qty);
  }, 0);
  saved = Math.round(saved);
  // The cart's "Discount applied" note (pdp-discount-applied, context cart)
  // shows exactly while the cart is saving money.
  document.querySelectorAll('[data-mm-disc-note="cart"]').forEach(function (n) {
    if (n.hidden !== (saved <= 0)) n.hidden = saved <= 0;
  });
  if (saved <= 0) {
    el.textContent = '';
    el.hidden = true;
    return;
  }
  el.textContent = mmT('you_save','You save') + ' ' + mmDiscountMoney(mmSaveRound(saved));
  el.hidden = false;
}

function renderItemPrice(item, mode) {
  var s = computeItemSavings(item);
  var now = s.now;
  var was = s.was;

  if (!was || mode === 'off') {
    return '<div class="mm-cart__item-price"><span class="mm-cart__item-now">' + formatMoney(now) + '</span></div>';
  }

  return '<div class="mm-cart__item-price mm-cart__item-price--stacked">' +
    '<span class="mm-cart__item-was">' + formatMoney(was) + '</span>' +
    '<span class="mm-cart__item-now">' + formatMoney(now) + '</span>' +
  '</div>';
}

function escapeHtml(str) {
  return String(str)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;');
}

// Subtle "Learn more about this subscription" link for subscription cart rows.
// Same .mm-subpolicy markup the Liquid snippet emits, so the global reader
// modal (snippets/subscription-policy-modal.liquid) intercepts the click and
// the shared styles apply. The href is the no-JS fallback; the URL mirrors the
// modal's data-policy-url (theme setting), falling back to the policy page.
function subPolicyLinkHtml() {
  var m = document.getElementById('mm-subpolicy-modal');
  var url = (m && m.getAttribute('data-policy-url')) || '/pages/precision-trimmer-2-0-subscription-policy';
  return '<a class="mm-subpolicy mm-subpolicy--cart" href="' + escapeHtml(url) + '" target="_blank" rel="noopener">' +
    '<svg class="mm-subpolicy__ic" viewBox="0 0 16 16" width="13" height="13" fill="none" aria-hidden="true">' +
      '<circle cx="8" cy="8" r="7" stroke="currentColor" stroke-width="1.4"/>' +
      '<path d="M8 7.2v4M8 4.9h.01" stroke="currentColor" stroke-width="1.6" stroke-linecap="round"/>' +
    '</svg>' +
    '<span class="mm-subpolicy__text">' + mmT('learn_sub','Learn more about this subscription') + '</span>' +
  '</a>';
}

/* ----------------------------------------------------------
   7. CART DRAWER
   ---------------------------------------------------------- */
var cartDrawerOpen = false;
var lastFocusedCart = null;
var scrollLockY = 0;
var scrollLockCount = 0;

function lockBodyScroll() {
  if (scrollLockCount++ > 0) return;
  scrollLockY = window.scrollY || window.pageYOffset || 0;
  var body = document.body;
  body.style.position = 'fixed';
  body.style.top = '-' + scrollLockY + 'px';
  body.style.left = '0';
  body.style.right = '0';
  body.style.width = '100%';
  body.style.overflow = 'hidden';
}

function unlockBodyScroll() {
  if (scrollLockCount === 0) return; // nothing locked: don't restore a stale scrollLockY (0 = jump to top)
  scrollLockCount--;
  if (scrollLockCount > 0) return;
  var body = document.body;
  body.style.position = '';
  body.style.top = '';
  body.style.left = '';
  body.style.right = '';
  body.style.width = '';
  body.style.overflow = '';
  window.scrollTo({ top: scrollLockY, left: 0, behavior: "instant" });
}

/* Reservation countdown — sessionStorage-backed cart-hold timer.
   The timer starts the first time the drawer opens this session, persists
   across page navigations, and shows an expired state at 00:00. */
var CartReserve = (function () {
  var STORAGE_KEY = 'mm-cart-reserve-expiry-v1';
  var el = null, labelEl = null, timeEl = null;
  var activeLabel = '', expiredLabel = '', minutes = 10;
  var expiry = 0;
  var iv = null;

  function pad(n) { return n < 10 ? '0' + n : '' + n; }

  function read() {
    try {
      var v = parseInt(sessionStorage.getItem(STORAGE_KEY), 10);
      return isNaN(v) ? 0 : v;
    } catch (e) { return 0; }
  }
  function write(v) {
    try { sessionStorage.setItem(STORAGE_KEY, String(v)); } catch (e) {}
  }

  function render() {
    if (!el || !timeEl) return;
    var rem = expiry - Date.now();
    if (rem <= 0) {
      timeEl.textContent = '00:00';
      el.setAttribute('data-expired', '');
      if (labelEl && expiredLabel) labelEl.textContent = expiredLabel;
      stop();
      return;
    }
    el.removeAttribute('data-expired');
    if (labelEl && activeLabel) labelEl.textContent = activeLabel;
    var mins = Math.floor(rem / 60000);
    var secs = Math.floor((rem % 60000) / 1000);
    timeEl.textContent = pad(mins) + ':' + pad(secs);
  }

  function start() {
    if (!el) init();
    if (!el) return;
    if (!expiry) {
      expiry = read();
      if (!expiry || expiry < Date.now()) {
        expiry = Date.now() + minutes * 60 * 1000;
        write(expiry);
      }
    }
    render();
    if (iv) return;
    iv = setInterval(render, 1000);
  }
  function stop() {
    if (iv) { clearInterval(iv); iv = null; }
  }

  function init() {
    el = document.querySelector('[data-mm-reserve]');
    if (!el) return;
    labelEl = el.querySelector('[data-mm-reserve-label]');
    timeEl  = el.querySelector('[data-mm-reserve-time]');
    activeLabel  = el.getAttribute('data-active-label')  || '';
    expiredLabel = el.getAttribute('data-expired-label') || '';
    minutes = parseInt(el.getAttribute('data-minutes'), 10) || 10;
  }

  return { start: start, stop: stop, init: init };
})();

/* Leave for /checkout only once the cart really holds what the drawer shows:
   wait out any in-flight add, and if this click's paid line is still
   unconfirmed, spend one round trip verifying (and recovering) it. Capped at
   4s — an instant redirect in the healthy case, never a hostage in the bad
   one. */
function mmGoCheckout() {
  var go = function () { window.location.href = '/checkout'; };
  var settled = mmAddInFlight
    ? mmAddInFlight.then(function () {}, function () {})
    : Promise.resolve();
  var verified = settled.then(function () {
    if (!mmPendingSetup) return;
    return CartState.fetch().then(function () {
      if (mmOrphanedGiftLines().length) return mmRecoverPaidLine();
    });
  });
  Promise.race([
    verified.then(function () {}, function () {}),
    new Promise(function (resolve) { setTimeout(resolve, 4000); })
  ]).then(go);
}

/* Spring-driven slide + drag-to-close for a drawer (mm-spring.js). Returns
   null when the motion layer isn't loaded; the CSS [data-open] state still
   opens and closes the drawer, just without motion. */
function drawerMotion(drawer, scrim, side, onDismiss) {
  if (!drawer || !window.MMSpring || drawer.hasAttribute('data-editor-pinned')) return null;
  return drawer.__mmPanel || (drawer.__mmPanel = MMSpring.panel(drawer, {
    side: side,
    scrim: scrim,
    open: drawer.hasAttribute('data-open'),
    onDismiss: onDismiss
  }));
}

/* ---- Header hides on scroll ------------------------------------------------
   The top panel floats over the list (CSS .mm-cart__top); the list reserves
   its room with padding-top = --mm-top-space, measured here and kept in step
   by a ResizeObserver as the hold / shipping / gift rows come and go.
   Scrolling the list down slides the panel up out of the drawer with a
   transform (data-head-hidden on #mm-cart); scrolling up, or reaching the
   top, brings it back. Nothing in the list's layout changes, so the scroll
   position never jumps. The close button is a separate element on the drawer,
   so it stays put and gains a shadow. Programmatic holds (mmHold keeps an
   added card under the finger) never toggle it, and a drawer with a banner
   (which sits outside the list) keeps its panel. */
var mmCartHead = (function () {
  var drawer, top, list, lastY = 0, acc = 0;
  function hidden() { return drawer.hasAttribute('data-head-hidden'); }
  function measure() {
    var mb = parseFloat(getComputedStyle(top).getPropertyValue('--ct-mb')) || 0;
    var padTop = parseFloat(getComputedStyle(drawer).paddingTop) || 0;
    var space = Math.round(top.offsetTop + top.offsetHeight + mb - padTop);
    drawer.style.setProperty('--mm-top-space', space + 'px');
  }
  function set(hide) {
    if (hide === hidden()) return;
    if (hide) drawer.setAttribute('data-head-hidden', '');
    else drawer.removeAttribute('data-head-hidden');
    acc = 0;
  }
  function onScroll() {
    var y = list.scrollTop, d = y - lastY;
    lastY = y;
    if (mmHold) return;
    if (y <= 4) { set(false); return; }
    if ((d > 0) !== (acc > 0)) acc = 0;
    acc += d;
    if (acc > 12 && y > top.offsetHeight && !drawer.querySelector('.mm-cart__banner')) set(true);
    else if (acc < -16) set(false);
  }
  function init() {
    if (drawer) return true;
    var d = document.getElementById('mm-cart');
    top = document.getElementById('mm-cart-top');
    list = document.getElementById('mm-cart-items');
    if (!d || !top || !list) return false;
    drawer = d;
    measure();
    if (window.ResizeObserver) new ResizeObserver(measure).observe(top);
    list.addEventListener('scroll', onScroll, { passive: true });
    // A re-render that leaves nothing to scroll brings the panel back.
    document.addEventListener('mm:cart:updated', function () {
      setTimeout(function () {
        if (hidden() && list.scrollHeight - list.clientHeight < 8) set(false);
      }, 60);
    });
    return true;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
  return {
    show: function () {
      if (!init()) return;
      lastY = list.scrollTop;
      set(false);
    }
  };
})();

function openCart() {
  var drawer = document.getElementById('mm-cart');
  var scrim = document.querySelector('[data-mm-cart-scrim]');
  if (!drawer) return;
  if (mmCartHead) mmCartHead.show();

  var motion = drawerMotion(drawer, scrim, 'right', closeCart);

  // Idempotent: a second open while already open (a quick double-tap on the cart
  // icon, an add flow that opens the drawer it is already in) must not take
  // another scroll-lock reference or re-aim focus. closeCart() gives back only
  // one reference, so a stray extra one left the page frozen after closing.
  var wasOpen = cartDrawerOpen;
  if (!wasOpen) {
    lastFocusedCart = document.activeElement;
    mmCartOpenSig = mmCartSig(CartState.items);
  }
  drawer.setAttribute('data-open', '');
  drawer.setAttribute('aria-hidden', 'false');
  if (scrim) { scrim.setAttribute('data-open', ''); scrim.setAttribute('aria-hidden', 'false'); }
  if (motion) motion.open();
  if (!wasOpen) lockBodyScroll();
  cartDrawerOpen = true;
  // First open starts the bundle deal lookup (skipped while closed); it
  // repaints the offers when it lands.
  var offerStore = document.querySelector('[data-mm-offers]');
  if (offerStore && CartState.items.length && offerStore.querySelector('[data-mm-bundle]') && !offerStore.dataset.dealsReady) {
    mmLoadBundleDeals(offerStore);
  }
  mmSyncRail(); // skipped while closed

  CartReserve.start();

  if (!wasOpen) {
    requestAnimationFrame(function() {
      var closeBtn = drawer.querySelector('[data-mm-action="close-cart"]');
      if (closeBtn) closeBtn.focus({ preventScroll: true });
    });
  }

  trapFocus(drawer);
}

function closeCart() {
  var drawer = document.getElementById('mm-cart');
  var scrim = document.querySelector('[data-mm-cart-scrim]');
  if (!drawer) return;

  // Only a drawer that really held a scroll lock gives one back: a stray close
  // (scrim tap while another panel is up) must not release someone else's lock.
  var motion = drawerMotion(drawer, scrim, 'right', closeCart);
  var wasOpen = cartDrawerOpen;
  drawer.removeAttribute('data-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (scrim) { scrim.removeAttribute('data-open'); scrim.setAttribute('aria-hidden', 'true'); }
  if (motion) motion.close();
  if (wasOpen) unlockBodyScroll();
  cartDrawerOpen = false;

  CartReserve.stop();

  removeTrapFocus(drawer);
  if (lastFocusedCart) { lastFocusedCart.focus({ preventScroll: true }); lastFocusedCart = null; }
  if (wasOpen) mmRefreshCartPage();

  // Any card still marked from an in-drawer add (e.g. the add failed) goes
  // back to the normal in-cart rule once the drawer has slid shut.
  mmHold = null;
  var held = document.querySelectorAll('.mm-cart__addon[data-mm-added]');
  if (held.length) {
    setTimeout(function() {
      if (cartDrawerOpen) return;
      held.forEach(function(c) { c.removeAttribute('data-mm-added'); });
      syncAddonsShelf();
    }, 450);
  }
}

/* The full cart page is server-rendered, so a change made in the drawer on top
   of it (add from "You may also like", qty, remove) only shows after a reload.
   Same for the empty cart page's shop grid: an add there reloads into the cart.
   An add still in flight at close is waited for, or the check would miss it. */
var mmCartOpenSig = null;
function mmRefreshCartPage() {
  if (!document.querySelector('[data-mm-cart-list], [data-mm-cart-empty]')) return;
  var settled = mmAddInFlight
    ? mmAddInFlight.then(function () { return CartState.fetch(); }, function () {})
    : Promise.resolve();
  settled.then(function () {
    if (!cartDrawerOpen && mmCartSig(CartState.items) !== mmCartOpenSig) window.location.reload();
  });
}

// For inline section scripts that post their own add.
window.mmOpenCart = function () {
  openCart();
  return CartState.fetch();
};

/* ----------------------------------------------------------
   8. MOBILE DRAWER
   ---------------------------------------------------------- */
var navDrawerOpen = false;
var lastFocusedDrawer = null;

function openDrawer() {
  var drawer = document.getElementById('mm-drawer');
  var scrim = document.querySelector('[data-mm-drawer-scrim]');
  var btn = document.querySelector('[data-mm-action="open-drawer"]');
  if (!drawer) return;

  // Idempotent, same reason as openCart(): a double-tap on the burger must not
  // stack a second scroll-lock reference that one close can't release.
  var motion = drawerMotion(drawer, scrim, 'left', closeDrawer);
  var wasOpen = navDrawerOpen;
  if (!wasOpen) lastFocusedDrawer = document.activeElement;
  drawer.setAttribute('data-open', '');
  drawer.setAttribute('aria-hidden', 'false');
  if (scrim) scrim.setAttribute('data-open', '');
  if (motion) motion.open();
  if (btn) btn.setAttribute('aria-expanded', 'true');
  if (!wasOpen) lockBodyScroll();
  navDrawerOpen = true;

  if (!wasOpen) requestAnimationFrame(function() { drawer.focus({ preventScroll: true }); });
  trapFocus(drawer);
}

function closeDrawer() {
  var drawer = document.getElementById('mm-drawer');
  var scrim = document.querySelector('[data-mm-drawer-scrim]');
  var btn = document.querySelector('[data-mm-action="open-drawer"]');
  if (!drawer) return;

  var motion = drawerMotion(drawer, scrim, 'left', closeDrawer);
  var wasOpen = navDrawerOpen;
  drawer.removeAttribute('data-open');
  drawer.setAttribute('aria-hidden', 'true');
  if (scrim) scrim.removeAttribute('data-open');
  if (motion) motion.close();
  if (btn) btn.setAttribute('aria-expanded', 'false');
  if (wasOpen) unlockBodyScroll();
  navDrawerOpen = false;

  removeTrapFocus(drawer);
  if (lastFocusedDrawer) { lastFocusedDrawer.focus({ preventScroll: true }); lastFocusedDrawer = null; }
}

/* ----------------------------------------------------------
   9. FOCUS TRAP
   ---------------------------------------------------------- */
var focusTrapHandler = null;

function trapFocus(el) {
  var focusable = el.querySelectorAll(
    'a[href], button:not([disabled]), input, textarea, select, details, [tabindex]:not([tabindex="-1"])'
  );
  var first = focusable[0];
  var last = focusable[focusable.length - 1];

  removeTrapFocus(el);

  focusTrapHandler = function(e) {
    if (e.key !== 'Tab') return;
    if (e.shiftKey) {
      if (document.activeElement === first) { e.preventDefault(); last.focus(); }
    } else {
      if (document.activeElement === last) { e.preventDefault(); first.focus(); }
    }
  };

  el.addEventListener('keydown', focusTrapHandler);
}

function removeTrapFocus(el) {
  if (focusTrapHandler) {
    el.removeEventListener('keydown', focusTrapHandler);
    focusTrapHandler = null;
  }
}

/* ----------------------------------------------------------
   10. ADD TO CART
   ---------------------------------------------------------- */
async function addToCart(variantIds) {
  if (!variantIds) {
    showCartError(mmT('err_variant','Please select a variant before adding to cart.'));
    return;
  }

  var ids = String(variantIds).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
  if (!ids.length) {
    showCartError(mmT('err_variant','Please select a variant before adding to cart.'));
    return;
  }

  var body = JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) });

  // Open first, add behind it — the drawer appearing IS the click feedback.
  // Buttons on this path carry only variant ids (no title/image), so there is
  // no stand-in row; the line pops in when the reconcile lands (~one round
  // trip after the add).
  clearCartError();
  openCart();

  try {
    var res = await mmTrackAdd(fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: body
    }));

    if (!res.ok) {
      var err = await res.json();
      showCartError(err.description || mmT('err_add','Could not add item to cart. Please try again.'));
      return;
    }

    await CartState.fetch();
    clearCartError();
  } catch (e) {
    showCartError(mmT('err_net','A network error occurred. Please check your connection and try again.'));
  }
}

/* Kaching selling-plan failsafe. When the Kaching Bundles widget owns this
   buybox it maintains a `properties[__kaching_bundles]` input in the form and
   stamps the ACTIVE selling-plan id as `data-selling-plan-id` on its block
   (cleared for one-time bars — same DOM contract pdp-bundle-sub-footer relies
   on). Kaching's cart interceptor (a window.fetch patch) normally injects the
   plan + bundle components into our /cart/add.js post, but when that
   interception misses (script-load race, A/B variant re-render) the add lands
   as a bare full-price one-time line — no plan, no discount. Appending the
   stamped plan id ourselves guarantees the subscription terms and pricing
   either way; when Kaching's merge DOES run it rebuilds the items and simply
   supersedes this field. */
function mmKachingPlanFailsafe(form, fd) {
  try {
    if (!form.querySelector('[name="properties[__kaching_bundles]"]')) return;
    if (fd.get('selling_plan')) return; // widget (or its interceptor) already set it
    var el = form.querySelector('[data-selling-plan-id]') ||
             document.querySelector('.kaching-bundles__block[data-selling-plan-id]');
    var raw = el ? el.getAttribute('data-selling-plan-id') : '';
    var id = (String(raw).match(/\d{3,}/) || [''])[0];
    if (id) fd.append('selling_plan', id);
  } catch (e) { /* never block the add */ }
}

/* Post-add watchdog. Our request resolving does NOT mean the click is done —
   Kaching may still be posting the paid line from its own partial request.
   Re-check the cart a few times (most misses are just that race, and the
   next /cart.js shows the full setup); only when the paid anchor never
   arrives do we add the product ourselves. The stand-in row stays painted
   throughout, so the customer only ever sees their setup. */
var MM_ENSURE_DELAYS = [600, 1100, 1900];
function mmEnsureSetupLanded(attempt) {
  if (!mmPendingSetup || mmPendingSetup.recovered) return;
  if (!mmOrphanedGiftLines().length) return; // paid anchor landed — healthy
  if (attempt >= MM_ENSURE_DELAYS.length) { mmRecoverPaidLine(); return; }
  setTimeout(function () {
    if (!mmPendingSetup) return;
    CartState.fetch().then(function () { mmEnsureSetupLanded(attempt + 1); });
  }, MM_ENSURE_DELAYS[attempt]);
}

/* The PDP's paid variant. Kaching's product JSON is the authority when the
   widget owns the buybox — the form's `id` input can hold a $0 component
   (verified live: Welcome Kit posts the foil shaver, not the trimmer). */
function mmMainPaidVariant() {
  try {
    var prodEl = document.querySelector('.kaching-bundles-product[data-main="true"]') ||
                 document.querySelector('.kaching-bundles-product');
    if (prodEl) {
      var prod = JSON.parse(prodEl.textContent);
      var variants = prod.variants || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id === prod.selectedVariantId) return { id: variants[i].id, price: variants[i].price };
      }
      if (variants.length) return { id: variants[0].id, price: variants[0].price };
    }
  } catch (e) { /* fall through to the theme form */ }
  var form = document.querySelector('[data-mm-product-form]');
  var idInput = form ? form.querySelector('[data-mm-variant-id]') : null;
  var vid = idInput ? parseInt(idInput.value, 10) : 0;
  return vid ? { id: vid, price: parseInt(form.dataset.mmProductPrice, 10) || 0 } : null;
}

/* Last resort: the paid line never landed, so post it ourselves — a plain
   JSON add Kaching's interceptor ignores, carrying the widget's stamped
   selling plan so subscription pricing stays correct. The gifts are already
   in the cart (they're what DID land); worst case they render as their own
   rows instead of nesting, but the order is complete and checkout-able. */
function mmRecoverPaidLine() {
  // Once per click — the watchdog and the checkout gate can both get here.
  if (mmPendingSetup) {
    if (mmPendingSetup.recovered) return Promise.resolve();
    mmPendingSetup.recovered = true;
  }
  var main = mmMainPaidVariant();
  if (!main || !main.id || !(main.price > 0)) return Promise.resolve();
  var landed = CartState.items.some(function (it) {
    return it.variant_id === main.id && mmLineTotal(it) > 0;
  });
  if (landed) return Promise.resolve();
  var body = { id: main.id, quantity: 1 };
  var el = document.querySelector('[data-mm-product-form] [data-selling-plan-id], .kaching-bundles__block[data-selling-plan-id]');
  var planId = el ? (String(el.getAttribute('data-selling-plan-id') || '').match(/\d{3,}/) || [''])[0] : '';
  if (planId) body.selling_plan = planId;
  return mmTrackAdd(fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(body)
  }))
    .then(function () { return CartState.fetch(); })
    .catch(function () { /* server truth is already rendered */ });
}

/* ----------------------------------------------------------
   10x. BUY NOW — add the form's selection, then jump straight
   to checkout instead of opening the cart drawer.
   ---------------------------------------------------------- */
async function buyNow(form, btn) {
  if (form.__mmLocked) return; // an ATC submit or buy-now is already in flight
  form.__mmLocked = true;
  var labelEl = btn.querySelector('.mm-btn__label') || btn;
  var origText = labelEl.textContent;
  btn.disabled = true;
  btn.setAttribute('aria-busy', 'true');
  labelEl.textContent = 'Processing…';
  var restore = function() {
    form.__mmLocked = false;
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    labelEl.textContent = origText;
  };

  try {
    var bundleMode = form.dataset.mmBundleMode;
    var kitVariants = form.dataset.mmKitVariants;
    var res;

    if (bundleMode === 'kit' && kitVariants) {
      var ids = String(kitVariants).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
      res = await mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      }));
    } else {
      // Same purchase-mode reconcile as the ATC submit handler — guarantees
      // "one-time" never posts selling_plan and "subscribe" posts the shown plan.
      form.querySelectorAll('[data-mm-sub]').forEach(function(group) {
        mmApplySubMode(group, mmSubMode(group));
      });
      var fdBuy = new FormData(form);
      mmKachingPlanFailsafe(form, fdBuy);
      res = await mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fdBuy
      }));
    }

    if (!res.ok) {
      var err = await res.json();
      showCartError(err.description || mmT('err_checkout','Could not start checkout. Please try again.'));
      restore();
      return;
    }
    clearCartError();
    // Kaching-owned buybox: our request resolving doesn't mean the PAID line
    // landed — the widget posts it separately, and leaving now can check out
    // the gifts without the product. One round trip verifies (and recovers)
    // before we go; non-Kaching forms skip straight to checkout.
    if (form.querySelector('[name="properties[__kaching_bundles]"]')) {
      try {
        await CartState.fetch();
        if (mmOrphanedGiftLines().length) await mmRecoverPaidLine();
      } catch (e2) { /* never block checkout */ }
    }
    // Keep the button locked — we're leaving the page.
    window.location.href = '/checkout';
  } catch (e) {
    showCartError(mmT('err_net','A network error occurred. Please check your connection and try again.'));
    restore();
  }
}

/* ----------------------------------------------------------
   10a. PRODUCT FORM (real <form action="/cart/add">)
   ---------------------------------------------------------- */
function lockSubmit(form) {
  if (form.__mmLocked) return false;
  form.__mmLocked = true;
  var btn = form.querySelector('button[type="submit"], [data-mm-action="atc"]');
  if (btn) {
    btn.dataset.mmOrigText = btn.dataset.mmOrigText || (btn.querySelector('.mm-btn__label') ? btn.querySelector('.mm-btn__label').textContent : btn.textContent);
    btn.disabled = true;
    btn.setAttribute('aria-busy', 'true');
    var labelEl = btn.querySelector('.mm-btn__label') || btn;
    labelEl.textContent = 'Adding…';
  }
  return true;
}
function unlockSubmit(form) {
  form.__mmLocked = false;
  var btn = form.querySelector('button[type="submit"], [data-mm-action="atc"]');
  if (btn) {
    btn.disabled = false;
    btn.removeAttribute('aria-busy');
    if (btn.dataset.mmOrigText) {
      var labelEl = btn.querySelector('.mm-btn__label') || btn;
      labelEl.textContent = btn.dataset.mmOrigText;
    }
  }
}

/* Best-effort line data for the drawer's optimistic pending row: the currently
   selected variant from the buybox's variants JSON, falling back to the
   form's product-level data attributes (set in pdp-hero.liquid). */
function mmAtcPendingInfo(form) {
  var title = form.dataset.mmProductTitle || 'Item';
  var image = form.dataset.mmProductImage || '';
  var price = parseInt(form.dataset.mmProductPrice, 10) || 0;
  var idInput = form.querySelector('[data-mm-variant-id]');
  var vid = idInput ? parseInt(idInput.value, 10) || 0 : 0;
  var jsonScript = form.querySelector('[data-mm-variants-json]');
  if (vid && jsonScript) {
    try {
      var variants = JSON.parse(jsonScript.textContent) || [];
      for (var i = 0; i < variants.length; i++) {
        if (variants[i].id !== vid) continue;
        if (typeof variants[i].price === 'number') price = variants[i].price;
        if (variants[i].featured_image && variants[i].featured_image.src) {
          var src = variants[i].featured_image.src;
          image = src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=144';
        }
        break;
      }
    } catch (e) { /* fall back to the form-level data */ }
  }
  // The offer box's FREE rows are the visible promise of what this click
  // adds — mirror them into the stand-in so the drawer shows the whole
  // setup the same frame, gifts included. The /cart.js reconcile swaps in
  // the real line titles/images once the add lands.
  var gifts = [];
  var offer = form.querySelector('.mm-offer');
  if (offer) {
    offer.querySelectorAll('.mm-offer__item').forEach(function (row) {
      var nowEl = row.querySelector('.mm-offer__item-now');
      if (!nowEl || !/free/i.test(nowEl.textContent)) return; // paid row = the product itself
      var nameEl = row.querySelector('.mm-offer__item-name');
      var img = row.querySelector('img');
      var wasEl = row.querySelector('.mm-offer__item-was');
      gifts.push({
        title: nameEl ? nameEl.textContent.trim() : mmT('free_gift','Free gift'),
        image: img ? img.getAttribute('src') : '',
        was: wasEl ? wasEl.textContent.trim() : ''
      });
    });
  }
  return { id: vid || 'atc', title: title, image: image, price: price, gifts: gifts };
}

/* The whole ATC sequence, optimistic-first: the drawer opens with a pending
   line the same frame the customer clicks — the two network round trips
   (/cart/add.js, then the /cart.js reconcile) that used to hold the drawer
   shut for ~1s now run behind it. Failures surface inside the OPEN drawer,
   so a rejected add can never look like a dead click again. */
function handleAtcSubmit(form) {
  if (!lockSubmit(form)) return; // already in flight — ignore rage-clicks
  var bundleMode = form.dataset.mmBundleMode;
  var kitVariants = form.dataset.mmKitVariants;

  // Everything before the fetch is guarded: the submit's default action is
  // already prevented by our listener, so an exception past this point would
  // otherwise mean NO request, no error UI, and a form locked on "Adding…"
  // forever — a silently dead buy button. The optimistic chrome (pending
  // row, drawer) is cosmetic; only the fetch below must always be reached.
  var info = { id: 'atc', title: 'Item', image: '', price: 0 };
  try {
    info = mmAtcPendingInfo(form);
    clearCartError();
    if (mmTakePreOpen(form)) {
      // The tap already opened the drawer with this stand-in (mmPreOpenAtc) —
      // a second insert would read as qty 2.
      if (mmPendingSetup) mmPendingSetup.until = Date.now() + 12000;
    } else {
      // Optimism window: renderItems keeps this stand-in painted until the
      // paid line is confirmed server-side (see mmReassertPendingSetup).
      mmPendingSetup = { info: info, until: Date.now() + 12000, recovered: false };
      insertPendingLine(info);
      openCart();
    }
  } catch (e) { /* cosmetic only — the add below still runs */ }

  var addPromise;
  try {
    if (bundleMode === 'kit' && kitVariants) {
      // Kit mode: multi-add via items[]
      var ids = String(kitVariants).split(',').map(function(id) { return id.trim(); }).filter(Boolean);
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ items: ids.map(function(id) { return { id: parseInt(id, 10), quantity: 1 }; }) })
      }));
    } else {
      // Authoritative purchase-mode reconcile before we read the fields.
      // The native radio is the source of truth — it toggles even when an
      // app re-render wiped our selection listeners — so this guarantees a
      // "one-time" choice never posts `selling_plan` (no surprise
      // subscription) and "subscribe" posts the currently shown plan.
      form.querySelectorAll('[data-mm-sub]').forEach(function(group) {
        mmApplySubMode(group, mmSubMode(group));
      });
      var fdAtc = new FormData(form);
      mmKachingPlanFailsafe(form, fdAtc);
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: fdAtc
      }));
    }
  } catch (e) {
    // Prep failed (e.g. an app re-render mid-click) — post the raw form
    // as-is rather than stranding the customer with a dead button.
    try {
      addPromise = mmTrackAdd(fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Accept': 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
        body: new FormData(form)
      }));
    } catch (e2) {
      mmPendingSetup = null;
      removePendingLine(info.id);
      showCartError(mmT('err_add','Could not add item to cart. Please try again.'));
      unlockSubmit(form);
      return;
    }
  }

  addPromise
    .then(function(res) {
      if (!res.ok) {
        return res.json().catch(function() { return {}; }).then(function(err) {
          throw new Error(err.description || mmT('err_add','Could not add item to cart. Please try again.'));
        });
      }
      // The refetch re-renders the list; the stand-in stays painted until
      // the paid line is confirmed, then the watchdog stands down.
      return CartState.fetch().then(clearCartError).then(function() { mmEnsureSetupLanded(0); });
    })
    .catch(function(err) {
      mmPendingSetup = null;
      removePendingLine(info.id);
      showCartError((err && err.message) || 'A network error occurred. Please check your connection and try again.');
      // Reconcile empty state / totals from server truth.
      CartState.fetch();
    })
    .then(function() { unlockSubmit(form); });
}

/* Open the drawer on the TAP, not the submit. Kaching's bundle widget holds
   the buy button's click in a capture listener of its own and only lets the
   form submit ~0.75s later (measured on live, mobile, 2026-10-15 — the main
   thread is idle the whole time). This document-capture listener runs before
   the button's own listeners, so the drawer + stand-in line paint the instant
   the finger lifts; handleAtcSubmit then only posts the add when the submit
   arrives. If no submit follows (the widget cancelled it, invalid form), the
   stand-in is withdrawn and the drawer re-synced from the server after 8s. */
var MM_PREOPEN_MS = 8000;
function mmTakePreOpen(form) {
  var fresh = !!(form.__mmPreOpen && Date.now() - form.__mmPreOpen < MM_PREOPEN_MS);
  form.__mmPreOpen = 0;
  return fresh;
}
function mmPreOpenAtc(form) {
  if (form.__mmLocked) return;                       // an add is already running
  if (form.__mmPreOpen && Date.now() - form.__mmPreOpen < MM_PREOPEN_MS) return; // double tap
  var stamp = form.__mmPreOpen = Date.now();
  var info;
  try {
    info = mmAtcPendingInfo(form);
    clearCartError();
    mmPendingSetup = { info: info, until: Date.now() + 12000, recovered: false };
    insertPendingLine(info);
    openCart();
  } catch (e) { form.__mmPreOpen = 0; return; }
  setTimeout(function () {
    if (form.__mmPreOpen !== stamp) return;          // the submit arrived and took over
    form.__mmPreOpen = 0;
    if (mmPendingSetup && mmPendingSetup.info === info) mmPendingSetup = null;
    removePendingLine(info.id);
    CartState.fetch();
  }, MM_PREOPEN_MS);
}
document.addEventListener('click', function (e) {
  if (!window.__mmAtcReady || e.button > 0 || !e.target.closest) return; // pre-boot taps: inline buffer
  var btn = e.target.closest('button[type="submit"], [data-mm-action="atc"]');
  if (!btn || btn.disabled) return;
  var form = btn.form || btn.closest('form');
  if (!form || !form.hasAttribute('data-mm-product-form')) return;
  if (btn.closest('[data-mm-action="buy-now"]') || btn.getAttribute('data-mm-action') === 'buy-now') return;
  mmPreOpenAtc(form);
}, true);

function initProductForms() {
  document.querySelectorAll('[data-mm-product-form]').forEach(function(form) {
    // Marks the node as having a live submit listener. Apps (Kaching etc.)
    // sometimes re-render the buybox and replace the form node — the clone
    // loses this flag along with the listener, and the document-level backup
    // click handler below takes over. See initWidgetLift for prior art on
    // app re-renders wiping per-node listeners.
    form.__mmWired = true;
    form.addEventListener('submit', function(e) {
      e.preventDefault();
      handleAtcSubmit(form);
    });
  });
}

/* Backup path for the "first click did nothing" failure: if the click's form
   is not wired (node replaced after boot), run the handler directly. Wired
   forms fall through to their own submit event so nothing runs twice. */
document.addEventListener('click', function(e) {
  var btn = e.target.closest('button[type="submit"], [data-mm-action="atc"]');
  if (!btn) return;
  var form = btn.form || btn.closest('form');
  if (!form || !form.hasAttribute('data-mm-product-form')) return;
  if (form.__mmWired) return;
  e.preventDefault();
  handleAtcSubmit(form);
});

/* Safety net: any other form posting to /cart/add (an app widget, a future
   section) goes through the drawer too, so a native post can't land on /cart.
   Left alone: forms an app already handled, and buy-now style submits that
   are meant to leave the page. */
document.addEventListener('submit', function(e) {
  var form = e.target;
  if (e.defaultPrevented || !form.matches('form[action*="/cart/add"]')) return;
  if (form.hasAttribute('data-mm-product-form')) return;
  if (form.querySelector('[name="return_to"]')) return;
  var sub = e.submitter;
  if (sub && (sub.name === 'checkout' || sub.getAttribute('data-mm-action') === 'buy-now')) return;
  e.preventDefault();
  handleAtcSubmit(form);
});

/* ----------------------------------------------------------
   10b. VARIANT PICKER — match selected options to a variant
   ---------------------------------------------------------- */
function initVariantPickers() {
  document.querySelectorAll('[data-mm-product-form]').forEach(function(form) {
    var jsonScript = form.querySelector('[data-mm-variants-json]');
    var hiddenId = form.querySelector('[data-mm-variant-id]');
    if (!jsonScript || !hiddenId) return;

    var variants;
    try { variants = JSON.parse(jsonScript.textContent); } catch (e) { return; }

    var optionInputs = Array.from(form.querySelectorAll('[data-mm-option-input]'));
    if (!optionInputs.length) return;

    // Variant-value → image-override map (built from <variant_image> blocks)
    var imageOverrides = [];
    var overridesScript = form.querySelector('[data-mm-variant-image-overrides]');
    if (overridesScript) {
      try { imageOverrides = JSON.parse(overridesScript.textContent) || []; } catch (e) { imageOverrides = []; }
    }
    // Cache original src so we can revert when the merchant doesn't define an override for the selected value
    var imageTargets = Array.from(form.querySelectorAll('[data-mm-variant-image-target]'));
    imageTargets.forEach(function(img) {
      if (!img.dataset.mmVariantImageOriginal) img.dataset.mmVariantImageOriginal = img.getAttribute('src') || '';
    });

    function currentSelection() {
      var groups = {};
      optionInputs.forEach(function(input) {
        // Selects always contribute their value; radios only when checked.
        if (input.tagName !== 'SELECT' && !input.checked) return;
        var i = input.dataset.mmOptionInput;
        groups[i] = input.value;
      });
      // Build ordered array based on option index
      var keys = Object.keys(groups).sort(function(a,b){ return parseInt(a,10) - parseInt(b,10); });
      return keys.map(function(k) { return groups[k]; });
    }

    function variantOpts(v) {
      if (Array.isArray(v.options)) return v.options;
      return [v.option1, v.option2, v.option3].filter(function(x){ return x != null; });
    }

    function update() {
      var sel = currentSelection();
      var match = variants.find(function(v) {
        var vo = variantOpts(v);
        return vo.length === sel.length && vo.every(function(opt, i) { return opt === sel[i]; });
      });
      if (!match) return;

      hiddenId.value = match.id;

      // Update displayed option labels
      form.querySelectorAll('[data-mm-option-display]').forEach(function(el) {
        var idx = parseInt(el.dataset.mmOptionDisplay, 10);
        if (sel[idx] != null) el.textContent = sel[idx];
      });

      // Update price + sticky atc price if the price changed
      var priceEls = document.querySelectorAll('[data-mm-live-price], .mm-offer__price, .mm-sticky-atc__price');
      if (match.price != null) {
        priceEls.forEach(function(el) { el.textContent = formatMoney(match.price); });
      }
      var wasEls = document.querySelectorAll('.mm-offer__was');
      if (match.compare_at_price && match.compare_at_price > match.price) {
        wasEls.forEach(function(el) { el.textContent = formatMoney(match.compare_at_price); el.hidden = false; });
      } else {
        wasEls.forEach(function(el) { el.hidden = true; });
      }

      // Variant-image override — match any selected option value against the merchant's overrides
      if (imageOverrides.length && imageTargets.length) {
        var overrideSrc = null;
        for (var i = 0; i < sel.length && !overrideSrc; i++) {
          var found = imageOverrides.find(function(o) { return o.value === sel[i]; });
          if (found) overrideSrc = found.src;
        }
        imageTargets.forEach(function(img) {
          var newSrc = overrideSrc || img.dataset.mmVariantImageOriginal;
          if (newSrc && img.getAttribute('src') !== newSrc) img.setAttribute('src', newSrc);
        });
      }
    }

    optionInputs.forEach(function(input) { input.addEventListener('change', update); });
    update();
  });
}

/* ----------------------------------------------------------
   10c. UPSELL QUICK-ADD
   ---------------------------------------------------------- */
async function applyPromoCode() {
  var input = document.querySelector('[data-mm-promo-input]');
  var msg   = document.querySelector('[data-mm-promo-msg]');
  if (!input || !input.value.trim()) return;
  var code = input.value.trim();
  if (msg) { msg.hidden = true; msg.removeAttribute('data-state'); }
  try {
    // Shopify natively applies discounts via /discount/<code> redirect.
    // Persist to a cart attribute so it survives drawer navigation.
    await fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ attributes: { 'discount_code': code } })
    });
    if (msg) {
      msg.textContent = 'Code saved — applied at checkout.';
      msg.removeAttribute('data-state');
      msg.hidden = false;
    }
  } catch (e) {
    if (msg) {
      msg.textContent = mmT('err_code','Could not apply code. Please try again.');
      msg.setAttribute('data-state', 'error');
      msg.hidden = false;
    }
  }
}

/* Stand-in cart row so an added item appears in the list the instant it is
   requested — before /cart/add.js returns. renderItems() clears every
   .mm-cart__item before re-inserting, so the stand-in removes itself as soon
   as the real /cart.js line arrives. info: { id, title, image, price }. */
function insertPendingLine(info) {
  var container = document.getElementById('mm-cart-items');
  if (!container) return;
  var title = info.title || 'Item';
  var price = info.price || 0;
  // A second add before the server reconciles bumps the stand-in's quantity
  // instead of stacking a duplicate row (both adds still reach the server,
  // which merges them into one line).
  var pending = container.querySelector('.mm-cart__item[data-key="pending-' + info.id + '"]');
  if (pending) {
    var pendingQty = pending.querySelector('.mm-cart__qty-val');
    if (pendingQty) pendingQty.textContent = (parseInt(pendingQty.textContent, 10) || 1) + 1;
    return;
  }
  var media = info.image
    ? '<img class="mm-cart__item-img" src="' + info.image + '" alt="' + escapeHtml(title) + '" width="72" height="72" loading="lazy">'
    : '<div class="mm-cart__item-img mm-ph" data-label="ITEM"></div>';
  // Free gifts render in the exact markup renderBundleGifts uses for the
  // real lines, so the stand-in → server swap is visually seamless.
  var giftsHtml = '';
  if (info.gifts && info.gifts.length) {
    var glabel = info.gifts.length === 1 ? mmT('gift_one','Your free gift') : mmT('gift_many','Your {n} free gifts').replace('{n}', info.gifts.length);
    giftsHtml = '<ul class="mm-cart__gifts" role="list">' +
      '<li class="mm-cart__gifts-label" aria-hidden="true">' + glabel + '</li>' +
      info.gifts.map(function (g) {
        var gmedia = g.image
          ? '<img class="mm-cart__gift-img" src="' + g.image + '" alt="" width="32" height="32" loading="lazy">'
          : '<span class="mm-cart__gift-img mm-cart__gift-img--ph" aria-hidden="true"></span>';
        return '<li class="mm-cart__gift">' +
            gmedia +
            '<span class="mm-cart__gift-meta"><span class="mm-cart__gift-name">' + escapeHtml(g.title) + '</span></span>' +
            '<span class="mm-cart__gift-price">' +
              (g.was ? '<span class="mm-cart__gift-was">' + escapeHtml(g.was) + '</span>' : '') +
              '<span class="mm-cart__gift-free">Free</span>' +
            '</span>' +
          '</li>';
      }).join('') +
    '</ul>';
  }
  // info.was (the card's compare-at): the same Save chip and struck price the
  // real row carries, so the row is already full height when /cart.js lands.
  var was = info.was > price ? info.was : 0;
  var cartEl = document.getElementById('mm-cart');
  var stacked = was && !(cartEl && cartEl.dataset.savingsMode === 'off');
  var html = '<div class="mm-cart__item mm-cart__item--pending" data-key="pending-' + info.id + '">' +
    media +
    '<div class="mm-cart__item-meta">' +
      (was ? '<span class="mm-cart__item-save">Save ' + mmDiscountMoney(mmSaveRound(was - price)) + '</span>' : '') +
      '<div class="mm-cart__item-name">' + escapeHtml(title) + '</div>' +
      '<div class="mm-cart__item-qty" role="group" aria-label="' + mmT('quantity','Quantity') + '">' +
        '<span class="mm-cart__qty-val">1</span>' +
      '</div>' +
    '</div>' +
    (stacked
      ? '<div class="mm-cart__item-price mm-cart__item-price--stacked"><span class="mm-cart__item-was">' + formatMoney(was) + '</span><span class="mm-cart__item-now">' + formatMoney(price) + '</span></div>'
      : '<div class="mm-cart__item-price">' + formatMoney(price) + '</div>') +
    giftsHtml +
  '</div>';
  var empty = document.getElementById('mm-cart-empty');
  if (empty) empty.hidden = true;
  container.insertAdjacentHTML('afterbegin', html);
  // Optimistic money: bump the visible total and progress bars now; the
  // /cart.js reconcile overwrites them with server truth moments later.
  var optimistic = CartState.subtotal + price;
  var footer = document.getElementById('mm-cart-footer');
  if (footer) footer.hidden = false;
  var subtotalEl = document.getElementById('mm-cart-subtotal');
  if (subtotalEl) subtotalEl.textContent = formatMoney(optimistic);
  patchShippingBarOptimistic(optimistic);
  patchGiftBarOptimistic(optimistic);
  // "You save" pill + "Discounts applied" note come up with the row, not a
  // beat later when the server copy arrives.
  if (was) {
    renderCartSavings(CartState.items.concat([{ quantity: 1, price: price, final_line_price: price, original_line_price: was, variant_id: info.id }]));
  }
}

function removePendingLine(id) {
  var row = document.querySelector('.mm-cart__item[data-key="pending-' + id + '"]');
  if (row) row.remove();
}

/* ---- Hold the drawer still while an add lands -----------------------------
   An add from inside the open drawer changes a lot ABOVE the card that was
   tapped: the empty message gives way to a line, an inline upgrade can
   appear, the shelf gains its header. For a few seconds after the tap, every
   frame scrolls the list by however far that card moved, so it stays under
   the finger (Safari has no CSS scroll anchoring; Chrome's skips a list
   sitting at the top). If the footer comes up over it, the card is lifted
   just clear. Any scroll gesture hands control straight back. Once the add
   is confirmed the card folds out of the shelf (mmFoldCard) and the hold
   passes to the card that slides into its spot. */
var mmHold = null;
function mmHoldCard(card) {
  var list = document.getElementById('mm-cart-items');
  if (!card || !list || !cartDrawerOpen || !list.contains(card)) return;
  card.setAttribute('data-mm-added', '');
  var running = !!mmHold;
  mmHold = { card: card, list: list, top: card.getBoundingClientRect().top, until: Date.now() + 3000 };
  if (!list.__mmHoldWired) {
    list.__mmHoldWired = true;
    var release = function() { mmHold = null; };
    ['wheel', 'touchmove', 'keydown'].forEach(function(ev) { list.addEventListener(ev, release, { passive: true }); });
  }
  if (!running) requestAnimationFrame(mmHoldTick);
}
function mmHoldTick() {
  var h = mmHold;
  if (!h) return;
  if (!cartDrawerOpen || !h.card.isConnected || h.card.hidden || Date.now() > h.until) { mmHold = null; return; }
  var lr = h.list.getBoundingClientRect();
  var cr = h.card.getBoundingClientRect();
  var footer = document.getElementById('mm-cart-footer');
  var floor = (footer && !footer.hidden) ? Math.min(lr.bottom, footer.getBoundingClientRect().top) : lr.bottom;
  var want = Math.max(lr.top, Math.min(h.top, floor - cr.height - 8));
  var d = cr.top - want;
  if (Math.abs(d) >= 1) {
    h.list.scrollTop += d;
    // The list couldn't scroll that far (already at its top): the card
    // settles where it landed rather than being pulled back by a later change.
    var miss = h.card.getBoundingClientRect().top - want;
    if (Math.abs(miss) >= 1 && want === h.top) h.top += miss;
  }
  requestAnimationFrame(mmHoldTick);
}
// The hydrate re-render (Save chips) lands after the reconcile; keep holding through it.
document.addEventListener('mm:cart:updated', function() {
  if (mmHold) mmHold.until = Math.max(mmHold.until, Date.now() + 1500);
});

/* ---- Slide open / closed ---------------------------------------------------
   mmFold slides a block shut along its parent's main axis (down a stacked
   list, or across a sideways rail): it shrinks and fades in place while its
   neighbours close up, then done(savedStyle) hides or drops it. The trailing
   margin eats the list gap, so the final hide doesn't nudge anything.
   mmUnfold is the reverse for a block that is about to show. Reduced motion
   skips straight to the end state. */
var MM_FOLD_MS = 280;
function mmReducedMotion() {
  return !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
}
function mmFoldAxis(el) {
  var ps = getComputedStyle(el.parentNode);
  var row = ps.display.indexOf('flex') > -1 && ps.flexDirection.indexOf('row') === 0;
  return { row: row, gap: parseFloat(row ? ps.columnGap : ps.rowGap) || 0 };
}
// Collapsed (or, with `to`, natural) values for the axis-specific properties.
function mmFoldProps(ax, size, cs) {
  var p = {};
  if (ax.row) {
    p.width = size; p.paddingLeft = cs ? cs.paddingLeft : '0px'; p.paddingRight = cs ? cs.paddingRight : '0px';
    p.borderLeftWidth = cs ? cs.borderLeftWidth : '0px'; p.borderRightWidth = cs ? cs.borderRightWidth : '0px';
    p.marginLeft = cs ? cs.marginLeft : '0px'; p.marginRight = cs ? cs.marginRight : (-ax.gap) + 'px';
  } else {
    p.height = size; p.paddingTop = cs ? cs.paddingTop : '0px'; p.paddingBottom = cs ? cs.paddingBottom : '0px';
    p.borderTopWidth = cs ? cs.borderTopWidth : '0px'; p.borderBottomWidth = cs ? cs.borderBottomWidth : '0px';
    p.marginTop = cs ? cs.marginTop : '0px'; p.marginBottom = cs ? cs.marginBottom : (-ax.gap) + 'px';
  }
  return p;
}
function mmFoldBase(el, ax) {
  var s = el.style;
  s.overflow = 'hidden';
  s.boxSizing = 'border-box';
  s.flex = '0 0 auto';
  if (ax.row) s.minWidth = '0'; else s.minHeight = '0';
}
var MM_FOLD_TRANSITION = 'height .28s ease, width .28s ease, padding .28s ease, margin .28s ease, border-width .28s ease, opacity .2s ease';
function mmFold(el, done) {
  if (el.__mmFold) return;
  el.__mmFold = true;
  var saved = el.style.cssText;
  var end = function() { el.__mmFold = false; done(saved); };
  if (mmReducedMotion()) { end(); return; }
  var ax = mmFoldAxis(el);
  var r = el.getBoundingClientRect();
  mmFoldBase(el, ax);
  el.style[ax.row ? 'width' : 'height'] = (ax.row ? r.width : r.height) + 'px';
  void el.offsetWidth;
  el.style.transition = MM_FOLD_TRANSITION;
  el.style.opacity = '0';
  var to = mmFoldProps(ax, '0px');
  for (var k in to) el.style[k] = to[k];
  setTimeout(end, MM_FOLD_MS + 20);
}
function mmUnfold(el) {
  el.hidden = false;
  if (mmReducedMotion() || el.__mmFold) return;
  var saved = el.style.cssText;
  var ax = mmFoldAxis(el);
  var r = el.getBoundingClientRect();
  var cs = getComputedStyle(el);
  var to = mmFoldProps(ax, (ax.row ? r.width : r.height) + 'px', cs);
  mmFoldBase(el, ax);
  el.style.opacity = '0';
  var from = mmFoldProps(ax, '0px');
  for (var k in from) el.style[k] = from[k];
  void el.offsetWidth;
  el.style.transition = MM_FOLD_TRANSITION;
  el.style.opacity = '1';
  for (var j in to) el.style[j] = to[j];
  setTimeout(function() { el.style.cssText = saved; }, MM_FOLD_MS + 20);
}

/* An added card leaves the shelf by folding (its top edge stays put, so the
   hold keeps it still); then it hides for real and the hold moves to
   whichever card slid into its spot. */
function mmFoldCard(card) {
  mmFold(card, function(saved) {
    card.removeAttribute('data-mm-added');
    card.style.cssText = saved;
    card.hidden = true;
    if (mmHold && mmHold.card === card) {
      var next = mmShelfNeighbour(card);
      if (next) {
        mmHold.card = next;
        mmHold.top = next.getBoundingClientRect().top;
        mmHold.until = Math.max(mmHold.until, Date.now() + 1000);
      } else {
        mmHold = null;
      }
    }
    syncAddonsShelf();
  });
}

/* Whatever renderItems changes in one go above the add-ons shelf (the shelf
   losing its band and header on an empty cart) would make it jump; instead
   it glides from where it was to where it lands. Folds/unfolds already slide
   on their own, and an add has the hold, so this stands down for those. */
function mmShelfFlipStart() {
  if (!cartDrawerOpen || mmHold || mmReducedMotion()) return null;
  var wrap = document.querySelector('[data-mm-addons]');
  if (!wrap || wrap.hidden) return null;
  var cards = Array.prototype.filter.call(wrap.querySelectorAll('.mm-cart__addon'), function(c) {
    return !c.hidden && !c.__mmFold;
  });
  var empty = document.getElementById('mm-cart-empty');
  return {
    wrap: wrap,
    cards: cards,
    tops: cards.map(function(c) { return c.getBoundingClientRect().top; }),
    emptyHidden: !!(empty && empty.hidden)
  };
}
function mmShelfFlipEnd(f) {
  if (!f) return;
  // The empty message (last line just removed) slides open rather than
  // shoving everything under it down in one frame. Before measuring, so the
  // glide below only covers the shelf's restyle.
  var empty = document.getElementById('mm-cart-empty');
  if (empty && f.emptyHidden && !empty.hidden) mmUnfold(empty);
  if (f.wrap.hidden) return;
  for (var i = 0; i < f.cards.length; i++) {
    var c = f.cards[i];
    if (c.hidden || !c.isConnected || c.__mmFold) continue;
    var d = f.tops[i] - c.getBoundingClientRect().top;
    if (Math.abs(d) < 1) return;
    var s = f.wrap.style;
    s.transition = 'none';
    s.transform = 'translateY(' + Math.round(d) + 'px)';
    void f.wrap.offsetWidth;
    s.transition = 'transform .28s ease';
    s.transform = '';
    setTimeout(function() { if (!s.transform) s.transition = ''; }, MM_FOLD_MS + 40);
    return;
  }
}
function mmShelfNeighbour(card) {
  var n;
  for (n = card.nextElementSibling; n; n = n.nextElementSibling) {
    if (n.classList.contains('mm-cart__addon') && !n.hidden) return n;
  }
  for (n = card.previousElementSibling; n; n = n.previousElementSibling) {
    if (n.classList.contains('mm-cart__addon') && !n.hidden) return n;
  }
  return null;
}

/* Optimistic quick-add: the UI confirms instantly — "✓ Added" on the button
   and the line appearing in the cart — while the network request runs behind
   it and /cart.js reconciles the real state. No spinners, no waiting. */
function quickAddToCart(button) {
  // Re-entry guard: the 1.6s "✓ Added" state doubles as the lockout window.
  if (button.dataset.mmBusy === '1') return;
  var id = button.dataset.variant;
  if (!id) return;
  var idNum = parseInt(id, 10);
  // Subscription add-on cards (pdp-cart-addon-card, subscribe: true) carry
  // the plan to add on; everything else is a one-time add.
  var planNum = parseInt(button.dataset.sellingPlan, 10) || 0;

  // Capture original label exactly once and stash on the element so repeated
  // clicks during the "Added" state can't overwrite it.
  if (!button.dataset.mmOrigLabel) {
    button.dataset.mmOrigLabel = button.textContent.trim();
  }
  // Markup too: shelf buttons carry an icon (pdp-cart-addon-card), which a
  // textContent restore would drop.
  var origHtml = button.__mmOrigHtml || (button.__mmOrigHtml = button.innerHTML);

  button.dataset.mmBusy = '1';
  button.setAttribute('data-added', '');
  button.textContent = '✓ Added';
  var restore = function(errState) {
    button.innerHTML = origHtml;
    button.dataset.mmBusy = '';
    button.removeAttribute('data-added');
    if (errState) {
      button.setAttribute('data-error', '');
      button.textContent = 'Error';
      setTimeout(function() {
        button.removeAttribute('data-error');
        button.innerHTML = origHtml;
      }, 1500);
    }
  };
  setTimeout(function() {
    if (button.dataset.mmBusy === '1') restore(false);
  }, 1600);

  // The card this add came from: the button's own, or the one the peek
  // popup was opened from. A drawer shelf card holds the drawer still.
  var srcCard = button.closest('.mm-cart__addon, .mm-pcar__card') ||
    (button.hasAttribute('data-mm-apk-add') ? AddonPeek.card : null);
  if (srcCard && srcCard.classList.contains('mm-cart__addon')) mmHoldCard(srcCard);

  // If this variant is already in the cart, bump its quantity instead of
  // letting Shopify create a second card. We merge even into lines with
  // tracking properties (e.g. __kaching_bundles) — those mark the same
  // product, not an add-on. Add-on lines like shipping protection live on
  // a different variant so the variant_id check alone keeps us out of them.
  // Two exceptions: never bump a selling-plan line from a one-time upsell
  // add, and never bump a $0 bundle component — that line belongs to the
  // bundle (it leaves the cart with its trimmer), so an explicit add of the
  // same accessory gets its own ordinary line instead.
  // A subscription add mirrors that: it only bumps a line on the SAME plan
  // that isn't part of a Kaching bundle (a bundle's sub component belongs
  // to its trimmer).
  var existing = null;
  for (var i = 0; i < CartState.items.length; i++) {
    var it = CartState.items[i];
    if (it.variant_id !== idNum) continue;
    var itKb = parseKachingBundle(it);
    if (planNum) {
      var itSpa = it.selling_plan_allocation;
      if (!itSpa || !itSpa.selling_plan || itSpa.selling_plan.id !== planNum) continue;
      if (itKb) continue;
    } else {
      if (it.selling_plan_allocation) continue;
      if (itKb && itKb.id && mmLineTotal(it) === 0) continue;
    }
    existing = it;
    break;
  }

  if (existing) {
    // The qty pipeline is already fully optimistic (instant DOM patch,
    // debounced /cart/change.js flush, /cart.js reconcile).
    updateCartQty(existing.key, 1);
    return;
  }

  // The card's compare-at (one-time adds of that same variant only) gives the
  // stand-in its Save chip, and seeds the cache the real row reads, so the
  // row doesn't wait on hydrateVariantComparePrices' fetch to grow the chip.
  var addPrice = parseInt(button.dataset.price, 10) || 0;
  var addWas = 0;
  if (!planNum && srcCard && parseInt(srcCard.dataset.variant, 10) === idNum) {
    addWas = parseInt(srcCard.dataset.compare, 10) || 0;
    if (addWas > addPrice && variantComparePriceCache[idNum] === undefined) variantComparePriceCache[idNum] = addWas;
  }
  insertPendingLine({
    id: idNum,
    title: button.dataset.title,
    image: button.dataset.image,
    price: addPrice,
    was: addWas
  });
  var addBody = { id: idNum, quantity: 1 };
  if (planNum) addBody.selling_plan = planNum;
  mmTrackAdd(fetch('/cart/add.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
    body: JSON.stringify(addBody)
  }))
    .then(function(res) {
      if (!res.ok) throw new Error('add failed');
      // The refetch re-renders the list, replacing the stand-in row.
      return CartState.fetch();
    })
    .catch(function() {
      removePendingLine(idNum);
      restore(true);
      showCartError('Couldn’t add that item — please try again.');
      // Reconcile empty state / totals from server truth.
      CartState.fetch();
    });
}

/* The add-on card renders the variant's Liquid price, but app / automatic
   discounts only exist on cart lines. Once the variant is in the cart, its
   discount-aware unit price is authoritative — mirror it onto the card so the
   add-on never advertises more than the cart actually charges, and strike the
   base price through as the markdown anchor. */
function syncAddonPricesFromCart() {
  document.querySelectorAll('[data-mm-addon-price]').forEach(function(el) {
    var vid = parseInt(el.dataset.variant, 10);
    var base = parseInt(el.dataset.base, 10) || 0;
    var line = null;
    for (var i = 0; i < CartState.items.length; i++) {
      var it = CartState.items[i];
      if (it.variant_id !== vid || it.selling_plan_allocation) continue;
      line = it;
      break;
    }
    if (!line || !line.quantity) return;
    var unit = (typeof line.final_line_price === 'number')
      ? Math.round(line.final_line_price / line.quantity)
      : line.price;
    if (!(unit > 0) || unit >= base) return;
    var now = el.querySelector('.mm-cart__addon-now');
    if (now) now.textContent = formatMoney(unit);
    if (!el.querySelector('.mm-cart__addon-was')) {
      el.insertAdjacentHTML('beforeend', '<s class="mm-cart__addon-was">' + formatMoney(base) + '</s>');
    }
  });
}
document.addEventListener('mm:cart:updated', syncAddonPricesFromCart);

/* ----------------------------------------------------------
   ADD-ON PEEK — product popup from the cart add-ons carousel
   ----------------------------------------------------------
   Clicking an add-on card opens one reusable shell (#mm-addon-peek) filled
   from the clicked card, so every product works with zero per-product setup:

     card dataset → title, price, link, Add button payload (instant)
     {url}.js     → the gallery images, in PDP order (~4KB, lands first)
     {url}        → the product page, whose .mm-buybox__bullet nodes ARE the
                    Benefit Bullet blocks from that product's hero buybox

   Benefit bullets are section-block settings inside each product's own
   template, which Liquid in the drawer cannot reach and the Section Rendering
   API cannot serve — ?section_id= needs the template-scoped id
   (template--<id>__hero), which is unknowable from here. Parsing the page is
   the only source of truth, so it's paid once per product: prefetched on
   hover/touch, kept in memory, and mirrored into sessionStorage so the rest
   of the session is free.

   The popup paints from the dataset in the same frame as the click and swaps
   the fetched gallery and bullets in when they land — nothing waits on the
   network. A product with no bullets on its page (e.g. one on the default
   product template) simply shows images and no bullet list. */
var AddonPeek = {
  cache: {},      // product url → in-flight or settled Promise<{images,bullets}>
  card: null,     // the card the open popup belongs to
  open: false,
  lastFocus: null,
  hideTimer: null,
  trap: null
};

function peekWidth(src, w) {
  if (!src) return src;
  // The desktop popup shows these up to 900px square, so 900 would go soft on hi-dpi.
  if (!w) w = window.matchMedia('(min-width: 1024px)').matches ? 1600 : 900;
  return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=' + w;
}

/* The page is parsed, never injected — only textContent crosses over, so a
   product title or bullet can't smuggle markup into the drawer. DOMParser
   builds an inert document, so none of the page's own images or scripts load. */
function parseHeroBullets(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nodes = doc.querySelectorAll('.mm-buybox__bullet');
    for (var i = 0; i < nodes.length && out.length < 6; i++) {
      var node = nodes[i].cloneNode(true);
      // Drop the icon first: built-in icons are <svg>, but Google Material
      // Symbols render as a <span> whose text is the ligature name ("check"),
      // which would otherwise land in the copy.
      node.querySelectorAll('svg, .mm-icon--google').forEach(function(icon) { icon.remove(); });
      var text = (node.textContent || '').replace(/\s+/g, ' ').trim();
      // A hero can render the buybox twice (mobile + desktop); keep one of each.
      if (text && out.indexOf(text) === -1) out.push(text);
    }
  } catch (err) { /* malformed section HTML — fall through with what we have */ }
  return out;
}

function parseDescriptionBullets(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var items = doc.querySelectorAll('li');
    for (var i = 0; i < items.length && out.length < 6; i++) {
      var text = (items[i].textContent || '').replace(/\s+/g, ' ').trim();
      // Long prose in a description list reads as a paragraph, not a benefit.
      if (text && text.length <= 90 && out.indexOf(text) === -1) out.push(text);
    }
  } catch (err) { /* malformed description — fall through */ }
  return out;
}

/* v2: entries gained `offers` (Kaching deals parsed off the product page) —
   the bump invalidates v1 sessions that would otherwise never show them. */
var PEEK_STORE_KEY = 'mm-addon-peek-v2';

/* The target product's own Kaching Bundles deals, read from the same fetched
   PDP HTML the bullets come from. Kaching server-renders its deal config as
   JSON script tags into the page, and DOMParser documents are inert, so the
   JSON is readable without running any of the page's scripts. Same math as
   mmKachingDeal() above, but listing every bar — these are the "offers" the
   popup surfaces. They only apply through the product's own PDP widget
   (Kaching skips plain cart adds), so they render as informational rows, not
   as the popup's price. */
function parsePeekOffers(html) {
  var out = [];
  if (!html) return out;
  try {
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var prodEl = doc.querySelector('.kaching-bundles-product[data-main="true"]') ||
                 doc.querySelector('.kaching-bundles-product');
    if (!prodEl) return out;
    var dealEl = doc.querySelector(
      '.kaching-bundles-deal-block-settings[data-product-id="' + prodEl.getAttribute('data-product-id') + '"]'
    ) || doc.querySelector('.kaching-bundles-deal-block-settings');
    if (!dealEl) return out;

    var prod = JSON.parse(prodEl.textContent);
    var cfg = JSON.parse(dealEl.textContent);

    var unit = 0;
    var variants = prod.variants || [];
    for (var j = 0; j < variants.length; j++) {
      if (variants[j].id === prod.selectedVariantId) { unit = variants[j].price; break; }
    }
    if (!unit && variants.length) unit = variants[0].price;
    if (!unit) return out;

    (cfg.dealBars || []).forEach(function(bar) {
      var qty = bar.quantity || 1;
      var orig = unit * qty;
      var save = 0;
      if (bar.discountType === 'specific') {
        save = orig - Math.round(bar.discountValue * 100); // discountValue = deal price in dollars
      } else if (bar.discountType === 'percentage') {
        save = Math.round(orig * bar.discountValue / 100);
      } else if (bar.discountType === 'amount' || bar.discountType === 'fixed') {
        save = Math.round(bar.discountValue * 100);
      }
      if (save <= 0 || save >= orig) return;
      var title = (typeof bar.title === 'string' && bar.title) ||
                  (typeof bar.name === 'string' && bar.name) ||
                  ('Buy ' + qty);
      out.push({ title: title, qty: qty, price: orig - save, orig: orig, save: save });
    });
  } catch (err) { /* no Kaching on that page — nothing to offer */ }
  return out.slice(0, 4);
}

function readPeekStore() {
  try { return JSON.parse(sessionStorage.getItem(PEEK_STORE_KEY)) || {}; }
  catch (err) { return {}; }
}

function writePeekStore(url, data) {
  try {
    var all = readPeekStore();
    all[url] = data;
    sessionStorage.setItem(PEEK_STORE_KEY, JSON.stringify(all));
  } catch (err) { /* private mode / quota — the in-memory cache still holds */ }
}

function fetchPeekData(url) {
  if (AddonPeek.cache[url]) return AddonPeek.cache[url];

  var stored = readPeekStore()[url];
  if (stored) {
    AddonPeek.cache[url] = Promise.resolve(stored);
    return AddonPeek.cache[url];
  }

  var images = fetch(url + '.js', { headers: { 'Accept': 'application/json' } })
    .then(function(res) { return res.ok ? res.json() : null; })
    .catch(function() { return null; });
  var page = fetch(url, { headers: { 'Accept': 'text/html' } })
    .then(function(res) { return res.ok ? res.text() : ''; })
    .catch(function() { return ''; });

  // Cache the promise, not the result: two fast clicks share one round trip.
  AddonPeek.cache[url] = Promise.all([images, page]).then(function(res) {
    var product = res[0] || {};
    // Products on the default product template have no hero buybox to read;
    // their description's list items are the next-best benefit copy, and cost
    // nothing extra — the description rides along in the .js payload.
    var bullets = parseHeroBullets(res[1]);
    if (!bullets.length) bullets = parseDescriptionBullets(product.description);
    // Compare-at per variant, so the popup can strike a markdown through even
    // when the card was rendered before one was set.
    var compare = {};
    (product.variants || []).forEach(function(v) {
      if (v && v.compare_at_price > v.price) compare[v.id] = v.compare_at_price;
    });
    var data = {
      images: (product.images || []).slice(0, 8).map(function(src) { return peekWidth(src); }),
      bullets: bullets,
      compare: compare,
      offers: parsePeekOffers(res[1])
    };
    // Only worth storing if the trip actually produced something.
    if (data.images.length || data.bullets.length || data.offers.length) writePeekStore(url, data);
    return data;
  });
  return AddonPeek.cache[url];
}

function renderPeekMedia(images, fallback) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var track = el.querySelector('[data-mm-apk-track]');
  var dotsEl = el.querySelector('[data-mm-apk-dots]');
  if (!track) return;
  var list = (images && images.length) ? images : (fallback ? [fallback] : []);

  track.innerHTML = '';
  list.forEach(function(src, i) {
    var img = document.createElement('img');
    img.className = 'mm-apk__img';
    img.src = src;
    img.alt = '';
    img.loading = i === 0 ? 'eager' : 'lazy';
    img.decoding = 'async';
    track.appendChild(img);
  });
  track.scrollLeft = 0;

  var multi = list.length > 1;
  ['[data-mm-apk-prev]', '[data-mm-apk-next]'].forEach(function(sel) {
    var b = el.querySelector(sel);
    if (b) b.hidden = !multi;
  });
  var pv = el.querySelector('[data-mm-apk-prev]');
  if (pv) pv.disabled = true;
  var nx = el.querySelector('[data-mm-apk-next]');
  if (nx) nx.disabled = false;

  if (!dotsEl) return;
  dotsEl.innerHTML = '';
  if (list.length < 2) return;
  list.forEach(function(_, i) {
    var dot = document.createElement('button');
    dot.type = 'button';
    dot.className = 'mm-apk__dot';
    dot.dataset.i = i;
    dot.setAttribute('aria-label', 'Image ' + (i + 1));
    if (i === 0) dot.setAttribute('data-active', '');
    dotsEl.appendChild(dot);
  });
}

/* What the shopper would actually be charged for one of these right now.
   A live cart line is the only client-side source that knows about app and
   automatic discounts (Kaching deals included), so once the variant is in the
   cart its discount-aware unit price wins over the Liquid price. */
function peekUnitPrice(variantId, base) {
  for (var i = 0; i < CartState.items.length; i++) {
    var it = CartState.items[i];
    if (it.variant_id !== variantId || it.selling_plan_allocation) continue;
    if (!it.quantity) break;
    var unit = (typeof it.final_line_price === 'number')
      ? Math.round(it.final_line_price / it.quantity)
      : it.price;
    if (unit > 0 && unit < base) return unit;
    break;
  }
  return base;
}

/* Price row: what it costs now, the original struck through, and how much
   that saves. The "was" anchor is the retail compare-at when the product has
   one, and otherwise the Liquid price — which only differs from `now` when a
   cart discount is doing the work. No markdown, no strikethrough. */
function renderPeekPrice(card, fetchedCompare) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var wrap = el.querySelector('[data-mm-apk-price]');
  if (!wrap) return;

  // Subscription cards: mirror the card's own plan terms ("Free ~~$19.99~~"
  // + "then $15.99 every 2 months") — the one-time math below would show
  // the wrong deal.
  if (card.dataset.sellingPlan) {
    wrap.innerHTML = '';
    var subNow = card.querySelector('.mm-cart__addon-now');
    var subWas = card.querySelector('.mm-cart__addon-was');
    var subPlan = card.querySelector('.mm-cart__item-sub-plan');
    var sn = document.createElement('span');
    sn.className = 'mm-apk__now';
    sn.textContent = subNow ? subNow.textContent.trim() : '';
    wrap.appendChild(sn);
    if (subWas) {
      var sw = document.createElement('s');
      sw.className = 'mm-apk__was';
      sw.textContent = subWas.textContent.trim();
      wrap.appendChild(sw);
    }
    if (subPlan && subPlan.textContent.trim()) {
      var sp = document.createElement('span');
      sp.className = 'mm-apk__plan';
      sp.style.cssText = 'flex-basis:100%;width:100%;display:block;font-size:13px;opacity:.75;';
      sp.textContent = subPlan.textContent.trim();
      wrap.appendChild(sp);
    }
    return;
  }

  var base = parseInt(card.dataset.price, 10) || 0;
  var now = peekUnitPrice(parseInt(card.dataset.variant, 10), base);
  var compare = parseInt(card.dataset.compare, 10) || fetchedCompare || 0;

  var was = 0;
  if (compare > now) was = compare;
  else if (now < base) was = base;

  wrap.innerHTML = '';
  var nowEl = document.createElement('span');
  nowEl.className = 'mm-apk__now';
  nowEl.textContent = formatMoney(now);
  wrap.appendChild(nowEl);

  if (was <= now) return;

  var wasEl = document.createElement('s');
  wasEl.className = 'mm-apk__was';
  wasEl.textContent = formatMoney(was);
  wrap.appendChild(wasEl);

  // Below ~5% the badge reads as noise next to the strikethrough.
  var pct = Math.round((was - now) / was * 100);
  if (pct < 5) return;
  var saveEl = document.createElement('span');
  saveEl.className = 'mm-apk__save';
  saveEl.textContent = 'Save ' + pct + '%';
  wrap.appendChild(saveEl);
}

function renderPeekBullets(bullets) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var list = el.querySelector('[data-mm-apk-bullets]');
  if (!list) return;
  list.innerHTML = '';
  if (!bullets || !bullets.length) return;
  bullets.forEach(function(text) {
    var li = document.createElement('li');
    li.className = 'mm-apk__bullet';
    li.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" ' +
      'stroke-linecap="round" stroke-linejoin="round" aria-hidden="true" focusable="false">' +
      '<polyline points="20 6 9 17 4 12"/></svg><span></span>';
    li.querySelector('span').textContent = text;
    list.appendChild(li);
  });
}

/* The product's own Kaching offers as informational rows under the price.
   The container is created on first use so the shell markup (which predates
   offers) needs no edit; styles live in pdp-product-carousel's stylesheet.
   Only textContent is ever written — deal titles come from app JSON and
   must not be able to inject markup. */
function renderPeekOffers(offers) {
  var el = document.getElementById('mm-addon-peek');
  if (!el) return;
  var wrap = el.querySelector('[data-mm-apk-offers]');
  if (!wrap) {
    var price = el.querySelector('[data-mm-apk-price]');
    if (!price) return;
    wrap = document.createElement('div');
    wrap.className = 'mm-apk__offers';
    wrap.setAttribute('data-mm-apk-offers', '');
    price.insertAdjacentElement('afterend', wrap);
  }
  wrap.innerHTML = '';
  if (!offers || !offers.length) { wrap.hidden = true; return; }
  wrap.hidden = false;

  var head = document.createElement('div');
  head.className = 'mm-apk__offers-h';
  head.textContent = 'Bundle & save';
  wrap.appendChild(head);

  offers.forEach(function(o) {
    var row = document.createElement('div');
    row.className = 'mm-apk__offer';
    row.innerHTML = '<span class="mm-apk__offer-name"></span>' +
      '<span class="mm-apk__offer-price"></span>' +
      '<s class="mm-apk__offer-was"></s>' +
      '<span class="mm-apk__offer-save"></span>';
    row.querySelector('.mm-apk__offer-name').textContent = o.title;
    row.querySelector('.mm-apk__offer-price').textContent = formatMoney(o.price);
    row.querySelector('.mm-apk__offer-was').textContent = formatMoney(o.orig);
    row.querySelector('.mm-apk__offer-save').textContent =
      'Save ' + Math.round(o.save * 100 / o.orig) + '%';
    wrap.appendChild(row);
  });
}

/* Opening the popup is a product view Klaviyo would otherwise never see —
   the shopper reads the gallery and bullets without visiting the PDP. Feed
   the onsite pixel the standard Viewed Product pair so browse-abandonment
   flows and recently-viewed blocks keep working. The Klaviyo app owns the
   queue object; no-op when it isn't installed. */
function mmPeekTrackKlaviyo(card) {
  try {
    var kl = window.klaviyo || window._learnq;
    if (!kl || typeof kl.push !== 'function') return;
    var price = (parseInt(card.dataset.price, 10) || 0) / 100;
    var url = card.dataset.url ? (location.origin + card.dataset.url) : location.href;
    var item = {
      Name: card.dataset.title || '',
      ProductID: card.dataset.variant || '',
      URL: url,
      ImageURL: card.dataset.image || '',
      Price: price
    };
    kl.push(['track', 'Viewed Product', item]);
    kl.push(['trackViewedItem', {
      Title: item.Name,
      ItemId: item.ProductID,
      Url: item.URL,
      ImageUrl: item.ImageURL,
      Metadata: { Price: price }
    }]);
  } catch (err) { /* tracking must never break the popup */ }
}

function openAddonPeek(card) {
  var el = document.getElementById('mm-addon-peek');
  if (!el || !card) return;
  bindPeekShell(el);
  if (AddonPeek.hideTimer) { clearTimeout(AddonPeek.hideTimer); AddonPeek.hideTimer = null; }

  AddonPeek.card = card;
  var url = card.dataset.url || '';
  var title = card.dataset.title || '';

  var titleEl = el.querySelector('[data-mm-apk-title]');
  if (titleEl) titleEl.textContent = title;

  renderPeekPrice(card, 0);

  var link = el.querySelector('[data-mm-apk-link]');
  if (link) link.href = url || '#';

  // Hand the Add button the same payload the card's own Add button carries so
  // it rides the existing optimistic quick-add pipeline untouched.
  var add = el.querySelector('[data-mm-apk-add]');
  if (add) {
    add.dataset.variant = card.dataset.variant || '';
    add.dataset.title = title;
    add.dataset.price = card.dataset.price || '0';
    // Subscription cards: the popup adds on the same plan the card does.
    if (card.dataset.sellingPlan) add.dataset.sellingPlan = card.dataset.sellingPlan;
    else delete add.dataset.sellingPlan;
    if (card.dataset.thumb) add.dataset.image = card.dataset.thumb;
    else delete add.dataset.image;
    if (card.dataset.mmPairFor) add.dataset.mmPairFor = card.dataset.mmPairFor;
    else delete add.dataset.mmPairFor;
    // Clear any "✓ Added" / error state left over from the last product.
    add.dataset.mmBusy = '';
    add.removeAttribute('data-added');
    add.removeAttribute('data-error');
    if (add.dataset.mmOrigLabel) add.textContent = add.dataset.mmOrigLabel;
  }

  // Paint from what we already have so the popup is on screen this frame.
  renderPeekMedia([], card.dataset.image);
  renderPeekBullets([]);
  renderPeekOffers([]);
  el.setAttribute('data-loading', '');

  mmPeekTrackKlaviyo(card);

  AddonPeek.lastFocus = document.activeElement;
  el.hidden = false;
  el.setAttribute('aria-hidden', 'false');
  requestAnimationFrame(function() { el.setAttribute('data-open', ''); });
  // Opening another card while the popup is up keeps the one lock it already
  // holds (closeAddonPeek gives back exactly one).
  var peekWasOpen = AddonPeek.open;
  AddonPeek.open = true;
  if (!peekWasOpen) lockBodyScroll();
  trapPeekFocus(el);
  requestAnimationFrame(function() {
    var x = el.querySelector('[data-mm-apk-close]');
    if (x && x.focus) x.focus();
  });

  if (!url) { el.removeAttribute('data-loading'); return; }
  fetchPeekData(url).then(function(data) {
    // Bail if it was closed, or another card was opened, while we waited.
    if (!AddonPeek.open || AddonPeek.card !== card) return;
    el.removeAttribute('data-loading');
    renderPeekMedia(data.images, card.dataset.image);
    renderPeekBullets(data.bullets);
    renderPeekOffers(data.offers);
    renderPeekPrice(card, (data.compare && data.compare[card.dataset.variant]) || 0);
  }).catch(function() { el.removeAttribute('data-loading'); });
}

function closeAddonPeek() {
  var el = document.getElementById('mm-addon-peek');
  if (!el || !AddonPeek.open) return;
  AddonPeek.open = false;
  AddonPeek.card = null;
  el.removeAttribute('data-open');
  el.setAttribute('aria-hidden', 'true');
  releasePeekFocus(el);
  unlockBodyScroll();
  // Hide only after the fade so the panel doesn't vanish mid-transition.
  AddonPeek.hideTimer = setTimeout(function() {
    el.hidden = true;
    AddonPeek.hideTimer = null;
  }, 180);
  if (AddonPeek.lastFocus && AddonPeek.lastFocus.focus) AddonPeek.lastFocus.focus({ preventScroll: true });
  AddonPeek.lastFocus = null;
}

/* Self-contained focus trap. The shared trapFocus() keeps its handler in one
   module-level variable, so reusing it here would orphan the drawer's trap
   underneath us. */
function trapPeekFocus(el) {
  releasePeekFocus(el);
  AddonPeek.trap = function(e) {
    if (e.key !== 'Tab') return;
    var f = el.querySelectorAll('a[href], button:not([disabled]), [tabindex]:not([tabindex="-1"])');
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  };
  el.addEventListener('keydown', AddonPeek.trap);
}

function releasePeekFocus(el) {
  if (!AddonPeek.trap) return;
  el.removeEventListener('keydown', AddonPeek.trap);
  AddonPeek.trap = null;
}

/* Wired on first open, not at boot, and guarded per element — the theme
   editor re-renders the whole drawer section on every settings change, which
   would otherwise strand these listeners on a detached shell. */
function bindPeekShell(el) {
  if (el.__mmPeekBound) return;
  el.__mmPeekBound = true;

  var track = el.querySelector('[data-mm-apk-track]');
  var dotsEl = el.querySelector('[data-mm-apk-dots]');
  if (!track || !dotsEl) return;

  var prevBtn = el.querySelector('[data-mm-apk-prev]');
  var nextBtn = el.querySelector('[data-mm-apk-next]');
  function pageBy(dir) {
    track.scrollBy({ left: dir * track.clientWidth, behavior: 'smooth' });
  }
  if (prevBtn) prevBtn.addEventListener('click', function() { pageBy(-1); });
  if (nextBtn) nextBtn.addEventListener('click', function() { pageBy(1); });

  var ticking = false;
  track.addEventListener('scroll', function() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function() {
      ticking = false;
      var dots = dotsEl.children;
      if (dots.length < 2 || !track.clientWidth) return;
      var idx = Math.min(dots.length - 1, Math.max(0, Math.round(track.scrollLeft / track.clientWidth)));
      if (prevBtn) prevBtn.disabled = idx <= 0;
      if (nextBtn) nextBtn.disabled = idx >= dots.length - 1;
      for (var i = 0; i < dots.length; i++) {
        if (i === idx) dots[i].setAttribute('data-active', '');
        else dots[i].removeAttribute('data-active');
      }
    });
  }, { passive: true });

  dotsEl.addEventListener('click', function(e) {
    var dot = e.target.closest('.mm-apk__dot');
    if (!dot) return;
    track.scrollTo({ left: parseInt(dot.dataset.i, 10) * track.clientWidth, behavior: 'smooth' });
  });
}

/* Close is delegated from the document for the same reason. */
document.addEventListener('click', function(e) {
  if (!AddonPeek.open || !e.target.closest) return;
  if (!e.target.closest('[data-mm-apk-close]')) return;
  e.preventDefault();
  closeAddonPeek();
});

function initAddonPeek() {
  // Warm the cache on intent, so the gallery and bullets are usually already
  // in hand by the time the popup opens. Selector covers every peek trigger:
  // cart add-on cards and the PDP product-carousel cards alike.
  document.querySelectorAll('[data-mm-action="addon-peek"][data-url]').forEach(function(card) {
    var warm = function() { fetchPeekData(card.dataset.url); };
    card.addEventListener('pointerenter', warm, { once: true });
    card.addEventListener('touchstart', warm, { once: true, passive: true });
  });
}

/* Storefront strings for the cart drawer: JSON emitted by snippets/pdp-cart-drawer
   from locales/*.json. English literal is the fallback (also used if absent). */
function mmT(k, f) {
  if (!mmT.d) {
    try { var e = document.getElementById('mm-cart-i18n'); mmT.d = e ? JSON.parse(e.textContent) : {}; }
    catch (_) { mmT.d = {}; }
  }
  return mmT.d[k] || f;
}

function showCartError(msg) {
  var el = document.getElementById('mm-cart-error');
  if (el) {
    el.textContent = msg;
    el.hidden = false;
    // The error line lives inside the footer, which is hidden while the cart
    // is empty — a failed FIRST add would otherwise report to a hidden node
    // and look like the click never registered.
    var footer = document.getElementById('mm-cart-footer');
    if (footer) footer.hidden = false;
  }
}

function clearCartError() {
  var el = document.getElementById('mm-cart-error');
  if (el) { el.textContent = ''; el.hidden = true; }
}

var __mmQtyPending = Object.create(null); // key -> { target, timer, inflight, item }

function patchLineDom(key, qty) {
  var row = document.querySelector('.mm-cart__item[data-key="' + key + '"]');
  if (!row) return;
  var qv = row.querySelector('.mm-cart__qty-val');
  if (qv) qv.textContent = qty;

  var item = CartState.items.find(function (i) { return i.key === key; });
  if (item) {
    // Use the discount-aware per-unit so optimistic line totals match
    // what the server will return after line-level discounts.
    var unitNow = (item.quantity > 0 && typeof item.final_line_price === 'number')
      ? (item.final_line_price / item.quantity)
      : item.price;
    var unitWas = 0;
    if (item.original_line_price && item.quantity && item.original_line_price / item.quantity > unitNow) {
      unitWas = item.original_line_price / item.quantity;
    }
    if (!unitWas) unitWas = getItemWasUnit(item);

    var nowEl = row.querySelector('.mm-cart__item-now');
    var wasEl = row.querySelector('.mm-cart__item-was');
    var saveEl = row.querySelector('.mm-cart__item-save');
    var single = row.querySelector('.mm-cart__item-price');
    var nowTotal = unitNow * qty;
    var wasTotal = unitWas * qty;

    if (nowEl) nowEl.textContent = formatMoney(nowTotal);
    if (wasEl && unitWas) wasEl.textContent = formatMoney(wasTotal);
    if (saveEl && unitWas) {
      var saved = wasTotal - nowTotal;
      saveEl.textContent = 'Save ' + mmDiscountMoney(mmSaveRound(saved));
    }
    if (!nowEl && single && !single.querySelector('span')) {
      single.textContent = formatMoney(nowTotal);
    }
  }

  if (qty <= 0) {
    row.style.pointerEvents = 'none';
    if (cartDrawerOpen) {
      // Slide the line shut now; it stays collapsed until renderItems drops
      // it, and the lines below close up as it goes.
      mmFold(row, function() {});
    } else {
      row.style.transition = 'opacity .18s ease';
      row.style.opacity = '0.4';
    }
  } else {
    row.style.opacity = '';
    row.style.pointerEvents = '';
  }
}

function patchSubtotalDom() {
  // Discount-aware optimistic subtotal: prefer the per-unit price
  // *after* line-level discounts (final_line_price / quantity) so the
  // displayed total matches what the server will return.
  var total = CartState.items.reduce(function (sum, it) {
    var pendingTarget = __mmQtyPending[it.key] ? __mmQtyPending[it.key].target : it.quantity;
    var unit = (it.quantity > 0 && typeof it.final_line_price === 'number')
      ? (it.final_line_price / it.quantity)
      : it.price;
    return sum + unit * pendingTarget;
  }, 0);
  var subtotalEl = document.getElementById('mm-cart-subtotal');
  if (subtotalEl) subtotalEl.textContent = formatMoney(total);
  renderCartSavings(CartState.items, function (it) {
    return __mmQtyPending[it.key] ? __mmQtyPending[it.key].target : it.quantity;
  });
  // Drive shipping + gift bars off the same optimistic subtotal so
  // they animate in lockstep with each click instead of lagging the
  // server round-trip.
  patchShippingBarOptimistic(total);
  patchGiftBarOptimistic(total);
}

function patchShippingBarOptimistic(subtotal) {
  var bar = document.getElementById('mm-cart-ship');
  if (bar && !bar.hidden) {
    var threshold = parseInt(bar.dataset.threshold, 10) || 0;
    if (threshold) {
      var remaining = Math.max(0, threshold - subtotal);
      var pct = Math.min(100, (subtotal / threshold) * 100);
      var fill = bar.querySelector('[data-mm-ship-fill]');
      var msg  = bar.querySelector('[data-mm-ship-msg]');
      if (fill) fill.style.width = pct + '%';
      if (msg) {
        var tplProgress = bar.dataset.textProgress || 'You’re {amount} away from free shipping';
        var tplUnlocked = bar.dataset.textUnlocked || '🎉 You unlocked <strong>free shipping</strong>!';
        var amount = '<strong>' + formatMoney(remaining) + '</strong>';
        msg.innerHTML = remaining === 0 ? tplUnlocked : tplProgress.replace(/\{amount\}/g, amount);
      }
    }
  }
}

function patchGiftBarOptimistic(subtotal) {
  var bar = document.getElementById('mm-cart-gift');
  if (!bar || bar.hidden) return;
  var threshold = parseInt(bar.dataset.threshold, 10) || 0;
  if (!threshold) return;
  var label = bar.dataset.label || 'free gift';
  var remaining = Math.max(0, threshold - subtotal);
  var pct = Math.min(100, (subtotal / threshold) * 100);
  var fill = bar.querySelector('[data-mm-gift-fill]');
  var msg  = bar.querySelector('[data-mm-gift-msg]');
  if (fill) fill.style.width = pct + '%';
  if (msg) {
    msg.innerHTML = remaining === 0
      ? '🎁 You unlocked your <strong>' + label + '</strong>!'
      : 'Add <strong>' + formatMoney(remaining) + '</strong> for a <strong>' + label + '</strong>';
  }
}

async function flushQty(key) {
  var p = __mmQtyPending[key];
  if (!p) return;
  if (p.inflight) return; // a sync is already running; it will re-flush after
  p.inflight = true;
  // Capture exactly what we're sending. If we compared the post-fetch
  // server quantity to p.target afterwards, an inventory cap would loop
  // forever (target=10, server caps to 5 → re-flush 10 → cap 5 → …).
  // Re-flush only when the *user's* target moved while we were in-flight.
  var sent = p.target;
  // Removing a bundle's paid anchor takes its $0 gift components with it in
  // the same request (one /cart/update.js keyed by line key), so the server
  // never holds — and the drawer never paints — an anchorless gift set.
  var ride = [];
  if (sent === 0) {
    var line = CartState.items.find(function (i) { return i.key === key; }) || p.item;
    if (line) ride = mmDependentGiftLines(line, CartState.items);
  }
  try {
    if (ride.length) {
      var updates = {};
      updates[key] = 0;
      ride.forEach(function (g) { updates[g.key] = 0; });
      await fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ updates: updates })
      });
    } else {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity: sent })
      });
    }
  } catch (e) { /* network error — refetch will reconcile */ }
  await CartState.fetch();
  var stillPending = __mmQtyPending[key];
  if (stillPending) {
    if (stillPending.target !== sent) {
      stillPending.inflight = false;
      flushQty(key);
      return;
    }
    delete __mmQtyPending[key];
  }
}

function updateCartQty(key, delta) {
  var item = CartState.items.find(function (i) { return i.key === key; });
  if (!item) return;
  var p = __mmQtyPending[key];
  if (!p) {
    p = __mmQtyPending[key] = { target: item.quantity, timer: 0, inflight: false, item: item };
  }
  p.target = Math.max(0, p.target + delta);
  patchLineDom(key, p.target);
  patchSubtotalDom();
  clearTimeout(p.timer);
  p.timer = setTimeout(function () { flushQty(key); }, 220);
}

/* ----------------------------------------------------------
   11. NEWSLETTER
   ---------------------------------------------------------- */
function initNewsletter() {
  document.querySelectorAll('[data-action="newsletter-subscribe"]').forEach(function(form) {
    form.addEventListener('submit', async function(e) {
      e.preventDefault();
      var emailInput = form.querySelector('input[type="email"]');
      if (!emailInput || !emailInput.value) return;

      var btn = form.querySelector('button[type="submit"]');
      var original = btn ? btn.textContent : '';
      if (btn) { btn.textContent = '…'; btn.disabled = true; }

      var klaviyoListId = window.MM_KLAVIYO_LIST_ID;

      try {
        if (klaviyoListId) {
          await fetch('https://a.klaviyo.com/client/subscriptions/?company_id=' + klaviyoListId, {
            method: 'POST',
            headers: { 'content-type': 'application/json', revision: '2023-02-22' },
            body: JSON.stringify({ data: { type: 'subscription', attributes: {
              list_id: klaviyoListId,
              email: emailInput.value
            }}})
          });
        } else {
          var fd = new FormData();
          fd.append('form_type', 'customer');
          fd.append('utf8', '✓');
          fd.append('contact[email]', emailInput.value);
          await fetch('/contact', { method: 'POST', body: fd });
        }
        if (btn) { btn.textContent = '✓ Joined'; }
        emailInput.value = '';
      } catch (err) {
        if (btn) { btn.textContent = 'Error — try again'; }
      } finally {
        setTimeout(function() {
          if (btn) { btn.textContent = original; btn.disabled = false; }
        }, 3000);
      }
    });
  });
}

/* ----------------------------------------------------------
   12. EVENT DELEGATION — central click handler
   ---------------------------------------------------------- */
document.addEventListener('click', function(e) {
  var action = e.target.closest('[data-mm-action]');
  if (!action) return;

  var type = action.dataset.mmAction;

  switch (type) {
    case 'open-cart':
      e.preventDefault();
      // Open on the tap — the drawer already holds the cart (seeded at boot,
      // kept current by every add/change). Re-sync behind it only when that
      // copy is old enough that another tab could have changed the cart.
      openCart();
      if (Date.now() - CartState.at > 5000) CartState.fetch();
      break;

    case 'close-cart':
      closeCart();
      break;

    case 'open-drawer':
      openDrawer();
      break;

    case 'close-drawer':
      closeDrawer();
      break;

    case 'add-to-cart':
      // If button is a submit inside a product form, let the form handler take it
      if (action.tagName === 'BUTTON' && action.type === 'submit') {
        break;
      }
      e.preventDefault();
      if (action.__mmLocked) break; // ignore rage-clicks
      action.__mmLocked = true;
      action.disabled = true;
      action.setAttribute('aria-busy', 'true');
      var origLabelEl = action.querySelector('.mm-btn__label') || action;
      var origText = origLabelEl.textContent;
      origLabelEl.textContent = 'Adding…';
      Promise.resolve(addToCart(action.dataset.variants || action.dataset.variant)).finally(function () {
        action.__mmLocked = false;
        action.disabled = false;
        action.removeAttribute('aria-busy');
        origLabelEl.textContent = origText;
      });
      break;

    case 'buy-now':
      e.preventDefault();
      var bnForm = action.closest('[data-mm-product-form]');
      if (bnForm) buyNow(bnForm, action);
      break;

    case 'bundle-upgrade':
      e.preventDefault();
      bundleUpgrade(action);
      break;

    case 'quick-add':
      e.preventDefault();
      // A pairing taken (inline, or from its peek) retires pairings for that
      // line, so adding one never sets off the next pitch under it.
      if (action.dataset.mmPairFor) mmNotePairTaken(action.dataset.mmPairFor);
      quickAddToCart(action);
      // Product cards (collection, search) sit outside the drawer, so open it
      // on the tap: same feedback as every other add on the site.
      if (action.closest('.mm-pcard')) openCart();
      // Added from the peek popup: hold the "✓ Added" state briefly so the
      // click is acknowledged, then close onto the cart with the new line
      // already in it (the add is optimistic, so it's there immediately).
      // A failed add stays put instead, so the shopper sees the Error state
      // on the button they actually pressed.
      if (action.hasAttribute('data-mm-apk-add')) {
        setTimeout(function() {
          if (!action.hasAttribute('data-error')) closeAddonPeek();
        }, 550);
      }
      break;

    case 'addon-peek':
      e.preventDefault();
      openAddonPeek(action);
      break;

    case 'apply-promo':
      e.preventDefault();
      applyPromoCode();
      break;

    case 'checkout':
      e.preventDefault();
      mmGoCheckout();
      break;

    case 'cart-qty':
      e.preventDefault();
      var key = action.dataset.key;
      var delta = parseInt(action.dataset.delta, 10);
      updateCartQty(key, delta);
      break;

    case 'reviews-page':
      /* Decorative pagination — extend here for async load */
      var allPageBtns = document.querySelectorAll('[data-mm-action="reviews-page"]');
      allPageBtns.forEach(function(btn) { btn.removeAttribute('aria-current'); });
      action.setAttribute('aria-current', 'true');
      break;

    case 'search':
      /* Delegate to Shopify's native search or predictive search */
      if (typeof window.Shopify !== 'undefined' && Shopify.routes) {
        window.location.href = Shopify.routes.search_url || '/search';
      }
      break;
  }
});

/* Scrim clicks close the relevant panel */
document.addEventListener('click', function(e) {
  if (e.target.matches('[data-mm-cart-scrim]')) closeCart();
  if (e.target.matches('[data-mm-drawer-scrim]')) closeDrawer();
});

/* Escape key closes open panels */
document.addEventListener('keydown', function(e) {
  if (e.key !== 'Escape') return;
  // The peek popup sits on top of the drawer, so it closes first.
  if (AddonPeek.open) closeAddonPeek();
  else if (cartDrawerOpen) closeCart();
  else if (navDrawerOpen) closeDrawer();
});

/* ----------------------------------------------------------
   SWIPE TO DISMISS — the mobile nav slides away to the left and the cart
   to the right, the way native app drawers do. The panel follows the
   finger, then commits on distance or a quick flick, otherwise springs
   back. The gesture only locks once the move is clearly horizontal, so
   vertical scrolling inside the panel is never touched, and it steps aside
   for inputs and anything that scrolls sideways (the cart add-on carousel).
   ---------------------------------------------------------- */
function mmSwipeBlocked(el, stop) {
  for (var n = el; n && n !== stop; n = n.parentElement) {
    if (n.nodeType !== 1) continue;
    if (n.hasAttribute('data-mm-no-swipe')) return true;
    var tag = n.tagName;
    if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true;
    if (n.scrollWidth > n.clientWidth + 1) {
      var ox = getComputedStyle(n).overflowX;
      if (ox === 'auto' || ox === 'scroll') return true;
    }
  }
  return false;
}

/* A finger lifted after a swipe can still synthesize a click on whatever is
   under it; eat it so a link or the scrim isn't triggered by the gesture. */
function mmSwallowNextClick() {
  var kill = function(ev) { ev.stopPropagation(); ev.preventDefault(); };
  document.addEventListener('click', kill, true);
  setTimeout(function() { document.removeEventListener('click', kill, true); }, 350);
}

function mmSwipeDismiss(panel, opts) {
  if (!panel || panel.__mmSwipe) return;
  panel.__mmSwipe = true;

  var dir = opts.dir;          // -1: swipe left closes · 1: swipe right closes
  var SLOP = 8;                // px of travel before the gesture picks an axis
  var state = '';              // '' idle · 'pending' undecided · 'drag' locked horizontal
  var x0 = 0, y0 = 0, lastX = 0, lastT = 0, vx = 0, offset = 0, width = 1;

  function scrimEl() { return opts.scrim ? document.querySelector(opts.scrim) : null; }

  function settle(commit) {
    var scrim = scrimEl();
    panel.style.transition = '';
    panel.style.transform = '';
    if (scrim) { scrim.style.transition = ''; scrim.style.opacity = ''; }
    state = '';
    // Inline styles are gone, so the CSS transition carries the panel on from
    // where the finger left it — out on a commit, back to rest otherwise.
    if (commit) opts.close();
  }

  panel.addEventListener('touchstart', function(e) {
    state = '';
    if (e.touches.length !== 1) return;
    if (!panel.hasAttribute('data-open') || panel.hasAttribute('data-editor-pinned')) return;
    if (mmSwipeBlocked(e.target, panel)) return;
    x0 = lastX = e.touches[0].clientX;
    y0 = e.touches[0].clientY;
    lastT = e.timeStamp;
    vx = 0; offset = 0;
    width = panel.offsetWidth || 1;
    state = 'pending';
  }, { passive: true });

  // Not passive: once the move is locked horizontal it must stop the browser
  // from also treating it as a scroll or edge pan.
  panel.addEventListener('touchmove', function(e) {
    if (!state) return;
    if (e.touches.length !== 1) { if (state === 'drag') settle(false); state = ''; return; }
    var t = e.touches[0];
    var dx = (t.clientX - x0) * dir;     // > 0 means toward closing
    var dy = t.clientY - y0;

    if (state === 'pending') {
      var adx = Math.abs(t.clientX - x0);
      if (adx < SLOP && Math.abs(dy) < SLOP) return;
      // Vertical scroll, or a swipe the wrong way: leave it to the browser.
      if (dx <= 0 || adx < Math.abs(dy) * 1.2) { state = ''; return; }
      state = 'drag';
      x0 = t.clientX;                    // start from the lock point — no jump
      dx = 0;
      panel.style.transition = 'none';
      var scrim = scrimEl();
      if (scrim) scrim.style.transition = 'none';
    }

    if (e.cancelable) e.preventDefault();

    var dt = e.timeStamp - lastT;
    if (dt > 0) vx = 0.6 * (((t.clientX - lastX) * dir) / dt) + 0.4 * vx;   // px/ms toward closing
    lastX = t.clientX;
    lastT = e.timeStamp;

    offset = Math.max(0, Math.min(dx, width));
    panel.style.transform = 'translateX(' + (dir * offset) + 'px)';
    var sc = scrimEl();
    if (sc) sc.style.opacity = String(1 - offset / width);
  }, { passive: false });

  panel.addEventListener('touchend', function() {
    if (state !== 'drag') { state = ''; return; }
    var commit = offset > width * 0.3 || (vx > 0.5 && offset > 24);
    mmSwallowNextClick();
    settle(commit);
  }, { passive: true });

  panel.addEventListener('touchcancel', function() {
    if (state === 'drag') settle(false);
    state = '';
  }, { passive: true });
}

function initSwipeDismiss() {
  mmSwipeDismiss(document.getElementById('mm-drawer'), { dir: -1, scrim: '[data-mm-drawer-scrim]', close: closeDrawer });
  mmSwipeDismiss(document.getElementById('mm-cart'),   { dir:  1, scrim: '[data-mm-cart-scrim]',   close: closeCart });
}

/* ----------------------------------------------------------
   13. INIT
   ---------------------------------------------------------- */
/* ----------------------------------------------------------
   STICKY HEADER (scroll-aware)
   ---------------------------------------------------------- */
function initStickyHeader() {
  var header = document.getElementById('mm-site-header');
  if (!header) return;
  var mode = header.dataset.mmSticky;
  if (mode !== 'scroll') return; // CSS handles "always" and "never" via [data-mm-sticky] selectors

  var lastY = window.scrollY;
  var DELTA = 8;       // ignore scroll noise smaller than this
  var TOP_BUFFER = 80; // never hide while still near the top
  var ticking = false;
  // Spring slide; a direction change mid-slide reverses from where it is
  var motion = window.MMSpring ? MMSpring.reveal(header, {
    shown: true,
    offset: function() { return -header.offsetHeight; }
  }) : null;

  function setHidden(hidden) {
    header.classList.toggle('is-hidden', hidden);
    if (motion) { if (hidden) motion.hide(); else motion.show(); }
  }

  function update() {
    var y = window.scrollY;
    var diff = y - lastY;
    if (Math.abs(diff) < DELTA) { ticking = false; return; }
    if (y < TOP_BUFFER) {
      setHidden(false);
    } else {
      setHidden(diff > 0); // scrolling down → hide, up → show
    }
    lastY = y;
    ticking = false;
  }

  window.addEventListener('scroll', function() {
    if (!ticking) { window.requestAnimationFrame(update); ticking = true; }
  }, { passive: true });
}

/* ----------------------------------------------------------
   Theme-editor integration — click a section or block in the
   editor sidebar and the corresponding drawer (cart or mobile
   nav) slides into view automatically. No effect on the live
   storefront.
   ---------------------------------------------------------- */
function initEditorDrawerHooks() {
  // Only run inside the Shopify theme editor preview iframe
  if (!(window.Shopify && Shopify.designMode)) return;

  // Heuristics to map a selected section/block to the right drawer.
  // We open the cart drawer for anything whose id/type/path mentions
  // cart/upsell/shipping/promo/checkout, and the nav drawer for
  // mobile-drawer/menu hits.
  var cartHints   = /cart|upsell|shipping|gift|promo|checkout/i;
  var navHints    = /drawer|hamburger|nav/i;
  var stickyHints = /sticky|hero|buybox|atc/i;

  function probe(detail) {
    if (!detail) return '';
    return [detail.sectionId, detail.blockId, detail.type, detail.id, detail.path].join(' ');
  }

  function pick(detail) {
    var s = probe(detail);
    if (cartHints.test(s))   return 'cart';
    if (navHints.test(s))    return 'nav';
    if (stickyHints.test(s)) return 'sticky';
    // Fall through: also inspect the actual selected DOM element if present
    var el = document.querySelector('[data-shopify-editor-block-selected],[data-shopify-editor-section-selected]');
    if (el && el.closest && el.closest('#mm-cart'))        return 'cart';
    if (el && el.closest && el.closest('#mm-drawer'))      return 'nav';
    if (el && el.closest && el.closest('#mm-sticky-atc'))  return 'sticky';
    return '';
  }

  function showSticky() {
    var bar = document.getElementById('mm-sticky-atc');
    if (bar) setStickyAtcVisible(bar, true);
  }
  function hideSticky() {
    var bar = document.getElementById('mm-sticky-atc');
    if (bar && !bar.hasAttribute('data-editor-pinned') &&
        bar.getAttribute('data-mm-trigger') !== 'always') setStickyAtcVisible(bar, false);
  }

  function handleSelect(e) {
    var which = pick(e.detail);
    if (which === 'cart'   && typeof openCart   === 'function') openCart();
    if (which === 'nav'    && typeof openDrawer === 'function') openDrawer();
    if (which === 'sticky') showSticky();
  }

  function handleDeselect() {
    if (cartDrawerOpen && typeof closeCart   === 'function') closeCart();
    if (navDrawerOpen  && typeof closeDrawer === 'function') closeDrawer();
    hideSticky();
  }

  document.addEventListener('shopify:section:select', handleSelect);
  document.addEventListener('shopify:block:select',   handleSelect);
  document.addEventListener('shopify:section:deselect', handleDeselect);
  document.addEventListener('shopify:block:deselect',   handleDeselect);
}

/* ----------------------------------------------------------
   10b2. KACHING SUBSCRIPTIONS — one-time row is an instant ATC.
   The theme CSS demotes the widget's "One time purchase" card to a
   centered text link under the subscription card. Clicking it no
   longer switches the widget's plan selection — it adds the current
   variant to the cart as a one-time line (no selling plan) and the
   drawer opens as the click feedback (addToCart does both).
   Capture phase so the widget's own select handler never runs; the
   subscription card stays the selected option in the buybox.
   ---------------------------------------------------------- */
document.addEventListener('click', function (e) {
  if (!e.target || !e.target.closest) return;
  var row = e.target.closest('kaching-subscriptions .kaching-subscriptions__card-wrapper.one-time-purchase');
  if (!row) return;
  e.preventDefault();
  e.stopPropagation();

  // Rage-click lockout — addToCart has no re-entry guard of its own.
  if (row.__mmBusy) return;
  row.__mmBusy = true;
  setTimeout(function () { row.__mmBusy = false; }, 1200);

  // Current variant: the widget renders inside the native product form;
  // fall back to any product form on the page (single-form PDPs).
  var form = row.closest('form[action*="/cart/add"]');
  var idInput = (form && form.querySelector('input[name="id"], select[name="id"]')) ||
                document.querySelector('[data-mm-product-form] input[name="id"], form[action*="/cart/add"] input[name="id"]');
  var vid = idInput && idInput.value;
  if (!vid) return;
  addToCart(vid);
}, true);

/* ----------------------------------------------------------
   10c. SUBSCRIPTION WIDGET — radio cards + frequency select.
   Toggles hidden line-item-property inputs (disabled = not posted).

   Listeners are DELEGATED on `document` rather than bound to each card.
   The cards live inside the product form, which subscription/bundle apps
   (Kaching, etc.) re-render after we boot — that wiped per-card listeners,
   so clicking "One-Time" only toggled the native radio while the gold
   `is-selected` styling and the `selling_plan` disable never ran. The card
   visually stayed on "Subscribe" and a subscription was still posted to the
   cart. Delegation re-resolves the DOM at event time, so it survives those
   re-renders; the form submit handler additionally reconciles from the
   native radio as a final guard (see initProductForms).
   ---------------------------------------------------------- */
// Matches Shopify-formatted money strings ($29.99, £1,299.00, etc.)
var MM_SUB_MONEY_RE = /([$€£¥₹]|kr|CHF|₩|CAD|USD)\s?[\d,]+(?:\.\d+)?/;

function mmSyncSubAtc(priceText) {
  if (!priceText) return;
  document.querySelectorAll('[data-mm-action="add-to-cart"] .mm-btn__label').forEach(function(el) {
    var t = el.textContent;
    if (MM_SUB_MONEY_RE.test(t)) {
      // Function replacement — a plain string like "$116.99" would be parsed
      // as the "$1" backreference (the captured currency symbol) + "16.99",
      // turning $116.99 into $16.99.
      el.textContent = t.replace(MM_SUB_MONEY_RE, function () { return priceText; });
    } else if (t.indexOf('—') === -1) {
      el.textContent = t.trim() + ' — ' + priceText;
    }
  });
  document.querySelectorAll('.mm-sticky-atc__price').forEach(function(el) {
    el.textContent = priceText;
  });
}

function mmRenderSubTokens(tpl, vals) {
  if (!tpl) return '';
  return tpl
    .replace(/\{discount\}/g, vals.discount || '')
    .replace(/\{percent\}/g,  vals.percent  || '')
    .replace(/\{price\}/g,    vals.price    || '')
    .replace(/\{was\}/g,      vals.was      || '')
    .replace(/\{saved\}/g,    vals.saved    || '');
}

// Purchase mode for a group, derived from the checked native radio (reliable
// even if our JS was wiped — clicking the label still checks it), with the
// server default as fallback.
function mmSubMode(group) {
  var checked = group.querySelector('input[name="mm-sub-choice"]:checked');
  if (checked) return checked.value;
  return (group.getAttribute('data-mm-sub-default') === 'onetime') ? 'onetime' : 'subscribe';
}

// Authoritatively apply a purchase mode ('subscribe' | 'onetime') to a widget.
// Re-queries the group every call so it works after app-driven DOM re-renders.
function mmApplySubMode(group, mode) {
  if (!group) return;
  var planEl  = group.querySelector('[data-mm-sub-plan-input]');
  var propOne = group.querySelector('[data-mm-sub-prop="onetime"]');
  var propSub = group.querySelector('[data-mm-sub-prop="subscribe"]');
  var freqSel = group.querySelector('[data-mm-sub-freq-select]');
  var priceEl = group.querySelector('[data-mm-sub-disc-price]');
  var oneCardPriceEl = group.querySelector('[data-mm-sub-card="onetime"] .mm-sub__price');

  group.querySelectorAll('[data-mm-sub-card]').forEach(function(c) {
    var match = c.getAttribute('data-mm-sub-card') === mode;
    c.classList.toggle('is-selected', match);
    var radio = c.querySelector('.mm-sub__radio-input');
    if (radio) radio.checked = match;
  });

  if (planEl)  planEl.disabled  = (mode !== 'subscribe');
  if (propOne) propOne.disabled = (mode !== 'onetime');
  if (propSub) propSub.disabled = (mode !== 'subscribe');

  // Keep the posted selling_plan aligned with the visible frequency choice,
  // so the right plan ships even if the freq listener was re-rendered away.
  if (mode === 'subscribe' && planEl && freqSel &&
      group.getAttribute('data-mm-sub-has-plans') === '1' && freqSel.value) {
    planEl.value = freqSel.value;
  }

  var price = (mode === 'subscribe' && priceEl) ? priceEl.textContent.trim()
            : (mode === 'onetime'  && oneCardPriceEl) ? oneCardPriceEl.textContent.trim()
            : null;
  mmSyncSubAtc(price);
}

// Apply a frequency-select change: update the plan id, price + token strings.
function mmApplySubFreq(group, freqSel) {
  var opt = freqSel.options[freqSel.selectedIndex];
  if (!opt) return;
  var hasPlans = group.getAttribute('data-mm-sub-has-plans') === '1';
  var planEl   = group.querySelector('[data-mm-sub-plan-input]');
  var priceEl  = group.querySelector('[data-mm-sub-disc-price]');
  if (hasPlans && planEl) planEl.value = opt.value; // selling_plan ID
  var price = opt.getAttribute('data-price');
  var pct   = opt.getAttribute('data-pct');
  var vals = {
    discount: opt.getAttribute('data-discount') || (pct ? pct + '%' : ''),
    percent:  pct,
    price:    price,
    was:      opt.getAttribute('data-was'),
    saved:    opt.getAttribute('data-saved')
  };
  if (price && priceEl) priceEl.textContent = price;
  group.querySelectorAll('[data-mm-sub-tpl]').forEach(function(el) {
    el.textContent = mmRenderSubTokens(el.getAttribute('data-mm-sub-tpl'), vals);
  });
  // If subscribe is currently selected, push the new price to the ATC bar.
  if (group.querySelector('[data-mm-sub-card="subscribe"].is-selected') && price) mmSyncSubAtc(price);
}

function initSubscriptionWidgets() {
  // Initial per-group sync — server rendered ATC with the base variant price;
  // reflect the default selection's price now.
  document.querySelectorAll('[data-mm-sub]').forEach(function(group) {
    mmApplySubMode(group, mmSubMode(group));
  });

  // Delegated change: native radio toggles (incl. label clicks + keyboard)
  // and frequency-select changes both bubble here.
  document.addEventListener('change', function(e) {
    var t = e.target;
    if (!t || !t.closest) return;
    var radio = t.closest('input[name="mm-sub-choice"]');
    if (radio) {
      var g = radio.closest('[data-mm-sub]');
      if (g) mmApplySubMode(g, radio.value);
      return;
    }
    var freq = t.closest('[data-mm-sub-freq-select]');
    if (freq) {
      var gf = freq.closest('[data-mm-sub]');
      if (gf) mmApplySubFreq(gf, freq);
    }
  });

  // Delegated click: covers re-selecting a card whose native radio is already
  // checked, and any case where label→radio forwarding was suppressed.
  document.addEventListener('click', function(e) {
    if (!e.target || !e.target.closest) return;
    if (e.target.closest('.mm-sub__freq-select')) return;
    var card = e.target.closest('[data-mm-sub-card]');
    if (!card) return;
    var g = card.closest('[data-mm-sub]');
    if (g) mmApplySubMode(g, card.getAttribute('data-mm-sub-card'));
  });

  // Delegated keyboard: the cards are <label>s (tabindex=0) which don't
  // natively respond to Space/Enter; let the wrapped radio handle its own keys.
  document.addEventListener('keydown', function(e) {
    if (e.key !== ' ' && e.key !== 'Enter') return;
    if (!e.target || !e.target.closest) return;
    if (e.target.matches('input, select, textarea, button, a')) return;
    var card = e.target.closest('[data-mm-sub-card]');
    if (!card) return;
    e.preventDefault();
    var g = card.closest('[data-mm-sub]');
    if (g) mmApplySubMode(g, card.getAttribute('data-mm-sub-card'));
  });
}

/* ----------------------------------------------------------
   11b. SUBSCRIPTION INFO SHEET — dark bottom sheet
   Triggered by the ⓘ link and the secondary "details" link.
   ---------------------------------------------------------- */
function initSubSheet() {
  var openers = document.querySelectorAll('[data-mm-sheet-open]');
  if (!openers.length) return;

  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var lastFocus = null;

  // Spring slide-up + swipe-down-to-close (mm-spring.js); null → CSS transition fallback
  function sheetMotion(sheet) {
    var panel = sheet.querySelector('.mm-sheet__panel');
    if (!panel || !window.MMSpring) return null;
    return panel.__mmPanel || (panel.__mmPanel = MMSpring.panel(panel, {
      side: 'bottom',
      preset: MMSpring.PRESETS.modal,
      scrim: sheet.querySelector('.mm-sheet__scrim'),
      onDismiss: function() { closeSheet(sheet, false); },
      onClosed: function() { finishClose(sheet); }
    }));
  }

  function openSheet(sheet) {
    if (!sheet || sheet.classList.contains('is-open')) return;
    if (sheet.hidden) lastFocus = document.activeElement;
    sheet.hidden = false;
    document.body.style.overflow = 'hidden';
    var motion = sheetMotion(sheet);
    if (!motion) void sheet.offsetWidth; // force reflow so the transition runs
    sheet.classList.add('is-open');
    if (motion) motion.open(); // mid-close this reverses from where it is
    var closeBtn = sheet.querySelector('.mm-sheet__x');
    if (closeBtn) closeBtn.focus({ preventScroll: true });
  }

  function finishClose(sheet) {
    sheet.hidden = true;
    var panel = sheet.querySelector('.mm-sheet__panel');
    if (panel) panel.style.transform = '';
    if (lastFocus && typeof lastFocus.focus === 'function') lastFocus.focus({ preventScroll: true });
    lastFocus = null;
  }

  function closeSheet(sheet, fromDrag) {
    if (!sheet || sheet.hidden || !sheet.classList.contains('is-open')) return;
    document.body.style.overflow = '';
    var motion = sheetMotion(sheet);
    if (motion) {
      sheet.classList.remove('is-open');
      motion.close(); // finishClose runs when the spring settles
      return;
    }
    var panel = sheet.querySelector('.mm-sheet__panel');

    if (reduceMotion || !panel) {
      sheet.classList.remove('is-open');
      finishClose(sheet);
      return;
    }

    var done = function() {
      panel.removeEventListener('transitionend', done);
      sheet.classList.remove('is-open');
      finishClose(sheet);
    };
    panel.addEventListener('transitionend', done);
    setTimeout(done, 420); // safety net if transitionend never fires

    if (fromDrag) {
      // Continue the slide from wherever the finger left it
      panel.style.transform = 'translateY(100%)';
    } else {
      sheet.classList.remove('is-open');
    }
  }

  // Open triggers
  openers.forEach(function(btn) {
    btn.addEventListener('click', function(e) {
      e.preventDefault();
      var sheet = document.getElementById(btn.getAttribute('data-mm-sheet-open'));
      openSheet(sheet);
    });
  });

  document.querySelectorAll('[data-mm-sheet]').forEach(function(sheet) {
    // Close affordances: X button + scrim
    sheet.querySelectorAll('[data-mm-sheet-close]').forEach(function(el) {
      el.addEventListener('click', function() { closeSheet(sheet, false); });
    });

    // Esc to close
    sheet.addEventListener('keydown', function(e) {
      if (e.key === 'Escape') closeSheet(sheet, false);
    });

    // Sticky ATC inside the sheet always commits the subscription
    var sheetAtc = sheet.querySelector('[data-mm-sheet-atc]');
    if (sheetAtc) {
      sheetAtc.addEventListener('click', function() {
        var group = sheet.closest('[data-mm-sub]');
        var subCard = group && group.querySelector('[data-mm-sub-card="subscribe"]');
        if (subCard) subCard.click(); // select subscribe before the form submits
        closeSheet(sheet, false);
        // No preventDefault — the submit proceeds and opens the cart drawer
      });
    }

    // Drag-to-dismiss on the grip (mobile). With mm-spring.js loaded the whole
    // panel follows the finger via sheetMotion instead.
    var grip = sheet.querySelector('[data-mm-sheet-grip]');
    var panel = sheet.querySelector('.mm-sheet__panel');
    if (grip && panel && !window.MMSpring) {
      var startY = 0, dy = 0, dragging = false;
      grip.addEventListener('pointerdown', function(e) {
        dragging = true; startY = e.clientY; dy = 0;
        panel.style.transition = 'none';
        grip.setPointerCapture(e.pointerId);
      });
      grip.addEventListener('pointermove', function(e) {
        if (!dragging) return;
        dy = Math.max(0, e.clientY - startY);
        panel.style.transform = 'translateY(' + dy + 'px)';
      });
      var endDrag = function() {
        if (!dragging) return;
        dragging = false;
        panel.style.transition = '';
        if (dy > 110) {
          closeSheet(sheet, true);
        } else {
          panel.style.transform = ''; // snap back
        }
      };
      grip.addEventListener('pointerup', endDrag);
      grip.addEventListener('pointercancel', endDrag);
    }
  });
}

/* ----------------------------------------------------------
   GUARANTEE BADGE — sizes the badge column beside the title.
   Width = main-column height × image aspect ratio (capped). The CSS
   aspect-ratio fallback resolves to 0 width in some flex passes
   (intrinsic sizing runs before the stretched height is definite),
   so the measured width is set explicitly here. Runs twice per pass:
   the first width can re-wrap the title, the second converges.
   ---------------------------------------------------------- */
function mmSizeGuaranteeBadges() {
  var rows = document.querySelectorAll('.mm-buybox__gbadge-row');
  if (!rows.length) return;
  var pass = function () {
    rows.forEach(function (row) {
      var badge = row.querySelector('.mm-buybox__gbadge');
      var main = row.querySelector('.mm-buybox__gbadge-main');
      if (!badge || !main) return;
      var ar = parseFloat(badge.getAttribute('data-ar')) || 1;
      var cap = Math.min(150, row.clientWidth * 0.38);
      badge.style.width = Math.min(main.offsetHeight * ar, cap) + 'px';
    });
  };
  pass();
  pass();
}

function initGuaranteeBadges() {
  mmSizeGuaranteeBadges();
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(mmSizeGuaranteeBadges);
  var t, lastW = window.innerWidth;
  window.addEventListener('resize', function (e) {
    if (e.isTrusted && window.innerWidth === lastW) return; // phone address bar: height only
    lastW = window.innerWidth;
    clearTimeout(t);
    t = setTimeout(mmSizeGuaranteeBadges, 120);
  });
}

document.addEventListener('DOMContentLoaded', function() {
  // Critical path — wire interactions immediately
  initCountdown();
  initMiniReviews();
  initFaq();
  initStickyAtc();
  initStickyLabelDiscount();
  initDiscNotes();
  initWidgetLift();
  initStickyHeader();
  initNewsletter();
  initProductForms();
  initVariantPickers();
  initSubscriptionWidgets();
  initSubSheet();
  initAddonPeek();
  initEditorDrawerHooks();
  initGuaranteeBadges();
  initSwipeDismiss();

  // Reservation banner: prime data attrs so it renders correctly even
  // before the cart is opened. If the drawer is pinned open (theme
  // editor) or already open at boot, start ticking immediately.
  CartReserve.init();
  var __mmCartEl = document.getElementById('mm-cart');
  if (__mmCartEl && __mmCartEl.hasAttribute('data-open')) CartReserve.start();

  // Cart state. The page ships the cart it was rendered with (#mm-cart-seed,
  // pdp-header.liquid), so the badge and drawer paint from it right here —
  // no boot round trip, and a drawer opened in the first second is never
  // empty or stale. A simple cart older than 24h is cleared first
  // (mmResetStaleCart), so a possibly-stale seed is held back until that
  // check resolves rather than flashing lines that are about to go.
  var seed = mmCartSeed();
  var ageRec = mmReadCartAge();
  var maybeStale = !!(ageRec && typeof ageRec.at === 'number' && Date.now() - ageRec.at >= MM_CART_STALE_MS);
  if (seed && !maybeStale) CartState.apply(seed);
  var staleReset = mmResetStaleCart(seed);
  // Reconcile with /cart.js only when the seed can't be the whole story:
  // no seed, a stale-cart check ran, or lines whose app-side state (Kaching
  // merges, discount allocations) is worth one idle refresh. An empty cart
  // rendered by the server needs no second opinion.
  if (!seed || maybeStale || seed.items.length) {
    var fetchCart = function() { staleReset.then(function() { CartState.fetch(); }); };
    if ('requestIdleCallback' in window) {
      requestIdleCallback(fetchCart, { timeout: 2500 });
    } else {
      setTimeout(fetchCart, 1200);
    }
  }
});

// Taps that landed before this file ran were held by the inline buffer in
// pdp-header.liquid (no full-page /cart detour). Handed over by a listener of
// its own, after the boot above, so a throwing init can't strand them.
document.addEventListener('DOMContentLoaded', mmDrainEarlyTaps);

/* Back/forward cache restores the page exactly as it was left, cart
   included — the shopper may have changed the cart elsewhere since. */
window.addEventListener('pageshow', function (e) {
  if (e.persisted) CartState.fetch();
});

/* ----------------------------------------------------------
   Server-rendered cart seed + early-tap handoff
   ---------------------------------------------------------- */
function mmCartSeed() {
  var el = document.getElementById('mm-cart-seed');
  if (!el) return null;
  try {
    var data = JSON.parse(el.textContent);
    if (!data || !Array.isArray(data.items)) return null;
    // Variant prices / compare-at for the seeded lines, so the savings
    // strikethrough needs no /products/{handle}.js fetch per line
    // (hydrateVariantComparePrices skips anything already cached).
    var meta = document.getElementById('mm-cart-seed-meta');
    var m = null;
    try { m = meta ? JSON.parse(meta.textContent) : null; } catch (e2) { m = null; } // lines just fetch as before
    if (m && m.v) {
      Object.keys(m.v).forEach(function (vid) {
        var price = m.v[vid][0], cap = m.v[vid][1];
        if (typeof price === 'number') variantPriceCache[vid] = price;
        variantComparePriceCache[vid] = (typeof cap === 'number' && cap > price) ? cap : null;
      });
    }
    return data;
  } catch (e) { return null; }
}

function mmDrainEarlyTaps() {
  window.__mmAtcReady = true;
  var q = window.__mmEarlyAtc || [];
  window.__mmEarlyAtc = [];
  // One add per form — a nervous double-tap before boot is still one add.
  var done = [];
  q.forEach(function (form) {
    if (!form) return;
    // An app re-render (Kaching) can swap the form node while the tap waits —
    // the add still belongs to the buybox, so it goes to the live form.
    if (!form.isConnected) form = document.querySelector('[data-mm-product-form]');
    if (!form || done.indexOf(form) > -1) return;
    done.push(form);
    handleAtcSubmit(form);
  });
  if (!done.length && window.__mmEarlyCart) openCart();
  window.__mmEarlyCart = 0;
}
